/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum WorkSourceEnum {
    Manually = 'Manually',
    RepTimesDb1 = 'RepTimesDb1',
    RepTimesDb2 = 'RepTimesDb2',
    RepTimesDb3 = 'RepTimesDb3',
    RepTimesDb4 = 'RepTimesDb4',
    RepTimesDb5 = 'RepTimesDb5',
    PriceList = 'PriceList'
}

export enum WorkReportSortColEnum {
    OrderNo = 'OrderNo',
    ActNo = 'ActNo',
    OrderDate = 'OrderDate',
    EstimateDate = 'EstimateDate',
    PaymentDueDate = 'PaymentDueDate',
    PaymentDate = 'PaymentDate'
}

export enum WarehouseAccountingMethodTypeEnum {
    Mixed = 'Mixed',
    NoWarehouse = 'NoWarehouse',
    Integrated = 'Integrated'
}

export enum VehicleTypeEnum {
    Car = 'Car',
    Other = 'Other',
    Truck = 'Truck',
    Motorcycle = 'Motorcycle',
    Unit = 'Unit',
    Bus = 'Bus'
}

export enum VatFilter {
    Any = 'Any',
    WithVat = 'WithVat',
    NoVat = 'NoVat'
}

/**
 * Возможные значения:
 * - `BadUser` — Пользователь не найден
 * - `UserIsLockedOut` — Аккаунт заблокирован
 * - `BadCredentials` — Неверный пароль
 * - `TenantIsMissing` — У пользователя нет тенанта
 * - `TenantIsBlocked` — Тенант заблокирован
 */
export enum UserSignInErrorCode {
    BadUser = 'BadUser',
    UserIsLockedOut = 'UserIsLockedOut',
    BadCredentials = 'BadCredentials',
    TenantIsMissing = 'TenantIsMissing',
    TenantIsBlocked = 'TenantIsBlocked'
}

/**
 * Возможные значения:
 * - `AccessDenied` — Only the creator or assignee can update the task.
 */
export enum UpdateTaskErrorCode {
    AccessDenied = 'AccessDenied'
}

/**
 * Возможные значения:
 * - `UnsupportedStatus` — The order status has no mapping to an event/preorder status.
 */
export enum UpdateOrderStatusErrorCode {
    UnsupportedStatus = 'UnsupportedStatus'
}

/**
 * Возможные значения:
 * - `BadOrderVersion` (HTTP 400) — The request does not contain a valid row version.
 * - `OrderVersionConflict` (HTTP 409) — The order was modified concurrently; reload it and retry.
 */
export enum UpdateOrderErrorCode {
    BadOrderVersion = 'BadOrderVersion',
    OrderVersionConflict = 'OrderVersionConflict'
}

/**
 * Возможные значения:
 * - `AccessDenied` — The current user can only update their own notes.
 */
export enum UpdateNoteErrorCode {
    AccessDenied = 'AccessDenied'
}

/**
 * Возможные значения:
 * - `DocumentMustBePublished` — The document is not published, so it cannot be unpublished; result contains documentId.
 * - `OnlyLastPublishedDocumentCanBeUnpublished` — Only the most recently published document can be unpublished; result contains documentId.
 */
export enum UnpublishRevaluationDocumentErrorCode {
    DocumentMustBePublished = 'DocumentMustBePublished',
    OnlyLastPublishedDocumentCanBeUnpublished = 'OnlyLastPublishedDocumentCanBeUnpublished'
}

/**
 * Возможные значения:
 * - `DocumentMustBePublished` — The document is not published, so it cannot be unpublished; result contains documentId.
 */
export enum UnpublishInventoryDocumentErrorCode {
    DocumentMustBePublished = 'DocumentMustBePublished'
}

/**
 * Возможные значения:
 * - `ProductsAreUsedElsewhere`
 */
export enum UnpublishIncomeDocumentPromptExceptionCode {
    ProductsAreUsedElsewhere = 'ProductsAreUsedElsewhere'
}

/**
 * Возможные значения:
 * - `DocumentMustBePublished` — The document is not published, so it cannot be unpublished; result contains documentId.
 */
export enum UnpublishIncomeDocumentErrorCode {
    DocumentMustBePublished = 'DocumentMustBePublished'
}

/**
 * Возможные значения:
 * - `UserIsNotLockedOut` — Аккаунт не заблокирован
 */
export enum UnblockUserErrorCode {
    UserIsNotLockedOut = 'UserIsNotLockedOut'
}

export enum UiLayoutPageTypeEnum {
    Orders = 'Orders',
    Acts = 'Acts',
    Payments = 'Payments',
    Clients = 'Clients',
    Cars = 'Cars',
    PreOrders = 'PreOrders',
    Employees = 'Employees',
    Warehouses = 'Warehouses',
    WhProducts = 'WhProducts',
    WhBalances = 'WhBalances',
    OrderAll = 'Order_All',
    OrderOpened = 'Order_Opened',
    OrderInWork = 'Order_InWork',
    OrderCompleted = 'Order_Completed',
    OrderPayed = 'Order_Payed',
    OrderCancelled = 'Order_Cancelled',
    OrderNumbered = 'Order_Numbered',
    OrderUnnumbered = 'Order_Unnumbered',
    OrderTraining = 'Order_Training',
    WhIncomeDocument = 'WhIncomeDocument',
    WhOutcomeDocument = 'WhOutcomeDocument',
    WhImport = 'WhImport'
}

export enum TransferDocumentViewType {
    Draft = 'Draft',
    Published = 'Published',
    All = 'All'
}

export enum TransferDocumentStatusEnum {
    Draft = 'Draft',
    Published = 'Published',
    Unpublished = 'Unpublished'
}

export enum TransactionDocumentType {
    Order = 'Order',
    Invoice = 'Invoice',
    Delivery = 'Delivery',
    BackFromBuyer = 'BackFromBuyer',
    BuyerOrder = 'BuyerOrder',
    BuyerInvoice = 'BuyerInvoice',
    BuyerSale = 'BuyerSale',
    OrderSale = 'OrderSale',
    Cancellation = 'Cancellation',
    BackToSupplier = 'BackToSupplier',
    Transfer = 'Transfer',
    QuantityAdjustment = 'QuantityAdjustment'
}

/**
 * Возможные значения:
 * - `BadTokenCredentials` — Неверный формат токена
 * - `BadToken` — Пользователь по токену не найден
 * - `UserIsLockedOut` — Аккаунт заблокирован
 * - `TenantIsMissing` — У пользователя нет тенанта
 * - `TenantIsBlocked` — Тенант заблокирован
 */
export enum TokenSignInExceptionCode {
    BadTokenCredentials = 'BadTokenCredentials',
    BadToken = 'BadToken',
    UserIsLockedOut = 'UserIsLockedOut',
    TenantIsMissing = 'TenantIsMissing',
    TenantIsBlocked = 'TenantIsBlocked'
}

/**
 * Возможные значения:
 * - `AccessDenied` — The current user can only pin/unpin their own notes.
 */
export enum TogglePinNoteErrorCode {
    AccessDenied = 'AccessDenied'
}

export enum TimeFormatEnum {
    Hours24 = 'Hours24',
    Hours12 = 'Hours12'
}

export enum TenantSubscriptionPlanResponse {
    Basic = 'Basic',
    Pro = 'Pro'
}

/** Tenant subscription plan. */
export enum TenantSubscriptionPlanEnum {
    Basic = 'Basic',
    Pro = 'Pro'
}

/** Tenant contract status. */
export enum TenantContractStatusEnum {
    None = 'None',
    Concluded = 'Concluded',
    Declined = 'Declined',
    NonConcludedDepreciated = 'NonConcludedDepreciated',
    Postponed = 'Postponed',
    InWork = 'InWork',
    AdvertisingDepreciated = 'AdvertisingDepreciated',
    CertifierDepreciated = 'CertifierDepreciated',
    Terminated = 'Terminated'
}

/** Represents the types of screens available in Telemost. */
export enum TelemostScreenTypeEnum {
    Board = 'Board',
    Promotion = 'Promotion',
    Team = 'Team'
}

/** Represents the available sort orders for board orders display. */
export enum TelemostBoardSortOrderEnum {
    CreatedDesc = 'CreatedDesc',
    CreatedAsc = 'CreatedAsc',
    PlannedTimeAsc = 'PlannedTimeAsc',
    PlannedTimeDesc = 'PlannedTimeDesc',
    Status = 'Status'
}

export enum TaskViewEnum {
    Open = 'Open',
    Sent = 'Sent',
    Closed = 'Closed',
    Deleted = 'Deleted',
    Copied = 'Copied',
    Stopped = 'Stopped',
    All = 'All'
}

/** Task status values. */
export enum TaskStatusEnum {
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

/** Represents the resource types that can be associated with a task. */
export enum TaskResourceTypeEnum {
    Employee = 'Employee',
    Supplier = 'Supplier',
    Car = 'Car',
    Client = 'Client',
    Preorder = 'Preorder',
    Order = 'Order',
    CalendarEvent = 'CalendarEvent'
}

export enum TagResourceTypeEnum {
    Cars = 'Cars',
    Clients = 'Clients',
    Orders = 'Orders'
}

/**
 * Возможные значения:
 * - `ResourceNotFound`
 * - `TagNotFound`
 * - `LinkNotFound`
 */
export enum TagErrorCode {
    ResourceNotFound = 'ResourceNotFound',
    TagNotFound = 'TagNotFound',
    LinkNotFound = 'LinkNotFound'
}

export enum SuppliersTypeEnum {
    None = 'None',
    Shate = 'Shate',
    Motex = 'Motex',
    Autospace = 'Autospace',
    LAuto = 'LAuto',
    Monlibon = 'Monlibon',
    KplusAuto = 'KplusAuto',
    Sviat = 'Sviat',
    Emex = 'Emex',
    ArmTek = 'ArmTek',
    IntercarsPl = 'IntercarsPl',
    AutopartnerPl = 'AutopartnerPl',
    HarpPl = 'HarpPl'
}

/**
 * Возможные значения:
 * - `UsedInDocuments` — Поставщик используется в документах (приход/расход/договоры) — удаление запрещено.
 */
export enum SupplierErrorCode {
    UsedInDocuments = 'UsedInDocuments'
}

/**
 * Возможные значения:
 * - `SubscriptionPlanNotFound` — No subscription plan is configured for the tenant's country and currency; result contains country and currency.
 */
export enum SubscriptionPlanNotFoundErrorCode {
    SubscriptionPlanNotFound = 'SubscriptionPlanNotFound'
}

export enum StockUsage {
    All = 'All',
    Filters = 'Filters',
    Reports = 'Reports',
    Transactions = 'Transactions'
}

export enum StationReportSortColEnum {
    OrderId = 'OrderId',
    OrderNo = 'OrderNo',
    ActNo = 'ActNo',
    OrderDate = 'OrderDate',
    EstimateDate = 'EstimateDate',
    PaymentDueDate = 'PaymentDueDate',
    PaymentDate = 'PaymentDate',
    WksNormTotal = 'WksNormTotal',
    WksCostNoVat = 'WksCostNoVat',
    WkcCostVat = 'WkcCostVat',
    WksCostTotalSum = 'WksCostTotalSum',
    WksDiscountAmountSum = 'WksDiscountAmountSum',
    WksProfitSum = 'WksProfitSum',
    SprCostNoVatSum = 'SprCostNoVatSum',
    SprCostVatSum = 'SprCostVatSum',
    SprCostTotalSum = 'SprCostTotalSum',
    SprProfitSum = 'SprProfitSum',
    CtrCostNoVatSum = 'CtrCostNoVatSum',
    CtrCostVatSum = 'CtrCostVatSum',
    CtrCostTotalSum = 'CtrCostTotalSum',
    CtrProfitSum = 'CtrProfitSum',
    TtlCostNoVatSum = 'TtlCostNoVatSum',
    TtlCostVatSum = 'TtlCostVatSum',
    TtlCostTotalSum = 'TtlCostTotalSum',
    TtlDiscountAmountSum = 'TtlDiscountAmountSum',
    TtlProfitSum = 'TtlProfitSum'
}

export enum SparesMenuEnum {
    StPartsFull = 'StPartsFull',
    StPartsShort = 'StPartsShort'
}

export enum SpareSupplier {
    None = 'None',
    ArmTekXls = 'ArmTekXls',
    AutospaceXls = 'AutospaceXls',
    AutospaceXls3 = 'AutospaceXls3',
    AutospaceXlsx = 'AutospaceXlsx',
    DiasXls = 'DiasXls',
    DiasXls2 = 'DiasXls2',
    DiasXls3 = 'DiasXls3',
    Emex = 'Emex',
    EuroFordXls = 'EuroFordXls',
    ForwardTxt = 'ForwardTxt',
    InterColorPlusXls = 'InterColorPlusXls',
    LAuto = 'LAuto',
    MannolXls = 'MannolXls',
    MonlibonXls = 'MonlibonXls',
    MonlibonXlsx = 'MonlibonXlsx',
    KplusAuto = 'KplusAuto',
    MotexCsv = 'MotexCsv',
    MotexXls = 'MotexXls',
    MotexXls2 = 'MotexXls2',
    MotexXlsx = 'MotexXlsx',
    NavitalXls = 'NavitalXls',
    ShateCsv = 'ShateCsv',
    ShateXls = 'ShateXls',
    ShateXls2 = 'ShateXls2',
    ShateXlsx = 'ShateXlsx',
    ShateXlsx2 = 'ShateXlsx2',
    ShateMagXls = 'ShateMagXls',
    SviatXls = 'SviatXls',
    SviatXls2 = 'SviatXls2',
    LautoXls = 'LautoXls',
    AutospaceXls2 = 'AutospaceXls2',
    ShateXls3 = 'ShateXls3',
    IntercarsCsv = 'IntercarsCsv',
    HartXml = 'HartXml',
    AutopartnerCsv = 'AutopartnerCsv',
    AutopartnerXml = 'AutopartnerXml',
    HipolXml = 'HipolXml',
    HipolCsv = 'HipolCsv',
    ProfiAutoCsv = 'ProfiAutoCsv',
    ProfiAutoXml = 'ProfiAutoXml',
    EmexXls = 'EmexXls',
    BonicsXlsx = 'BonicsXlsx',
    IntercarsCsv2 = 'IntercarsCsv2',
    MannolXls2 = 'MannolXls2',
    TaunMotorsXls = 'TaunMotorsXls',
    AvitoAutoXls = 'AvitoAutoXls',
    AvitoAutoXlsx = 'AvitoAutoXlsx',
    AutoPiterXls = 'AutoPiterXls',
    AutoPiterXls2 = 'AutoPiterXls2',
    GammaTestXls1 = 'GammaTestXls1',
    GruzEuroTehXlsx1 = 'GruzEuroTehXlsx1',
    PartsByXls1 = 'PartsByXls1',
    DoronZapchastXls1 = 'DoronZapchastXls1',
    RemStarterGroupXls1 = 'RemStarterGroupXls1',
    AgGaudiSlCsv = 'AgGaudiSlCsv',
    ShateXml = 'ShateXml',
    ArmTekXlsx = 'ArmTekXlsx',
    KolyadaXlsx = 'KolyadaXlsx',
    ParadAutoXls = 'ParadAutoXls',
    EmexXls2 = 'EmexXls2',
    ArmTekTxt = 'ArmTekTxt',
    ProfiCarLineXlsx = 'ProfiCarLineXlsx',
    ProfiCarLineXlsx2 = 'ProfiCarLineXlsx2',
    InterColorPlusXls2 = 'InterColorPlusXls2',
    TdSphereXls = 'TdSphereXls',
    EuroProjectTradingXlsx = 'EuroProjectTradingXlsx',
    AlmiTehXlsx = 'AlmiTehXlsx',
    AstartaAutoXlsx = 'AstartaAutoXlsx',
    BelStarterGroupXls1 = 'BelStarterGroupXls1',
    WurthBelXlsx = 'WurthBelXlsx',
    MotexXls3 = 'MotexXls3',
    ArmTekInvoiceTxt = 'ArmTekInvoiceTxt',
    ShateXlsm = 'ShateXlsm',
    BapeentXlsx = 'BapeentXlsx',
    MannolXls3 = 'MannolXls3',
    BlackBoxXlsx = 'BlackBoxXlsx',
    BelInvestZapchastXls = 'BelInvestZapchastXls',
    PartsByXls2 = 'PartsByXls2',
    VMtehnoGruz = 'VMtehnoGruz',
    DiasXls4 = 'DiasXls4',
    SplatServiceXlsx = 'SplatServiceXlsx',
    BelOilGroupXls = 'BelOilGroupXls',
    DoronZapchastXls2 = 'DoronZapchastXls2',
    ArmTekInvoiceTxt2 = 'ArmTekInvoiceTxt2',
    ForwardXlsx = 'ForwardXlsx',
    PasAutoCsv = 'PasAutoCsv',
    ForSageXls = 'ForSageXls',
    SplatService2Xlsx = 'SplatService2Xlsx',
    RemShinTorgXls = 'RemShinTorgXls',
    DnnGroupXls = 'DnnGroupXls',
    AmazisXls = 'AmazisXls',
    TruckBelXls = 'TruckBelXls',
    MonlibonXlsx2 = 'MonlibonXlsx2',
    ForwardXls = 'ForwardXls',
    CarDoneXlsx = 'CarDoneXlsx'
}

export enum SourceResourceTypeEnum {
    Client = 'Client',
    PreOrder = 'PreOrder'
}

export enum SmsTemplateTypeEnum {
    Client = 'Client',
    Event = 'Event',
    PreOrder = 'PreOrder',
    Order = 'Order',
    Custom = 'Custom'
}

export enum SmsTemplateNameEnum {
    Birthday = 'Birthday',
    EventRequest = 'EventRequest',
    EventReminder = 'EventReminder',
    PreOrderRequest = 'PreOrderRequest',
    PreOrderConfirmed = 'PreOrderConfirmed',
    OrderComplete = 'OrderComplete',
    OrderFeedBack = 'OrderFeedBack',
    Custom = 'Custom',
    PaymentReminder = 'PaymentReminder',
    ComeBackReminder = 'ComeBackReminder'
}

export enum SmsTemplateModeEnum {
    Disabled = 'Disabled',
    Interactive = 'Interactive',
    Automatic = 'Automatic'
}

export enum SmsProviderEnum {
    Beltelecom = 'Beltelecom',
    Mts = 'Mts',
    Twilio = 'Twilio',
    A1 = 'A1'
}

export enum SmsDeliveryStatusResponse {
    Pending = 'Pending',
    Delivered = 'Delivered',
    Undelivered = 'Undelivered',
    Unknown = 'Unknown'
}

export enum SmsCampaignType {
    Single = 'Single',
    Broadcast = 'Broadcast'
}

export enum SmsCampaignStatusResponse {
    Draft = 'Draft',
    ReadyToSend = 'ReadyToSend',
    Sending = 'Sending',
    Sent = 'Sent',
    Failed = 'Failed',
    Postponed = 'Postponed'
}

export enum SmsCampaignStatus {
    Draft = 'Draft',
    ReadyToSend = 'ReadyToSend',
    Sending = 'Sending',
    Sent = 'Sent',
    Failed = 'Failed',
    Postponed = 'Postponed'
}

/**
 * Возможные значения:
 * - `BadTokenCredentials` — Неверный app token
 */
export enum SignOutErrorCode {
    BadTokenCredentials = 'BadTokenCredentials'
}

export enum ScheduleType {
    OneByOne = 'OneByOne',
    OneByTwo = 'OneByTwo',
    TwoByTwo = 'TwoByTwo',
    TwoByTwoByThree = 'TwoByTwoByThree',
    FourByTwo = 'FourByTwo',
    FiveByTwo = 'FiveByTwo'
}

/**
 * Возможные значения:
 * - `StorageLocationAlreadyExists` — A storage location with the same code already exists on the stock; result contains stockId and code.
 */
export enum SaveStorageLocationErrorCode {
    StorageLocationAlreadyExists = 'StorageLocationAlreadyExists'
}

/**
 * Возможные значения:
 * - `ProductsMustNotBeEmpty` — The document must contain at least one product.
 * - `ProductsHasDuplicates` — The document has duplicate products by productId or internalCode.
 * - `DuplicateDocument` — Another document with the same document number already exists; result contains documentNo.
 */
export enum SaveRevaluationDocumentErrorCode {
    ProductsMustNotBeEmpty = 'ProductsMustNotBeEmpty',
    ProductsHasDuplicates = 'ProductsHasDuplicates',
    DuplicateDocument = 'DuplicateDocument'
}

/**
 * Возможные значения:
 * - `BadStock` — The referenced stock was not found; result contains stockId.
 * - `BadBuyer` — A buyer reference is required for this document type but was not provided.
 * - `BadBuyerContract` — The buyer's contract was not found; result contains contractId.
 * - `BadSupplier` — The referenced supplier was not found; result contains supplierId.
 * - `BadSupplierContract` — The supplier's contract was not found; result contains contractId.
 * - `DuplicateDocumentNo` — Настройка «Уникальность номера документа» включена, а документ того же типа с таким номером уже есть; result содержит documentNo, documentType и id найденного документа.
 */
export enum SaveOutcomeDocumentErrorCode {
    BadStock = 'BadStock',
    BadBuyer = 'BadBuyer',
    BadBuyerContract = 'BadBuyerContract',
    BadSupplier = 'BadSupplier',
    BadSupplierContract = 'BadSupplierContract',
    DuplicateDocumentNo = 'DuplicateDocumentNo'
}

/**
 * Возможные значения:
 * - `ProductsMustNotBeEmpty` — The document must contain at least one product.
 * - `ProductsHasDuplicates` — The document has duplicate products by internalCode.
 * - `DuplicateDocument` — Another document with the same document number already exists; result contains documentNo.
 * - `BadStock` — The referenced stock was not found; result contains stockId.
 * - `DuplicateProduct` — A product with the same internalCode is already present in the document; result contains internalCode.
 * - `MissingProduct` — A product to update or delete was not found in the document; result contains internalCode.
 */
export enum SaveInventoryDocumentErrorCode {
    ProductsMustNotBeEmpty = 'ProductsMustNotBeEmpty',
    ProductsHasDuplicates = 'ProductsHasDuplicates',
    DuplicateDocument = 'DuplicateDocument',
    BadStock = 'BadStock',
    DuplicateProduct = 'DuplicateProduct',
    MissingProduct = 'MissingProduct'
}

/**
 * Возможные значения:
 * - `BadStock` — The referenced stock was not found; result contains stockId.
 * - `BadBuyer` — A buyer reference is required for this document type but was not provided.
 * - `BadBuyerContract` — The buyer's contract was not found; result contains contractId.
 * - `BadSupplier` — The referenced supplier was not found; result contains supplierId.
 * - `BadSupplierContract` — The supplier's contract was not found; result contains contractId.
 * - `DuplicateDocumentNo` — Настройка «Уникальность номера документа» включена, а документ того же типа с таким номером уже есть; result содержит documentNo, documentType и id найденного документа.
 */
export enum SaveIncomeDocumentErrorCode {
    BadStock = 'BadStock',
    BadBuyer = 'BadBuyer',
    BadBuyerContract = 'BadBuyerContract',
    BadSupplier = 'BadSupplier',
    BadSupplierContract = 'BadSupplierContract',
    DuplicateDocumentNo = 'DuplicateDocumentNo'
}

/**
 * Возможные значения:
 * - `CashboxTitleNotUnique` — Another cashbox with the same title already exists; result contains the title.
 */
export enum SaveCashboxErrorCode {
    CashboxTitleNotUnique = 'CashboxTitleNotUnique'
}

/**
 * Возможные значения:
 * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
 */
export enum RevaluationDocumentReadonlyErrorCode {
    PublishedDocumentIsReadonly = 'PublishedDocumentIsReadonly'
}

/**
 * Возможные значения:
 * - `SomeProductsAreMissingInCatalog` — Some of the document's products no longer exist in the catalog; result contains documentId.
 * - `BadInternalCode` — The document references an internal code that no longer exists on the catalog product; result contains productId and internalCode.
 */
export enum RevaluationCatalogSyncErrorCode {
    SomeProductsAreMissingInCatalog = 'SomeProductsAreMissingInCatalog',
    BadInternalCode = 'BadInternalCode'
}

/**
 * Возможные значения:
 * - `ResourceTypeNotSupported` — Тип ресурса корзины не поддерживается — нет зарегистрированного обработчика.
 * - `SourceObjectNotFound` — Исходный объект не найден и не может быть восстановлен.
 * - `SourceObjectAlreadyRestored` — Исходный объект уже восстановлен (soft-delete снят) и не подлежит повторному восстановлению.
 * - `ParentNotRestored` — Родительский агрегат отсутствует или помечен удалённым — сначала восстановите родителя.
 */
export enum RestoreRecycleBinItemExceptionCode {
    ResourceTypeNotSupported = 'ResourceTypeNotSupported',
    SourceObjectNotFound = 'SourceObjectNotFound',
    SourceObjectAlreadyRestored = 'SourceObjectAlreadyRestored',
    ParentNotRestored = 'ParentNotRestored'
}

/**
 * Возможные значения:
 * - `UserIsLockedOut` — Аккаунт заблокирован
 */
export enum ResetPasswordErrorCode {
    UserIsLockedOut = 'UserIsLockedOut'
}

/**
 * Возможные значения:
 * - `BadResetCode` — Неверный или просроченный код сброса
 */
export enum ResetPasswordConfirmErrorCode {
    BadResetCode = 'BadResetCode'
}

export enum ReportingDateEnum {
    OrderDate = 'OrderDate',
    CompletionDate = 'CompletionDate',
    PaymentDate = 'PaymentDate',
    PaymentDueDate = 'PaymentDueDate'
}

export enum ReportExportFormatEnum {
    Xml = 'Xml',
    Excel = 'Excel',
    Json = 'Json',
    Csv = 'Csv',
    CsvGoogle = 'CsvGoogle',
    Internal = 'Internal'
}

export enum RepTimesDbEnum {
    Unknown = 'Unknown',
    RepTimesDb1 = 'RepTimesDb1',
    RepTimesDb2 = 'RepTimesDb2',
    RepTimesDb3 = 'RepTimesDb3',
    RepTimesDb4 = 'RepTimesDb4',
    RepTimesDb5 = 'RepTimesDb5',
    TechDataDb2 = 'TechDataDb2',
    TechDataDb5 = 'TechDataDb5',
    TechDataDb4 = 'TechDataDb4',
    TechDataDb3 = 'TechDataDb3'
}

/**
 * Возможные значения:
 * - `ForceReleaseDenied` (HTTP 403) — Force-releasing a lock requires the Orders.LockReset permission.
 * - `LockedByAnotherUser` (HTTP 409) — The lock belongs to another user; retry with force=true to override.
 */
export enum ReleaseOrderErrorCode {
    ForceReleaseDenied = 'ForceReleaseDenied',
    LockedByAnotherUser = 'LockedByAnotherUser'
}

/**
 * Возможные значения:
 * - `ContactEmailIsDuplicate` — A user with the given contact email is already registered.
 */
export enum RegisterTenantErrorCode {
    ContactEmailIsDuplicate = 'ContactEmailIsDuplicate'
}

export enum RecycleBinResourceTypeEnum {
    Order = 'Order',
    Client = 'Client',
    Car = 'Car'
}

/**
 * Возможные значения:
 * - `ResourceTypeNotSupported` — Тип ресурса корзины не поддерживается — нет зарегистрированного обработчика.
 * - `DependentAlive` — На ресурс всё ещё ссылается активная (в базе или в корзине) зависимая запись — сначала окончательно удалите её.
 */
export enum PurgeRecycleBinItemExceptionCode {
    ResourceTypeNotSupported = 'ResourceTypeNotSupported',
    DependentAlive = 'DependentAlive'
}

/**
 * Возможные значения:
 * - `DocumentAlreadyPublished` — The document is already published; result contains documentId.
 */
export enum PublishRevaluationDocumentErrorCode {
    DocumentAlreadyPublished = 'DocumentAlreadyPublished'
}

/**
 * Возможные значения:
 * - `DocumentAlreadyPublished` — The document is already published; result contains documentId.
 */
export enum PublishInventoryDocumentErrorCode {
    DocumentAlreadyPublished = 'DocumentAlreadyPublished'
}

/**
 * Возможные значения:
 * - `DocumentAlreadyPublished` — The document is already published; result contains documentId.
 * - `DocumentHasEmptyProducts` — The document has no products; result contains documentId.
 * - `DocumentHasProductsWithZeroCount` — The document contains products with zero count; result contains documentId.
 */
export enum PublishIncomeDocumentErrorCode {
    DocumentAlreadyPublished = 'DocumentAlreadyPublished',
    DocumentHasEmptyProducts = 'DocumentHasEmptyProducts',
    DocumentHasProductsWithZeroCount = 'DocumentHasProductsWithZeroCount'
}

export enum PrintUserOptionEnum {
    FillCarDetails = 'FillCarDetails',
    FillNames = 'FillNames',
    FitHeight = 'FitHeight',
    HeaderText = 'HeaderText',
    HeaderNumering = 'HeaderNumering',
    SetPaymentForm = 'SetPaymentForm',
    PrintPdf = 'PrintPdf',
    PrintWord = 'PrintWord',
    Email = 'Email',
    SetPaymentType = 'SetPaymentType',
    PrintLandscape = 'PrintLandscape',
    FillStamp = 'FillStamp',
    FillCatalogNumber = 'FillCatalogNumber',
    FillImages = 'FillImages'
}

export enum PrintTemplateEnum {
    SmsInvoice = 'SmsInvoice',
    SmsAct = 'SmsAct',
    SmsCampaignReport = 'SmsCampaignReport',
    ServiceHistoryVehicle = 'ServiceHistoryVehicle',
    ServiceHistoryClient = 'ServiceHistoryClient',
    StationInvoice = 'StationInvoice',
    StationInvoiceAct = 'StationInvoiceAct',
    OrderRequest = 'OrderRequest',
    Order = 'Order',
    OrderAcceptanceAct = 'OrderAcceptanceAct',
    OrderComplitionAct = 'OrderComplitionAct',
    OrderReport = 'OrderReport',
    OrderInvoice = 'OrderInvoice',
    OrderDesignation = 'OrderDesignation',
    OrderDiagMap = 'OrderDiagMap',
    OrderContract = 'OrderContract',
    PreOrder = 'PreOrder',
    Contract = 'Contract',
    Calculation = 'Calculation',
    SystemContract = 'SystemContract',
    Generic = 'Generic',
    WhIncomeOrder = 'WhIncomeOrder',
    WhIncomeInvoice = 'WhIncomeInvoice',
    WhIncomeDelivery = 'WhIncomeDelivery',
    WhIncomeBackFromBuyer = 'WhIncomeBackFromBuyer',
    WhOutcomeBuyerOrder = 'WhOutcomeBuyerOrder',
    WhOutcomeBuyerInvoice = 'WhOutcomeBuyerInvoice',
    WhOutcomeBuyerSale = 'WhOutcomeBuyerSale',
    WhOutcomeOrderSale = 'WhOutcomeOrderSale',
    WhOutcomeCancellation = 'WhOutcomeCancellation',
    WhOutcomeBackToSupplier = 'WhOutcomeBackToSupplier',
    WhTransfer = 'WhTransfer',
    WhInventory = 'WhInventory'
}

export enum PrintFileTypeEnum {
    None = 'None',
    Pdf = 'Pdf',
    Word = 'Word',
    Html = 'Html'
}

export enum PreOrderStatusEnum {
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

export enum PreOrderListViewEnum {
    All = 'All',
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled'
}

export enum PaymentViewEnum {
    All = 'All',
    Income = 'Income',
    Outcome = 'Outcome'
}

export enum PaymentTypeEnum {
    Sale = 'Sale',
    Return = 'Return',
    Deposit = 'Deposit',
    Withdraw = 'Withdraw',
    Cancel = 'Cancel',
    Transfer = 'Transfer',
    CashWithdraw = 'CashWithdraw'
}

/**
 * Возможные значения:
 * - `CashboxNotFound` — The cashbox referenced by the payment was not found; result contains cashboxId.
 * - `CashboxArchived` — The cashbox is archived and closed for operations; result contains cashboxId.
 * - `NotEnoughMoney` — The cashbox balance is not sufficient for the outcome operation.
 */
export enum PaymentOperationErrorCode {
    CashboxNotFound = 'CashboxNotFound',
    CashboxArchived = 'CashboxArchived',
    NotEnoughMoney = 'NotEnoughMoney'
}

export enum PaymentMethodEnum {
    Cash = 'Cash',
    Card = 'Card',
    CreditCard = 'CreditCard',
    DirectTransfer = 'DirectTransfer',
    QrCode = 'QrCode',
    Certificate = 'Certificate',
    EPayment = 'EPayment'
}

/**
 * Возможные значения:
 * - `DocumentReferenceInvalid` — The document reference id has an invalid format; result contains documentId and documentType.
 * - `OrderNotFound` — The order referenced by the payment was not found; result contains orderId.
 * - `ClientNotFound` — The client of the referenced order was not found; result contains clientId.
 * - `WhIncomeDocumentNotFound` — The referenced warehouse income document was not found; result contains documentId.
 * - `WhOutcomeDocumentNotFound` — The referenced warehouse outcome document was not found; result contains documentId.
 */
export enum PaymentDocumentErrorCode {
    DocumentReferenceInvalid = 'DocumentReferenceInvalid',
    OrderNotFound = 'OrderNotFound',
    ClientNotFound = 'ClientNotFound',
    WhIncomeDocumentNotFound = 'WhIncomeDocumentNotFound',
    WhOutcomeDocumentNotFound = 'WhOutcomeDocumentNotFound'
}

export enum PaymentClientTypeEnum {
    Client = 'Client',
    Supplier = 'Supplier',
    Contractor = 'Contractor'
}

/**
 * Возможные значения:
 * - `DocumentMustBePublished` — Only a published document can be unpublished.
 */
export enum OutcomeDocumentUnpublishErrorCode {
    DocumentMustBePublished = 'DocumentMustBePublished'
}

export enum OutcomeDocumentTypeEnum {
    BuyerOrder = 'BuyerOrder',
    BuyerInvoice = 'BuyerInvoice',
    BuyerSale = 'BuyerSale',
    OrderSale = 'OrderSale',
    Cancellation = 'Cancellation',
    BackToSupplier = 'BackToSupplier'
}

export enum OutcomeDocumentStatusEnum {
    Draft = 'Draft',
    Published = 'Published',
    Unpublished = 'Unpublished'
}

/**
 * Возможные значения:
 * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
 */
export enum OutcomeDocumentReadonlyErrorCode {
    PublishedDocumentIsReadonly = 'PublishedDocumentIsReadonly'
}

/**
 * Возможные значения:
 * - `DocumentAlreadyPublished` — The document is already published.
 * - `DocumentHasEmptyProducts` — The document has no products.
 * - `DocumentHasProductsWithZeroCount` — The document contains products with zero count.
 * - `BadStockBalance` — Хендлер бросает доменный ; в этот код его переводит Web-слой, передавая payload уже в платформенных response-моделях.
 */
export enum OutcomeDocumentPublishErrorCode {
    DocumentAlreadyPublished = 'DocumentAlreadyPublished',
    DocumentHasEmptyProducts = 'DocumentHasEmptyProducts',
    DocumentHasProductsWithZeroCount = 'DocumentHasProductsWithZeroCount',
    BadStockBalance = 'BadStockBalance'
}

export enum OutcomeDocumentListViewEnum {
    Draft = 'Draft',
    Published = 'Published',
    All = 'All'
}

export enum OrderWorkStatusEnum {
    NotStarted = 'NotStarted',
    InProgress = 'InProgress',
    Done = 'Done',
    Blocked = 'Blocked',
    Canceled = 'Canceled'
}

/**
 * Возможные значения:
 * - `BadStockRef` — The order references warehouse stocks that do not exist.
 * - `BadStockReserves` — Not enough free stock to reserve the order products; result contains only the lacking products grouped by stock.
 * - `BadStockBalance` — Not enough stock balance to ship the order products; result contains only the lacking products grouped by stock.
 */
export enum OrderStockCheckErrorCode {
    BadStockRef = 'BadStockRef',
    BadStockReserves = 'BadStockReserves',
    BadStockBalance = 'BadStockBalance'
}

export enum OrderStatusEnum {
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Paid = 'Paid',
    Cancelled = 'Cancelled'
}

export enum OrderStatus {
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Paid = 'Paid',
    Cancelled = 'Cancelled'
}

export enum OrderStationSparesStatusEnum {
    NotProcessed = 'NotProcessed',
    PendingApproval = 'PendingApproval',
    Approved = 'Approved',
    Paid = 'Paid',
    InTransit = 'InTransit',
    Delivered = 'Delivered',
    Installed = 'Installed'
}

export enum OrderNumberingTypeEnum {
    DateTime = 'DateTime',
    Continuous = 'Continuous'
}

/**
 * Возможные значения:
 * - `OrderNumberExists` — The order number is already in use.
 * - `ActNumberExists` — The act number is already in use.
 * - `InvalidNumberFormat` — The number does not match the configured numbering format.
 * - `InvalidNumberingType` — The configured numbering type is not supported.
 */
export enum OrderNumberingErrorCode {
    OrderNumberExists = 'OrderNumberExists',
    ActNumberExists = 'ActNumberExists',
    InvalidNumberFormat = 'InvalidNumberFormat',
    InvalidNumberingType = 'InvalidNumberingType'
}

export enum OrderLockTypeEnum {
    Off = 'Off',
    Warning = 'Warning',
    Manual = 'Manual',
    Auto = 'Auto'
}

export enum OrderLockResetEnum {
    Off = 'Off',
    Hours = 'Hours'
}

/**
 * Возможные значения:
 * - `Empty` — The uploaded file has zero length.
 * - `TooLarge` — The uploaded file exceeds the maximum allowed size.
 * - `InvalidType` — The uploaded file has an unsupported content type.
 */
export enum OrderFileErrorCode {
    Empty = 'Empty',
    TooLarge = 'TooLarge',
    InvalidType = 'InvalidType'
}

export enum OrderClientType {
    Owner = 'Owner',
    Payer = 'Payer',
    Client = 'Client'
}

export enum OrderClientSpareConditionEnum {
    New = 'New',
    Used = 'Used',
    Restored = 'Restored'
}

/**
 * Возможные значения:
 * - `OrderReopeningNotAllowed` — RestrictOrderReopening: попытка понизить статус закрытого заказа. result содержит orderId и targetStatus.
 * - `DocumentReissueNotAllowed` — RestrictOrderReopening: попытка переоформить закрытый документ — сменить номер заказа или акта либо признак учебного заказа. result содержит orderId.
 * - `ClosedOrderMutationNotAllowed` — RestrictClosedOrders: заказ оплачен и изменению не подлежит. result содержит orderId.
 * - `FinalizedOrderMutationNotAllowed` — RestrictOrderReopening: заказ в финальном статусе, содержимое менять нельзя. Проверяется только в MobileApi. result содержит orderId и status.
 * - `NotOwnOrderMutationNotAllowed` — RestrictOthersOrders: сотрудник не указан ответственным по этому заказу. result содержит orderId.
 * - `OthersOrderResponsibleChangeNotAllowed` — RestrictOthersOrderResponsible: менять ответственного в чужом заказе нельзя. result содержит orderId.
 * - `StatusTransitionNotAllowed` — ForbiddenTargetStatuses: перевод в этот статус сотруднику запрещён. result содержит targetStatus и, если заказ уже существует, orderId.
 */
export enum OrderBusinessRuleErrorCode {
    OrderReopeningNotAllowed = 'OrderReopeningNotAllowed',
    DocumentReissueNotAllowed = 'DocumentReissueNotAllowed',
    ClosedOrderMutationNotAllowed = 'ClosedOrderMutationNotAllowed',
    FinalizedOrderMutationNotAllowed = 'FinalizedOrderMutationNotAllowed',
    NotOwnOrderMutationNotAllowed = 'NotOwnOrderMutationNotAllowed',
    OthersOrderResponsibleChangeNotAllowed = 'OthersOrderResponsibleChangeNotAllowed',
    StatusTransitionNotAllowed = 'StatusTransitionNotAllowed'
}

/** Represents the resource types that can be associated with a note in the system. */
export enum NoteResourceTypeEnum {
    Employee = 'Employee',
    Supplier = 'Supplier',
    Car = 'Car',
    Client = 'Client',
    Preorder = 'Preorder',
    Order = 'Order',
    CalendarEvent = 'CalendarEvent',
    WarehouseStock = 'WarehouseStock',
    WarehouseStockProduct = 'WarehouseStockProduct',
    WarehouseCatalogProduct = 'WarehouseCatalogProduct',
    WarehouseIncomeDocument = 'WarehouseIncomeDocument',
    WarehouseOutcomeDocument = 'WarehouseOutcomeDocument'
}

/**
 * Возможные значения:
 * - `InvalidTin` — Идентификатор (УНП для Беларуси / NIP для Польши) не соответствует формату выбранной страны.
 * - `CountryNotSupported` — Поиск по реестру не поддерживается для выбранной страны (доступны только Беларусь и Польша).
 */
export enum NipErrorCode {
    InvalidTin = 'InvalidTin',
    CountryNotSupported = 'CountryNotSupported'
}

/**
 * Возможные значения:
 * - `UserNotFound` (HTTP 403) — Employee record for the current user was not found.
 * - `AlreadyLocked` (HTTP 409) — The order is locked by another user; result contains the current lock state.
 */
export enum LockOrderErrorCode {
    UserNotFound = 'UserNotFound',
    AlreadyLocked = 'AlreadyLocked'
}

export enum ListViewEnum {
    All = 'All',
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    Paid = 'Paid',
    Active = 'Active',
    Training = 'Training',
    OrdersAll = 'Orders_all',
    OrdersNumbered = 'Orders_numbered',
    OrdersUnassigned = 'Orders_unassigned',
    ActsAll = 'Acts_all',
    ActsUnassigned = 'Acts_unassigned',
    ActsPeriod = 'Acts_period',
    ActsNumbered = 'Acts_numbered'
}

export enum LanguageEnum {
    En = 'en',
    Ru = 'ru',
    Pl = 'pl',
    Es = 'es',
    Uk = 'uk',
    De = 'de',
    Fr = 'fr',
    Cn = 'cn'
}

/** Invoice status enumeration */
export enum InvoiceStatusEnum {
    Open = 'Open',
    Paid = 'Paid',
    PartiallyPaid = 'PartiallyPaid',
    Canceled = 'Canceled',
    Rejected = 'Rejected'
}

/**
 * Возможные значения:
 * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
 */
export enum InventoryDocumentReadonlyErrorCode {
    PublishedDocumentIsReadonly = 'PublishedDocumentIsReadonly'
}

export enum IncomeDocumentTypeEnum {
    Order = 'Order',
    Invoice = 'Invoice',
    Delivery = 'Delivery',
    BackFromBuyer = 'BackFromBuyer'
}

export enum IncomeDocumentStatusEnum {
    Draft = 'Draft',
    Published = 'Published',
    Unpublished = 'Unpublished'
}

/**
 * Возможные значения:
 * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
 */
export enum IncomeDocumentReadonlyErrorCode {
    PublishedDocumentIsReadonly = 'PublishedDocumentIsReadonly'
}

export enum IncomeDocumentListViewEnum {
    Draft = 'Draft',
    Published = 'Published',
    All = 'All'
}

/**
 * Возможные значения:
 * - `FileEmpty` — Файл не передан или пуст.
 * - `FileInvalid` — Содержимое файла не удалось расшифровать/распознать.
 */
export enum ImportTestErrorCode {
    FileEmpty = 'FileEmpty',
    FileInvalid = 'FileInvalid'
}

export enum FuelTypeEnum {
    Petrol = 'Petrol',
    Diesel = 'Diesel',
    Gas = 'Gas',
    Hybrid = 'Hybrid',
    Bio = 'Bio',
    Electro = 'Electro',
    PetrolEtanol = 'PetrolEtanol',
    PetrolGas = 'PetrolGas',
    NoInfo = 'NoInfo'
}

/** Export implementation version. */
export enum ExportVersionEnum {
    V1 = 'V1',
    V2 = 'V2'
}

/** Export file output format. */
export enum ExportFileFormatEnum {
    Xml = 'Xml',
    Excel = 'Excel',
    Json = 'Json',
    Csv = 'Csv',
    CsvGoogle = 'CsvGoogle',
    Internal = 'Internal'
}

/**
 * Возможные значения:
 * - `VersionNotSupported` — Запрошенная версия экспорта не поддерживается этим эндпоинтом.
 */
export enum ExportErrorCode {
    VersionNotSupported = 'VersionNotSupported'
}

export enum EventTypeEnum {
    Detailed = 'Detailed',
    Summary = 'Summary'
}

export enum EventStatusEnum {
    Open = 'Open',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Paid = 'Paid',
    Cancelled = 'Cancelled'
}

/**
 * Возможные значения:
 * - `LinkAlreadyExists` — A link between this preorder and order already exists; result contains preOrderId and orderId.
 */
export enum EstablishConnectionErrorCode {
    LinkAlreadyExists = 'LinkAlreadyExists'
}

export enum EmployeeRateTypeEnum {
    Percentage = 'Percentage',
    Fixed = 'Fixed'
}

export enum EmployeePermissions {
    Empty = 'Empty',
    ManagePermissions = 'ManagePermissions',
    ManagePayments = 'ManagePayments',
    ManageProfile = 'ManageProfile',
    ManageSettings = 'ManageSettings',
    ManageEmployees = 'ManageEmployees',
    ManageAuto = 'ManageAuto',
    ManageAutoLimited = 'ManageAutoLimited',
    ManageClients = 'ManageClients',
    ManageClientsLimited = 'ManageClientsLimited',
    ManageOrders = 'ManageOrders',
    ManageOrdersLimited = 'ManageOrdersLimited',
    ExportClients = 'ExportClients',
    ExportAuto = 'ExportAuto',
    ExportOrders = 'ExportOrders',
    ViewOperationalReport = 'ViewOperationalReport',
    ViewAnalyticalReport = 'ViewAnalyticalReport',
    ManageStationAreas = 'ManageStationAreas',
    ManagePreOrders = 'ManagePreOrders',
    ManageStationCalendar = 'ManageStationCalendar',
    OrderLockReset = 'OrderLockReset',
    Full = 'Full'
}

/**
 * Возможные значения:
 * - `AlreadyArchived` — The employee is already archived.
 * - `SelfArchiveNotAllowed` — Users cannot archive their own employee record.
 * - `NotArchived` — The employee is not archived.
 * - `PermissionsRequireActiveAccount` — Permissions can be read or assigned only for an employee with an active account.
 */
export enum EmployeeErrorCode {
    AlreadyArchived = 'AlreadyArchived',
    SelfArchiveNotAllowed = 'SelfArchiveNotAllowed',
    NotArchived = 'NotArchived',
    PermissionsRequireActiveAccount = 'PermissionsRequireActiveAccount'
}

export enum EmployeeCalcTypeEnum {
    Auto = 'Auto',
    Manual = 'Manual'
}

/**
 * Возможные значения:
 * - `AccountAlreadyActivated` — The employee account is already activated (createAccount, joinAccount, activate).
 * - `EmployeeAlreadyHasLogin` — The employee already has a login bound to them (createAccount, joinAccount).
 * - `AccountAlreadyExists` — An account with the given login is already used by another employee of the station (createAccount, joinAccount, activate).
 * - `BadAccountCredentials` — Login or password do not match an existing account (joinAccount).
 * - `AccountCreateFailed` — The account could not be created; result contains the identity status (createAccount).
 * - `ActivationRequiresAccessGranted` — The account must be granted access before it can be activated (activate).
 * - `DeactivationRequiresAccessGranted` — The account has no granted access, so there is nothing to deactivate (deactivate).
 * - `SelfDeactivateNotAllowed` — An employee cannot deactivate their own account (deactivate).
 */
export enum EmployeeAccountErrorCode {
    AccountAlreadyActivated = 'AccountAlreadyActivated',
    EmployeeAlreadyHasLogin = 'EmployeeAlreadyHasLogin',
    AccountAlreadyExists = 'AccountAlreadyExists',
    BadAccountCredentials = 'BadAccountCredentials',
    AccountCreateFailed = 'AccountCreateFailed',
    ActivationRequiresAccessGranted = 'ActivationRequiresAccessGranted',
    DeactivationRequiresAccessGranted = 'DeactivationRequiresAccessGranted',
    SelfDeactivateNotAllowed = 'SelfDeactivateNotAllowed'
}

export enum DocumentTypeEnum {
    Order = 'Order',
    Preorder = 'Preorder',
    WhIncomeOrder = 'WhIncomeOrder',
    WhIncomeInvoice = 'WhIncomeInvoice',
    WhIncomeDelivery = 'WhIncomeDelivery',
    WhIncomeBackFromBuyer = 'WhIncomeBackFromBuyer',
    WhOutcomeBuyerOrder = 'WhOutcomeBuyerOrder',
    WhOutcomeBuyerInvoice = 'WhOutcomeBuyerInvoice',
    WhOutcomeBuyerSale = 'WhOutcomeBuyerSale',
    WhOutcomeOrderSale = 'WhOutcomeOrderSale',
    WhOutcomeBackToSupplier = 'WhOutcomeBackToSupplier'
}

export enum DocumentSetConflictResolutionEnum {
    None = 'None',
    MoveDocument = 'MoveDocument',
    MergeDocumentSet = 'MergeDocumentSet'
}

export enum DocumentKindEnum {
    Numbered = 'Numbered',
    Unnumbered = 'Unnumbered',
    Training = 'Training'
}

export enum DiscountFilter {
    Any = 'Any',
    Positive = 'Positive',
    Negative = 'Negative'
}

/**
 * Возможные значения:
 * - `AccessDenied` — Only the creator or assignee can delete the task.
 */
export enum DeleteTaskErrorCode {
    AccessDenied = 'AccessDenied'
}

/**
 * Возможные значения:
 * - `StorageLocationInUse` — The storage location is referenced by stock products and cannot be deleted; result contains storageLocationId.
 */
export enum DeleteStorageLocationErrorCode {
    StorageLocationInUse = 'StorageLocationInUse'
}

/**
 * Возможные значения:
 * - `ProductHasTransactions`
 */
export enum DeleteProductPromptExceptionCode {
    ProductHasTransactions = 'ProductHasTransactions'
}

/**
 * Возможные значения:
 * - `TenantMismatch` — The file belongs to a different tenant than the current one.
 */
export enum DeleteOrderFileErrorCode {
    TenantMismatch = 'TenantMismatch'
}

/**
 * Возможные значения:
 * - `AccessDenied` — The current user can only delete their own notes.
 */
export enum DeleteNoteErrorCode {
    AccessDenied = 'AccessDenied'
}

/**
 * Возможные значения:
 * - `CashboxAlreadyArchived` — The cashbox is already archived; result contains cashboxId.
 */
export enum DeleteCashboxErrorCode {
    CashboxAlreadyArchived = 'CashboxAlreadyArchived'
}

export enum DateFormatEnum {
    DdMMyyyy = 'ddMMyyyy',
    MMddyy = 'MMddyy',
    YyyyMMdd = 'yyyyMMdd'
}

export enum CurrencyCodeEnum {
    BYR = 'BYR',
    BYN = 'BYN',
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    ALL = 'ALL',
    AMD = 'AMD',
    AZN = 'AZN',
    BGN = 'BGN',
    BHD = 'BHD',
    CAD = 'CAD',
    CHF = 'CHF',
    CNY = 'CNY',
    CZK = 'CZK',
    EGP = 'EGP',
    GEL = 'GEL',
    HUF = 'HUF',
    ILS = 'ILS',
    ISK = 'ISK',
    JOD = 'JOD',
    KGS = 'KGS',
    KRW = 'KRW',
    KZT = 'KZT',
    MDL = 'MDL',
    NOK = 'NOK',
    NZD = 'NZD',
    PLN = 'PLN',
    RON = 'RON',
    RSD = 'RSD',
    RUB = 'RUB',
    SAR = 'SAR',
    SEK = 'SEK',
    TRY = 'TRY',
    UAH = 'UAH',
    AED = 'AED',
    DKK = 'DKK',
    HRK = 'HRK'
}

export enum CountryEnum {
    None = 'None',
    Belarus = 'Belarus',
    Russia = 'Russia',
    Kazakhstan = 'Kazakhstan',
    Ukraine = 'Ukraine',
    England = 'England',
    Estonia = 'Estonia',
    Germany = 'Germany',
    Italy = 'Italy',
    Latvia = 'Latvia',
    Lithuania = 'Lithuania',
    Poland = 'Poland',
    Romania = 'Romania',
    Spain = 'Spain',
    Australia = 'Australia',
    Austria = 'Austria',
    Belgium = 'Belgium',
    Brazil = 'Brazil',
    Bulgaria = 'Bulgaria',
    Canada = 'Canada',
    China = 'China',
    Croatia = 'Croatia',
    Cyprus = 'Cyprus',
    CzechRepublic = 'CzechRepublic',
    Denmark = 'Denmark',
    Finland = 'Finland',
    France = 'France',
    Greece = 'Greece',
    Hungary = 'Hungary',
    Iceland = 'Iceland',
    India = 'India',
    Ireland = 'Ireland',
    Israel = 'Israel',
    Luxembourg = 'Luxembourg',
    Malta = 'Malta',
    Netherlands = 'Netherlands',
    Norway = 'Norway',
    Portugal = 'Portugal',
    Singapore = 'Singapore',
    Slovakia = 'Slovakia',
    Slovenia = 'Slovenia',
    SouthAfrica = 'SouthAfrica',
    SouthKorea = 'SouthKorea',
    Sweden = 'Sweden',
    Switzerland = 'Switzerland',
    Turkey = 'Turkey',
    UAE = 'UAE',
    USA = 'USA',
    Azerbaijan = 'Azerbaijan',
    Bahrain = 'Bahrain',
    Andorra = 'Andorra',
    Serbia = 'Serbia',
    Armenia = 'Armenia'
}

/**
 * Возможные значения:
 * - `SourceStockNotFound` — The source stock was not found; result contains sourceStockId.
 * - `SourceAndTargetStocksMustBeDifferent` — The source and the target stocks must be different.
 */
export enum CopyStorageLocationsErrorCode {
    SourceStockNotFound = 'SourceStockNotFound',
    SourceAndTargetStocksMustBeDifferent = 'SourceAndTargetStocksMustBeDifferent'
}

export enum ContractType {
    Supplier = 'Supplier',
    Client = 'Client',
    SparePartsSupply = 'SparePartsSupply'
}

/**
 * Возможные значения:
 * - `StationBankAccountIdIsMissing` — StationBankAccountId is required for the contract.
 * - `UsedInDocuments` — Контракт используется в складских документах (приход/расход) — удаление запрещено.
 */
export enum ContractErrorCode {
    StationBankAccountIdIsMissing = 'StationBankAccountIdIsMissing',
    UsedInDocuments = 'UsedInDocuments'
}

export enum ContactTypeEnum {
    Organization = 'Organization',
    Print = 'Print'
}

/** Company status returned by the NIP/TIN lookup. */
export enum CompanyStatusEnum {
    NotFound = 'NotFound',
    Active = 'Active',
    Liquidated = 'Liquidated',
    InLiquidation = 'InLiquidation',
    SubmittedForLiquidation = 'SubmittedForLiquidation',
    Unknown = 'Unknown'
}

export enum CommonMenuEnum {
    WorksTab = 'WorksTab',
    SparesTab = 'SparesTab',
    NotesTab = 'NotesTab'
}

export enum ClientTypeEnum {
    Individual = 'Individual',
    Organization = 'Organization'
}

export enum ClientFilterViewEnum {
    All = 'All',
    Individual = 'Individual',
    Organizations = 'Organizations',
    Recommendations = 'Recommendations',
    Favorites = 'Favorites'
}

export enum ClientErrorCode {
    PhoneNumberRequired = 'PhoneNumberRequired'
}

/**
 * Возможные значения:
 * - `BadTokenCredentials` — Неверный app token
 * - `BadNewPassword_MustBeDifferentFromOldPassword` — Новый пароль совпадает со старым
 * - `BadNewPassword_MustMatchToConfirmPassword` — Подтверждение пароля не совпадает
 * - `BadOldPassword_Incorrect` — Неверный старый пароль
 */
export enum ChangePasswordErrorCode {
    BadTokenCredentials = 'BadTokenCredentials',
    BadNewPasswordMustBeDifferentFromOldPassword = 'BadNewPassword_MustBeDifferentFromOldPassword',
    BadNewPasswordMustMatchToConfirmPassword = 'BadNewPassword_MustMatchToConfirmPassword',
    BadOldPasswordIncorrect = 'BadOldPassword_Incorrect'
}

/**
 * Возможные значения:
 * - `CategoryNotFound` — Корневая категория каталога не найдена.
 * - `ParentTagNotFound` — Родительский тег (ParentCode из тела запроса) не найден.
 * - `RootTagCannotBeDeleted` — Корневой тег категории нельзя удалить.
 * - `MoveNotAllowed` — Перемещение тега недопустимо; причина — в result.reason.
 */
export enum CategoryTagErrorCode {
    CategoryNotFound = 'CategoryNotFound',
    ParentTagNotFound = 'ParentTagNotFound',
    RootTagCannotBeDeleted = 'RootTagCannotBeDeleted',
    MoveNotAllowed = 'MoveNotAllowed'
}

/**
 * Возможные значения:
 * - `ProductIdsEmpty` — Список идентификаторов товаров пуст.
 * - `BadTagCode` — Код тега ссылается на несуществующую категорию каталога.
 */
export enum CatalogProductTagErrorCode {
    ProductIdsEmpty = 'ProductIdsEmpty',
    BadTagCode = 'BadTagCode'
}

/**
 * Возможные значения:
 * - `NoFiles` — Файлы не переданы.
 * - `FileReadFailed` — Не удалось прочитать файл или распаковать архив; подробности — в result.details.
 * - `ParseFailed` — Не удалось разобрать файл импорта; подробности — в result.details.
 */
export enum CatalogImportErrorCode {
    NoFiles = 'NoFiles',
    FileReadFailed = 'FileReadFailed',
    ParseFailed = 'ParseFailed'
}

export enum CashBoxTypeEnum {
    Bank = 'Bank',
    CashBox = 'CashBox',
    Wallet = 'Wallet',
    EWallet = 'EWallet',
    Lkassa = 'Lkassa'
}

/**
 * Возможные значения:
 * - `InvoiceNotOpen` — Only invoices in 'Open' or 'PartiallyPaid' status can be cancelled; result contains the current status.
 * - `InvoiceNotClientRequested` — Only client-requested invoices can be cancelled.
 * - `InvoiceHasPayments` — The invoice already has payments; result contains paymentsCount. Cancellation requires contacting support.
 */
export enum CancelInvoiceErrorCode {
    InvoiceNotOpen = 'InvoiceNotOpen',
    InvoiceNotClientRequested = 'InvoiceNotClientRequested',
    InvoiceHasPayments = 'InvoiceHasPayments'
}

/**
 * Возможные значения:
 * - `BranchTenantNotAllowed` — Billing operations are not allowed for a branch tenant; result contains tenantId and parentTenantId.
 */
export enum BranchTenantNotAllowedErrorCode {
    BranchTenantNotAllowed = 'BranchTenantNotAllowed'
}

export enum BlackListMatchType {
    Id = 'Id',
    Contacts = 'Contacts',
    DisplayName = 'DisplayName',
    Unp = 'Unp'
}

/**
 * Возможные значения:
 * - `CountryNotSupported` — Страна и валюта кабинета не поддерживаются: тарифного плана под них нет.
 * - `BankAccountNotConfigured` — Под страну и валюту кабинета не заведён банковский счёт — выставить счёт не на что.
 * - `OpenInvoiceExists` — У кабинета уже есть неоплаченный счёт.
 * - `TenantNotFound` — Кабинет не найден в биллинге.
 * - `CreationFailed` — Счёт не создался по иной причине; подробности в result.reason.
 * - `BillingUnavailable` — Биллинг временно недоступен: админский API не ответил или отверг запрос.
 */
export enum BillingErrorCode {
    CountryNotSupported = 'CountryNotSupported',
    BankAccountNotConfigured = 'BankAccountNotConfigured',
    OpenInvoiceExists = 'OpenInvoiceExists',
    TenantNotFound = 'TenantNotFound',
    CreationFailed = 'CreationFailed',
    BillingUnavailable = 'BillingUnavailable'
}

export enum BankAccountTypeEnum {
    Cash = 'Cash',
    Cashless = 'Cashless',
    CardPayment = 'CardPayment'
}

export enum BalanceFilterTypeEnum {
    Any = 'Any',
    Positive = 'Positive',
    Negative = 'Negative',
    Empty = 'Empty'
}

export enum BalanceFilter {
    Any = 'Any',
    Positive = 'Positive',
    Negative = 'Negative',
    Empty = 'Empty'
}

export enum AvailabilityModeEnum {
    Unknown = 'Unknown',
    Normal = 'Normal',
    Limited = 'Limited',
    Forbidden = 'Forbidden'
}

/**
 * Возможные значения:
 * - `AccessDenied` — Only the creator or assignee can assign the task.
 */
export enum AssignTaskErrorCode {
    AccessDenied = 'AccessDenied'
}

/**
 * Возможные значения:
 * - `ZeroAmount` — The total payment amount must not be zero.
 */
export enum AddPaymentErrorCode {
    ZeroAmount = 'ZeroAmount'
}

/**
 * Возможные значения:
 * - `BadRepTimeDb` — Источник данных авто не поддерживается (доступен только RepTimesDb4).
 */
export enum AddCarsToProductErrorCode {
    BadRepTimeDb = 'BadRepTimeDb'
}

export interface A1VatsCallHistoryRecordResponse {
    /** @format int32 */
    clientId: number
    clientName?: string | null
    /** @format int64 */
    callTimestamp: number
    callType?: string | null
    destinationNumber?: string | null
    callerNumber?: string | null
    callerName?: string | null
    calleeNumber?: string | null
    calleeName?: string | null
    /** @format int64 */
    callDuration: number
    /** @format int64 */
    conversationDuration: number
    callStatus?: string | null
}

export interface A1VatsGetCallsHistoryRequest {
    /** @format date-time */
    from: string
    /** @format date-time */
    to?: string | null
}

/**
 * Response model that represents the current A1 Virtual PBX (VATS) integration settings.
 * OAuth tokens are omitted intentionally.
 */
export interface A1VatsSettingsResponse {
    /** Indicates whether the A1 VATS integration is enabled. */
    isEnabled: boolean
    /** Company ID from A1 VATS personal account (company_id). */
    companyId?: string | null
    /** Primary integration code from A1 VATS personal account (api_key). */
    apiKey?: string | null
}

/**
 * Request model for adding a client to the blacklist.
 * Stores the client identifier and the reason for blacklisting.
 */
export interface AddBlackListRequest {
    /**
     * The unique identifier of the client to be blacklisted.
     * @format int32
     */
    clientId: number
    /** The reason for adding the client to the blacklist. */
    reason: string | null
}

/** Request model for adding or updating calendar settings. */
export interface AddCalendarSettingsRequest {
    /** A collection of working areas (e.g., service areas, departments) used in the calendar. */
    areas?: Area[] | null
    /**
     * The starting hour of the working day in the calendar. Default is `7`.
     * @format int32
     */
    startHour: number
    /**
     * The ending hour of the working day in the calendar. Default is `22`.
     * @format int32
     */
    endHour: number
    /**
     * The step interval (in minutes) for time slots in the calendar. Default is `30`.
     * @format int32
     */
    step: number
    /** Indicates whether synchronization with Google Calendar is enabled. */
    enableSyncWithGoogleCalendar: boolean
}

/** Request model for adding a new car to the system. */
export interface AddCarRequest {
    /**
     * The identifier of the car owner.
     * @format int32
     */
    ownerId: number
    /**
     * The current mileage of the car (optional).
     * @format int32
     */
    mileage?: number | null
    /** The manufacturing year of the car (optional). */
    year?: string | null
    /** The registration number (license plate) of the car (optional). */
    regNo?: string | null
    /** The primary body (chassis) number of the car (optional). */
    bodyNo?: string | null
    /** An alternative body (chassis) number of the car (optional). */
    bodyNo2?: string | null
    /** The manufacturer (make) of the car (optional). */
    manufacturer?: string | null
    /** The model of the car (optional). */
    model?: string | null
    /**
     * The engine capacity in liters (optional).
     * @format float
     */
    engineLitres?: number | null
    fuelType?: FuelTypeEnum
    vehicleType: VehicleTypeEnum
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    /** Additional notes or annotations for the car. */
    annotation?: string | null
    /**
     * The identifier for the first repair times database entry (optional).
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** The value/description for the first repair times database entry (optional). */
    repTimesDb1Value?: string | null
    /**
     * The identifier for the second repair times database entry (optional).
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** The value/description for the second repair times database entry (optional). */
    repTimesDb2Value?: string | null
    /** The identifier for the third repair times database entry (optional). */
    repTimesDb3Id?: string | null
    /** The value/description for the third repair times database entry (optional). */
    repTimesDb3Value?: string | null
    /** The identifier for the fourth repair times database entry (optional). */
    repTimesDb4Id?: string | null
    /** The value/description for the fourth repair times database entry (optional). */
    repTimesDb4Value?: string | null
    /** The identifier for the fifth repair times database entry (optional). */
    repTimesDb5Id?: string | null
    /** The value/description for the fifth repair times database entry (optional). */
    repTimesDb5Value?: string | null
}

/** Ответ ошибки типа `AddCarsToProductException`. Код см. в поле `Detail`. */
export interface AddCarsToProductExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'AddCarsToProductException'. */
    Title?: 'AddCarsToProductException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadRepTimeDb` — Источник данных авто не поддерживается (доступен только RepTimesDb4).
     */
    Detail?: AddCarsToProductErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface AddCarsToProductWarehouseRequest {
    modificationIds?: string[] | null
    repDb: RepTimesDbEnum
}

export interface AddCashboxPaymentRequest {
    /** @format uuid */
    cashBoxId: string
    /** @format date-time */
    paymentDate: string
    /** @format uuid */
    parentPaymentId?: string | null
    /** @format uuid */
    paymentCategoryId?: string | null
    paymentType: PaymentTypeEnum
    isFullPayment?: boolean | null
    email?: string | null
    comment?: string | null
    client?: PaymentClientRequest
    payments?: AddUpdateCashboxTransactionRequest[] | null
    documentReference?: DocumentReferenceRequest
}

export interface AddCashboxRequest {
    title: string | null
    cashboxType: CashBoxTypeEnum
    hidden: boolean
    isArchive: boolean
    username?: string | null
    password?: string | null
    defaultCurrency: CurrencyCodeEnum
    /** @format int32 */
    integrationId?: number | null
}

/**
 * Request model for creating a new client.
 * Contains full client information, including contacts, tags, and sources.
 */
export interface AddClientRequest {
    clientTypeCode: ClientTypeEnum
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName: string | null
    /** The email address of the client (optional). */
    email?: string | null
    /** The Skype contact of the client (optional). */
    skype?: string | null
    /** The Telegram contact of the client (optional). */
    telegram?: string | null
    /** The street address of the client (optional). */
    streetAddress?: string | null
    /** Additional notes or annotations about the client (optional). */
    annotation?: string | null
    /** The name of the bank associated with the client (optional). */
    bank?: string | null
    /** The bank code (e.g., SWIFT or local code) (optional). */
    bankCode?: string | null
    /** The bank account number of the client (optional). */
    bankAccount?: string | null
    /** The address of the client’s bank (optional). */
    bankAddress?: string | null
    /** The full name of the company director (optional). */
    director?: string | null
    /** The full name of the company accountant (optional). */
    accountant?: string | null
    /**
     * The general discount percentage applied to the client’s services.
     * @format int32
     */
    discountWorks: number
    /**
     * The discount percentage applied to spare parts.
     * @format int32
     */
    discountSpares: number
    /** The discount card number associated with the client (optional). */
    discountCard?: string | null
    /** Indicates whether the client is a resident (optional). */
    resident?: boolean | null
    /** The client’s birthday (optional). */
    birthday?: string | null
    /** Indicates whether the client requires follow-up calls. */
    isNeedCall?: boolean | null
    /** Marks the client as a favorite. */
    isFavorite?: boolean | null
    /** Indicates whether the client is marked as trusted. */
    isTrusted?: boolean | null
    /** The contract identifier associated with the client (optional). */
    contract?: string | null
    /** The contract start date (optional). */
    contractDate?: string | null
    /** The contract end date (optional). */
    contractEndDate?: string | null
    /** The legal basis for the contract (optional). */
    based?: string | null
    /** Indicates whether SMS notifications are disabled for this client. */
    banSms?: boolean | null
    /** The description or reason for disabling SMS notifications (optional). */
    banSmsDescription?: string | null
    /**
     * The rate number associated with the client.
     * @format int32
     */
    rateNumber?: number | null
    countryCode: CountryEnum
    /** The unique taxpayer identification number (UNP) of the client (optional). */
    unp?: string | null
    /** Custom property 2 (for extended data). */
    prop2?: string | null
    /** Custom property 3 (for extended data). */
    prop3?: string | null
    /** A list of sources from which the client was acquired. */
    sources?: AddUpdateClientSourceRequest[] | null
    /** A list of contact persons associated with the client. */
    contacts?: ClientContactRequest[] | null
}

export interface AddContactRequest {
    name?: string | null
    phone?: string | null
    email?: string | null
}

/** Represents a request to add a new contract. */
export interface AddContractRequest {
    /** Contract number (optional, may be auto-generated if not provided). */
    contractNo?: string | null
    /**
     * Identifier of the station's bank account associated with this contract.
     * @format uuid
     */
    stationBankAccountId?: string | null
    type: ContractType
    /**
     * Identifier of the supplier (if the contract is with a supplier).
     * @format uuid
     */
    supplierId?: string | null
    /**
     * Identifier of the client (if the contract is with a client).
     * @format int32
     */
    clientId?: number | null
    /**
     * Date when the contract was signed.
     * @format date-time
     */
    signedAt: string
    /**
     * Date when the contract becomes effective.
     * @format date-time
     */
    startDate: string
    /**
     * Date when the contract ends (optional, may be open-ended).
     * @format date-time
     */
    endDate?: string | null
    /**
     * Discount applied to work/services under the contract (percentage).
     * @format double
     */
    workDiscount: number
    /**
     * Discount applied to spare parts under the contract (percentage).
     * @format double
     */
    spareDiscount: number
    /**
     * Discount applied to contractor services under the contract (percentage).
     * @format double
     */
    contractorDiscount: number
    /**
     * Payment deferment period in days.
     * @format int32
     */
    paymentDeferment: number
    /** Additional notes or comments about the contract. */
    notes?: string | null
    signedBy?: string | null
    signedByPosition?: string | null
    signedOnBasis?: string | null
    warrantyObligations?: string | null
}

/** Represents a request to add a new contact person for a contractor. */
export interface AddContractorContactRequest {
    /** Full name of the contact person. */
    fullName: string | null
    /** Phone number of the contact person. */
    phoneNumber: string | null
}

/** Represents a request to add a new contractor (organization or individual). */
export interface AddContractorRequest {
    /** Full legal name of the contractor (organization name or individual full name). */
    fullName: string | null
    /** Taxpayer Identification Number (TIN) or equivalent company identifier. */
    tin: string | null
    /** Official address of the contractor. */
    address?: string | null
    /** Website of the contractor, if available. */
    site?: string | null
    /** Additional notes or annotations about the contractor. */
    annotation?: string | null
    /** List of contractor's contact persons with their details. */
    contacts?: AddContractorContactRequest[] | null
}

/** Represents a request to add a custom (customer-provided) work item to an order. */
export interface AddCustomerWorkRequest {
    /**
     * The title or description of the customer work to be added.
     * For example: "Install additional equipment" or "Paint left door".
     */
    title: string | null
    /**
     * The position (order index) of the work item in the list.
     * Used for sorting and execution sequence.
     * @format int32
     */
    position: number
}

/** Request model for adding or updating an employee's rate configuration. */
export interface AddEmployeeRateRequest {
    /**
     * The identifier of the station rate associated with this employee rate.
     * @format int32
     */
    stationRateId: number
    /**
     * The interest rate (percentage) applied for the specified station rate.
     * @format double
     */
    interestRate: number
    employeeRateType: EmployeeRateTypeEnum
}

/** Model for adding a new employee */
export interface AddEmployeeRequest {
    /** Full name of the employee */
    fullName: string | null
    /** Short name of the employee */
    shortName: string | null
    /** Job position of the employee */
    position: string | null
    /** Address of the employee */
    address?: string | null
    /** Primary phone number of the employee */
    primaryPhone?: string | null
    /** Secondary phone number of the employee */
    secondaryPhone?: string | null
    /** Email address of the employee */
    email?: string | null
    /** Birth date of the employee */
    birthDay?: string | null
    /** Indicates whether the employee is shown as responsible */
    showAsResponsible: boolean
    /**
     * Interest rate for the responsible role
     * @format double
     */
    interestRateResponsible: number
    /** Indicates whether the employee is shown as an executor */
    showAsExecutor: boolean
    /** Whether to use a common interest rate for all types of work */
    useCommonWorkInterestRate: boolean
    /**
     * Common interest rate for all types of work
     * @format double
     */
    workInterestRate?: number | null
    /**
     * Interest rate for spare parts
     * @format double
     */
    spareInterestRate: number
    /** Notes for the employee */
    annotation?: string | null
    /** Access to the CarDone/Favicar mobile application - Master */
    isMobileAccessEnabledForMaster: boolean
    /** Interest rates depending on the type of work */
    employeeRates?: AddEmployeeRateRequest[] | null
    /** Request model for adding or updating an employee's work schedule. */
    employeeSchedule?: AddUpdateEmployeeScheduleRequest
}

/** Represents a request to add a client-supplied spare part to the event. */
export interface AddEventClientSpareRequest {
    /** Human-readable name of the spare part. */
    spareName: string | null
    /** Catalog/part number (SKU, OEM/aftermarket code). */
    catalogNumber?: string | null
    /**
     * Quantity of the spare part (can be fractional for fluids/consumables).
     * @format double
     */
    count: number
    /** Unit of measure (e.g., "pcs", "l", "kg", "m"). */
    measure: string | null
    condition: OrderClientSpareConditionEnum
    /**
     * Per-unit input price provided for this spare part (in tenant currency).
     * @format double
     */
    inputPrice: number
}

/** Add Event Request */
export interface AddEventRequest {
    type: EventTypeEnum
    /**
     * Identifier of the area/location where the event takes place.
     * @format int32
     */
    areaId: number
    /**
     * Identifier of the responsible employee.
     * @format int32
     */
    responsibleId: number
    /**
     * Source
     * @format int32
     */
    sourceId?: number | null
    status: EventStatusEnum
    /**
     * Scheduled start time in UTC.
     * @format date-time
     */
    startUtc: string
    /**
     * Scheduled end time in UTC.
     * @format date-time
     */
    endUtc: string
    /** Short title/subject of the event. */
    title?: string | null
    /** Detailed description/notes for the event. */
    description?: string | null
    /**
     * Related vehicle identifier, if any.
     * @format int32
     */
    vehicleId?: number | null
    /**
     * Related client identifier, if any.
     * @format int32
     */
    clientId?: number | null
    /** Represents notification preferences for an event. */
    eventNotification?: EventNotificationDto
    /**
     * Lightweight vehicle DTO for embedding into event payloads/responses.
     * Includes display fields and cross-references to multiple RepTimes catalogs.
     */
    vehicleData?: EventVehicleDto
    clientData: EventClientDto
    /** Customer-requested work items (free-form list). */
    customerWork?: string[] | null
    /** Station-performed works associated with the event (optional). */
    stationWorks?: AddEventStationWorkRequest[] | null
    /** Station-supplied spare parts associated with the event (optional). */
    stationSpares?: AddEventStationSpareRequest[] | null
    /** Client-supplied spare parts associated with the event (optional). */
    clientSpares?: AddEventClientSpareRequest[] | null
    /**
     * Total cost of works/services.
     * @format double
     */
    wksCostTotal: number
    /**
     * Total cost of spare parts.
     * @format double
     */
    sprCostTotal: number
    /**
     * Total event cost
     * @format double
     */
    ttlCostTotal: number
    /** Linked Google Calendar identifier (optional). */
    googleCalendarId?: string | null
    /** Linked Google Calendar event identifier (optional). */
    googleEventId?: string | null
}

export interface AddEventStationSpareRequest {
    /** The name/description of the spare part. */
    spareName?: string | null
    /** Country of origin for the spare part (optional). */
    country?: string | null
    /** The brand name of the spare part (optional). */
    brandName?: string | null
    /** Vendor code (article number provided by manufacturer or supplier, optional). */
    vendorCode?: string | null
    /** Catalog number (article) of the spare part (optional). */
    catalogNumber?: string | null
    /**
     * The quantity of the spare part used in the order.
     * @format double
     */
    count: number
    /** Unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * VAT Rate
     * @format double
     */
    vatRate: number
    /**
     * Base input price (per unit) without VAT.
     * @format double
     */
    inputPriceNoVat: number
    /**
     * Total input price without VAT for all items (InputPriceNoVat * Count).
     * @format double
     */
    inputPriceNoVatTotal: number
    /**
     * VAT amount applied to the input price.
     * @format double
     */
    inputPriceVat: number
    /**
     * Input price (per unit) including VAT.
     * @format double
     */
    inputPrice: number
    /**
     * Total input price including VAT for all items.
     * @format double
     */
    inputPriceTotal: number
    /**
     * Absolute markup (extra charge) applied to the spare part.
     * @format double
     */
    extraAmount: number
    /**
     * Percentage markup applied to the spare part.
     * @format double
     */
    extraPercent: number
    /**
     * Selling price per unit without VAT.
     * @format double
     */
    priceNoVat: number
    /**
     * Total selling price without VAT for all items.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount applied to the selling price.
     * @format double
     */
    priceVat: number
    /**
     * Selling price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * Total selling price including VAT for all items.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to this spare part.
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount applied.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount included in the cost.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments for this spare part. */
    notes?: string | null
    /**
     * Identifier of the stock (warehouse) from which the spare part was taken.
     * @format uuid
     */
    stockId?: string | null
    /**
     * Identifier of the product in stock system.
     * @format uuid
     */
    productId?: string | null
    /** Internal code of the spare part in stock system (optional). */
    internalCode?: string | null
    status: OrderStationSparesStatusEnum
}

/**
 * Represents a request to add a station-performed work line to an event
 * with pricing, VAT and cost breakdowns.
 */
export interface AddEventStationWorkRequest {
    /** Display name of the work (what the customer sees on documents). */
    displayName: string | null
    /**
     * Quantity of work (e.g., hours or units).
     * NOTE: consider using `decimal` for money/quantities that need exact arithmetic.
     * @format double
     */
    count: number
    /**
     * Optional rate code/number from your price list (tariff identifier).
     * @format int32
     */
    rateNumber: number
    /**
     * Optional price per rate unit (e.g., price per hour) excluding VAT.
     * @format double
     */
    ratePrice: number
    /**
     * Standard (normative) time per unit (e.g., hours for this operation).
     * @format double
     */
    normTime: number
    /**
     * Total normative time = `NormTime × Count`.
     * @format double
     */
    normTimeTotal: number
    /**
     * VAT Rate
     * @format double
     */
    vatRate: number
    /**
     * Unit price excluding VAT (net).
     * @format double
     */
    priceNoVat: number
    /**
     * Total price excluding VAT (net) for the line.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount for the line (specify whether per-unit or total in your mapping; commonly total).
     * @format double
     */
    priceVat: number
    /**
     * Unit price including VAT (gross).
     * @format double
     */
    price: number
    /**
     * Total price including VAT (gross) for the line.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to the line (0–100).
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount in currency (how much was subtracted).
     * @format double
     */
    discountAmount: number
    /**
     * Unit internal cost excluding VAT (net).
     * @format double
     */
    costNoVat: number
    /**
     * Total internal cost excluding VAT (net) for the line.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount calculated from internal cost (commonly total).
     * @format double
     */
    costVat: number
    /**
     * Total internal cost including VAT (gross) for the line.
     * @format double
     */
    costTotal: number
    workSource: WorkSourceEnum
    /** If true, hides the normative time in printed documents/UI. */
    isHideNormTime: boolean
    status: OrderWorkStatusEnum
}

/** AddFeedbackRequest */
export interface AddFeedbackRequest {
    /** User Full name */
    fullName?: string | null
    /** User phone */
    phone?: string | null
    /** User email */
    email?: string | null
    /** Feedback message */
    text?: string | null
}

/** Request model for adding or updating Google API service account settings. */
export interface AddGoogleApiSettingsRequest {
    /** The type of the service account (usually "service_account"). */
    type?: string | null
    /** The Google Cloud project identifier. */
    projectId?: string | null
    /** The unique identifier of the private key. */
    privateKeyId?: string | null
    /** The private key string used for authentication. */
    privateKey?: string | null
    /** The client email address associated with the service account. */
    clientEmail?: string | null
    /** The client ID associated with the service account. */
    clientId?: string | null
    /** The authentication URI (used for OAuth2 flow). */
    authUri?: string | null
    /** The token URI used to obtain access tokens. */
    tokenUri?: string | null
    /** The URL for the authentication provider’s X.509 public certificates. */
    authProviderX509CertUrl?: string | null
    /** The URL for the client’s X.509 public certificate. */
    clientX509CertUrl?: string | null
}

export interface AddIncomeDocumentRequest {
    documentType: IncomeDocumentTypeEnum
    /** @format uuid */
    stockId: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    /** @format date-time */
    estimatedShippingDate?: string | null
    bankAccountRef?: WarehouseBankAccountReferenceDto
    responsibleRef?: WarehouseEmployeeReferenceDto
    supplierRef?: WarehouseSupplierReferenceDto
    supplierContractRef?: WarehouseContractReferenceDto
    buyerRef?: WarehouseBuyerReferenceDto
    buyerContractRef?: WarehouseContractReferenceDto
    comment?: string | null
    /** @format double */
    vat: number
    products?: IncomeProductDto[] | null
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
}

export interface AddInventoryDocumentRequest {
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    stockRef?: InventoryStockRef
    responsibleRef?: InventoryEmployeeRef
    comment?: string | null
    products?: InventoryProductCreateItem[] | null
}

/** Request model for creating a new user account. */
export interface AddNewAccountRequest {
    /** The login/username of the existing account to be linked. */
    login: string | null
    /** The password of the existing account to confirm access. */
    password?: string | null
    /**
     * The email address associated with the new account.
     * If Cardone.Web.PlatformApiCore.Features.Dictionaries.Models.Employee.AddNewAccountRequest.GenerateEmail is set to `true`, a default/generated email will be used.
     */
    email?: string | null
    /** Indicates whether the email should be generated automatically. */
    generateEmail: boolean
    /** Indicates whether the password should be generated automatically. */
    generatePassword: boolean
}

/**
 * Represents a request model for adding a client-provided spare part to an order.
 * Contains details such as catalog number, name, unit of measure, quantity, usage flag,
 * and initial input price.
 */
export interface AddOrderClientSpareRequest {
    /**
     * The position (sorting index) of the spare part in the order’s spare list.
     * @format int32
     */
    position: number
    /** The catalog number of the spare part (optional, may come from a catalog or be manually entered). */
    catalogNumber?: string | null
    /** The name/description of the spare part provided by the client. */
    spareName?: string | null
    /** The unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * The quantity of the spare part provided by the client.
     * @format float
     */
    count: number
    condition: OrderClientSpareConditionEnum
    /**
     * The input price of the spare part (value assigned, before markup).
     * @format double
     */
    inputPrice: number
}

/**
 * Represents a request model for adding a contractor's work to an order.
 * Contains details such as contractor identifier, work description,
 * pricing information (with and without VAT), and calculated profit.
 */
export interface AddOrderContractorWorkRequest {
    /**
     * The position (sorting index) of the work in the order’s contractor work list.
     * @format int32
     */
    position: number
    /**
     * The identifier of the contractor who performed the work.
     * @format int32
     */
    contractorId: number
    /** The description of the contractor's work (e.g., "Wheel alignment", "Painting"). */
    workDesc: string | null
    /**
     * The applied VAT (Value Added Tax) percentage for this work.
     * @format double
     */
    vat: number
    /**
     * The initial input price without vat
     * @format double
     */
    inputPriceNoVat: number
    /**
     * The initial input price (cost provided by contractor, before taxes).
     * @format double
     */
    inputPriceVat: number
    /**
     * The initial input price (cost provided by contractor, before taxes).
     * @format double
     */
    inputPrice: number
    /** @format double */
    extraAmount: number
    /** @format double */
    extraPercent: number
    /**
     * The cost of the work excluding VAT.
     * @format double
     */
    costNoVat: number
    /**
     * The VAT amount applied to the cost of the work.
     * @format double
     */
    costVat: number
    /**
     * The total cost including VAT.
     * @format double
     */
    costTotal: number
    /**
     * The calculated profit margin for this contractor work.
     * @format double
     */
    profit: number
}

/**
 * Request model for creating a new order.
 * Contains information about participants, vehicle, financial details, dates,
 * and associated child entities such as works, spares, and tags.
 */
export interface AddOrderRequest {
    /**
     * The identifier of the bank account associated with the order.
     * @format uuid
     */
    bankAccount: string
    /**
     * The identifier of the employee responsible for the order.
     * @format int32
     */
    employeeId: number
    /**
     * The identifier of the order owner.
     * @format int32
     */
    ownerId: number
    /**
     * The identifier of the client for whom the order is created.
     * @format int32
     */
    clientId: number
    /**
     * The identifier of the payer for the order.
     * @format int32
     */
    payerId: number
    /**
     * The identifier of the car associated with the order.
     * @format int32
     */
    carId: number
    /**
     * The optional identifier of the contract associated with the order.
     * @format uuid
     */
    contractId?: string | null
    numberingType: OrderNumberingTypeEnum
    /**
     * The mileage of the car at the moment of the order (optional).
     * @format int32
     */
    mileage?: number | null
    /** Indicates whether the order is a training order. */
    isTraining: boolean
    /** Proxy document number, if applicable (optional). */
    proxyNumber?: string | null
    /** Description of malfunctions reported for the car (optional). */
    malfunctions?: string | null
    /** Additional notes for the order (optional). */
    notes?: string | null
    /** Warranty description or conditions (optional). */
    warranty?: string | null
    /** Recommendations related to the order (optional). */
    recommendation?: string | null
    status: OrderStatusEnum
    /**
     * VAT (NDS) rate applied to works.
     * @format double
     */
    ndsWorks: number
    /**
     * VAT (NDS) rate applied to spare parts.
     * @format double
     */
    ndsSpares: number
    /**
     * The date when the order was created.
     * @format date-time
     */
    orderDate: string
    /**
     * The estimated completion date for the order.
     * @format date-time
     */
    estimateDate: string
    /**
     * The due date for payment (optional).
     * @format date-time
     */
    paymentDueDate?: string | null
    /**
     * The actual date of payment (optional).
     * @format date-time
     */
    paymentDate?: string | null
    /**
     * The discount amount applied to works.
     * @format double
     */
    wksDiscountAmount: number
    /**
     * The discount amount applied to spares.
     * @format double
     */
    sprDiscountAmount: number
    /**
     * The total discount amount applied to the order.
     * @format double
     */
    ttlDiscountAmount: number
    /**
     * The profit from works.
     * @format double
     */
    wksProfit: number
    /**
     * The profit from contractor works.
     * @format double
     */
    ctrProfit: number
    /**
     * The profit from spares.
     * @format double
     */
    sprProfit: number
    /**
     * The total profit of the order.
     * @format double
     */
    ttlProfit: number
    /**
     * The cost of works without VAT.
     * @format double
     */
    wksCostNoVat: number
    /**
     * The cost of contractor works without VAT.
     * @format double
     */
    ctrCostNoVat: number
    /**
     * The cost of spares without VAT.
     * @format double
     */
    sprCostNoVat: number
    /**
     * The total cost without VAT.
     * @format double
     */
    ttlCostNoVat: number
    /**
     * The cost of works with VAT.
     * @format double
     */
    wksCostVat: number
    /**
     * The cost of contractor works with VAT.
     * @format double
     */
    ctrCostVat: number
    /**
     * The cost of spares with VAT.
     * @format double
     */
    sprCostVat: number
    /**
     * The total cost with VAT.
     * @format double
     */
    ttlCostVat: number
    /**
     * The total cost of works including VAT.
     * @format double
     */
    wksCostTotal: number
    /**
     * The total cost of contractor works including VAT.
     * @format double
     */
    ctrCostTotal: number
    /**
     * The total cost of spares including VAT.
     * @format double
     */
    sprCostTotal: number
    /**
     * The total cost of the order including VAT.
     * @format double
     */
    ttlCostTotal: number
    /**
     * The total norms of works (measured in hours).
     * @format double
     */
    wksNormsTotal: number
    /**
     * The total cost of contractor spare parts.
     * @format double
     */
    cspCostTotal: number
    /**
     * The discount applied to works based on client settings.
     * @format double
     */
    discountWksClient: number
    /**
     * The discount applied to works based on car settings.
     * @format double
     */
    discountWksCar: number
    /**
     * The total discount on works.
     * @format double
     */
    discountWksTtl: number
    /**
     * The total discount on spares.
     * @format double
     */
    discountSprTtl: number
    /**
     * The discount based on the year of manufacture.
     * @format double
     */
    discountYear: number
    /** The list of customer-defined works associated with the order. */
    customerWorks?: AddCustomerWorkRequest[] | null
    /** The list of works associated with the order. */
    orderWorks?: AddOrderStationWorkRequest[] | null
    /** The list of contractor works associated with the order. */
    contractorWorks?: AddOrderContractorWorkRequest[] | null
    /** The list of client-provided spare parts for the order. */
    clientSpares?: AddOrderClientSpareRequest[] | null
    /** The list of station-provided spare parts for the order. */
    stationSpares?: AddOrderStationSpareRequest[] | null
    /** The list of tags assigned to the order. */
    tags?: AddOrderTagRequest[] | null
}

/**
 * Represents a request model for adding a station-provided spare part to an order.
 * Contains details about identification, pricing, markup, discounts, costs, and stock properties.
 */
export interface AddOrderStationSpareRequest {
    /**
     * The position (sorting index) of the spare part in the order’s spare list.
     * @format int32
     */
    position: number
    /** The name/description of the spare part. */
    spareName?: string | null
    /** Country of origin for the spare part (optional). */
    country?: string | null
    /** The brand name of the spare part (optional). */
    brandName?: string | null
    /** Vendor code (article number provided by manufacturer or supplier, optional). */
    vendorCode?: string | null
    /** Catalog number (article) of the spare part (optional). */
    catalogNumber?: string | null
    /**
     * The quantity of the spare part used in the order.
     * @format double
     */
    count: number
    /** Unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * Identifier of the employee responsible for this spare part.
     * @format int32
     */
    responsibleId: number
    /**
     * Base input price (per unit) without VAT.
     * @format double
     */
    inputPriceNoVat: number
    /**
     * Total input price without VAT for all items (InputPriceNoVat * Count).
     * @format double
     */
    inputPriceNoVatTotal: number
    /**
     * VAT amount applied to the input price.
     * @format double
     */
    inputPriceVat: number
    /**
     * Input price (per unit) including VAT.
     * @format double
     */
    inputPrice: number
    /**
     * Total input price including VAT for all items.
     * @format double
     */
    inputPriceTotal: number
    /**
     * Absolute markup (extra charge) applied to the spare part.
     * @format double
     */
    extraAmount: number
    /**
     * Percentage markup applied to the spare part.
     * @format double
     */
    extraPercent: number
    /**
     * Selling price per unit without VAT.
     * @format double
     */
    priceNoVat: number
    /**
     * Total selling price without VAT for all items.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount applied to the selling price.
     * @format double
     */
    priceVat: number
    /**
     * Selling price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * Total selling price including VAT for all items.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to this spare part.
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount applied.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount included in the cost.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments for this spare part. */
    notes?: string | null
    /**
     * Calculated profit for this spare part (selling price - cost).
     * @format double
     */
    profit: number
    /**
     * Identifier of the stock (warehouse) from which the spare part was taken.
     * @format uuid
     */
    stockId?: string | null
    /**
     * Identifier of the product in stock system.
     * @format uuid
     */
    productId?: string | null
    /** Internal code of the spare part in stock system (optional). */
    internalCode?: string | null
    status: OrderStationSparesStatusEnum
}

/**
 * Represents a request model for adding a station work entry to an order.
 * Contains details about work identification, pricing, costs, discounts, profit,
 * and assigned employees.
 */
export interface AddOrderStationWorkRequest {
    /**
     * Position (ordering) of this work within the order.
     * @format int32
     */
    position: number
    /** Identifier of the work item (from catalog or external source). */
    workId?: string | null
    /** Description of the work performed. */
    workDesc?: string | null
    workSource: WorkSourceEnum
    /**
     * Quantity of work items.
     * @format double
     */
    count: number
    /**
     * Standard norm time for a single unit of this work.
     * @format double
     */
    normTime: number
    /**
     * Total calculated norm time (NormTime × Count).
     * @format double
     */
    normTimeTotal: number
    /**
     * Identifier of the responsible employee.
     * @format int32
     */
    responsibleId: number
    /**
     * Optional rate number (used for calculating pricing based on station rate tables).
     * @format int32
     */
    rateNumber?: number | null
    /**
     * Price per unit (rate price).
     * @format double
     */
    ratePrice: number
    /**
     * Price without VAT for a single unit of work.
     * @format double
     */
    priceNoVat: number
    /**
     * Total price without VAT (PriceNoVat × Count).
     * @format double
     */
    priceNoVatTotal: number
    /**
     * Price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * VAT amount for the work.
     * @format double
     */
    priceVat: number
    /**
     * Total price including VAT.
     * @format double
     */
    priceTotal: number
    /**
     * Applied discount percentage.
     * @format double
     */
    discount: number
    /**
     * Discount amount in absolute value.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT (CostNoVat × Count).
     * @format double
     */
    costNoVatTotal: number
    /**
     * Cost of VAT applied to this work.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments about the work. */
    notes?: string | null
    /**
     * Calculated profit (difference between price and cost).
     * @format double
     */
    profit: number
    /** Indicates whether the norm time should be hidden in reports/UI. */
    isHideNormTime: boolean
    /** Indicates whether this work should be excluded from order calculations. */
    ignoreWorkOnCalc: boolean
    status: OrderWorkStatusEnum
    calc: EmployeeCalcTypeEnum
    /** List of employees assigned to this work. */
    workers?: AddOrderWorkEmployeeRequest[] | null
}

/** Request model for adding a tag to an order. */
export interface AddOrderTagRequest {
    /**
     * The unique identifier of the tag to be attached to the order.
     * @format int32
     */
    id: number
}

/**
 * Response model representing the details of an employee's involvement in a specific order work item.
 * Contains information about time worked, share of work, and calculated payment/interest.
 */
export interface AddOrderWorkEmployeeRequest {
    /**
     * Unique identifier of the employee.
     * @format int32
     */
    employeeId: number
    /**
     * Norm time (in hours) assigned to the employee for this work item.
     * @format float
     */
    normTime: number
    /**
     * Percentage of the total work assigned to the employee.
     * @format double
     */
    percentage: number
    /**
     * Absolute part of the work amount assigned to the employee.
     * @format double
     */
    amountPart: number
    /**
     * Employee’s interest rate (percentage of profit or cost applied).
     * @format double
     */
    interestRate: number
    /**
     * Calculated interest amount for the employee based on the interest rate.
     * @format double
     */
    interestAmount: number
    /**
     * Rate price per unit of work assigned to the employee.
     * @format double
     */
    ratePrice: number
}

export interface AddOutcomeDocumentRequest {
    documentType: OutcomeDocumentTypeEnum
    stockRef?: WarehouseStockReferenceDto
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    /** @format date-time */
    estimatedSaleDate?: string | null
    /** @format date-time */
    estimatedPaymentDate?: string | null
    bankAccountRef?: WarehouseBankAccountReferenceDto
    responsibleRef?: WarehouseEmployeeReferenceDto
    supplierRef?: WarehouseSupplierReferenceDto
    supplierContractRef?: WarehouseContractReferenceDto
    buyerRef?: WarehouseBuyerReferenceDto
    buyerContractRef?: WarehouseContractReferenceDto
    comment?: string | null
    /** @format double */
    vat: number
    products?: OutcomeProductDto[] | null
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
}

/** Ответ ошибки типа `AddPaymentException`. Код см. в поле `Detail`. */
export interface AddPaymentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'AddPaymentException'. */
    Title?: 'AddPaymentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ZeroAmount` — The total payment amount must not be zero.
     */
    Detail?: AddPaymentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface AddPreOrderRequest {
    preOrder: PreOrderPayload
    events?: PreOrderEventsCreatePayload
}

export interface AddPriceListItemRequest {
    name: string | null
    isHideNormTime: boolean
    currency: CurrencyCodeEnum
    tagCode: string | null
    spares?: PriceListStationSpare[] | null
    works?: PriceListStationWork[] | null
    /** @format double */
    spareVat: number
    /** @format double */
    workVat: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
}

export interface AddPriceListItemTagRequest {
    parentCode: string | null
    name: string | null
    description?: string | null
}

export interface AddProductRequest {
    /** @minLength 1 */
    name: string
    printName?: string | null
    /** @format double */
    vat: number
    /** @minLength 1 */
    measure: string
    /** @minLength 1 */
    tagCode: string
    catalogCode?: string | null
    vendorCode?: string | null
    brandName?: string | null
    country?: string | null
    /** @format int32 */
    discount: number
    /** @format double */
    minBalance: number
    /** @format double */
    weight: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    recommendedPriceNoVat: number
    /** @format double */
    recommendedPriceVat: number
    /** @format double */
    recommendedPrice: number
    description?: string | null
    comment?: string | null
    barcodeList?: CatalogBarcodeItem[] | null
    oecodeList?: CatalogOecodeItem[] | null
}

export interface AddProductTagRequest {
    parentCode?: string | null
    name?: string | null
    description?: string | null
}

export interface AddRevaluationDocumentRequest {
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    responsibleRef?: RevaluationEmployeeRef
    comment?: string | null
    products?: RevaluationProductItem[] | null
}

/** Request model for adding or updating SMS service settings. */
export interface AddSmsSettingsRequest {
    provider: SmsProviderEnum
    /** Indicates whether bulk SMS mailing is enabled. */
    smsMailingEnable: boolean
    /** Provider-specific configuration settings (may vary depending on the selected provider). */
    settings: any
}

/** Request model for adding a new source associated with a specific resource type. */
export interface AddSourceRequest {
    resourceType: SourceResourceTypeEnum
    /** The title or descriptive name of the source. */
    title: string | null
}

/** Request model for adding or updating a station bank account. */
export interface AddStationBankAccountRequest {
    /**
     * The position or display order of the bank account in the list.
     * @format int32
     */
    position: number
    /** The title or descriptive name of the bank account. */
    title: string | null
    /** The name of the bank where the account is held. */
    bankName?: string | null
    /** The bank’s code (e.g., SWIFT/BIC or local identifier). */
    bankCode?: string | null
    /** The number of the bank account. */
    bankAccount?: string | null
    /** The address of the bank branch. */
    bankAddress?: string | null
    currency: CurrencyCodeEnum
    type: BankAccountTypeEnum
    /** A list of associated cashbox identifiers linked to this account. */
    cashboxes?: string[] | null
    /** Indicates whether this account is the default account for the station. */
    isDefault: boolean
    /** Indicates whether the account is archived (inactive). */
    archived: boolean
}

export interface AddStockRequest {
    /** @minLength 1 */
    title: string
    address?: string | null
    notes?: string | null
    isHide: boolean
}

export interface AddSupplierRequest {
    name?: string | null
    nip?: string | null
    address?: string | null
    /** @format double */
    discount: number
    login?: string | null
    password?: string | null
    clientId?: string | null
    clientSecret?: string | null
    apiKey?: string | null
    notes?: string | null
    status?: string | null
    type: SuppliersTypeEnum
    active: boolean
    contactsList?: AddContactRequest[] | null
}

/** Request model for adding a new tag to a specific resource. */
export interface AddTagRequest {
    /**
     * The unique identifier of the tag, if it already exists.
     * Used to link to an existing tag instead of creating a new one.
     * @format int32
     */
    tagId?: number | null
    resourceType: TagResourceTypeEnum
    /** The name of the tag to be created. */
    name: string | null
    /**
     * The identifier of the specific resource instance (e.g., order ID, client ID, vehicle ID)
     * to which the tag will be attached.
     * @format int32
     */
    resourceId: number
}

export interface AddTransferDocumentRequest {
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    /** @format uuid */
    sourceStockId: string
    /** @format uuid */
    targetStockId: string
    responsibleRef?: TransferEmployeeRef
    comment?: string | null
    products?: TransferProductItem[] | null
}

/** Request model for adding or updating A1 Virtual PBX (VATS) integration settings. */
export interface AddUpdateA1VatsSettingsRequest {
    /** Indicates whether the A1 VATS integration is enabled. */
    isEnabled: boolean
    /** Company ID from A1 VATS personal account (company_id). */
    companyId?: string | null
    /** Primary integration code from A1 VATS personal account (api_key). */
    apiKey?: string | null
}

export interface AddUpdateCashboxTransactionRequest {
    method: PaymentMethodEnum
    /** @format double */
    amount: number
}

export interface AddUpdateClientSourceRequest {
    /** @format int32 */
    id: number
    resourceType: SourceResourceTypeEnum
}

/** Request model for adding or updating the common organization settings. */
export interface AddUpdateCommonSettingsRequest {
    /** Full legal name of the organization. */
    organizationName: string | null
    /** Brand or trade name of the organization (if different from the legal name). */
    brandName?: string | null
    /** Legal (registered) address of the organization. */
    legalAddress?: string | null
    /** Actual street address of the organization. */
    streetAddress?: string | null
    /** Full name of the organization’s director. */
    directorName?: string | null
    /** The legal basis on which the director acts (e.g., “Charter”, “Power of Attorney”). */
    basedOn?: string | null
    /** The organization’s registration number (UNP / taxpayer identification). */
    unp?: string | null
    /** Additional property 1 (customizable field). */
    prop1?: string | null
    /** Additional property 2 (customizable field). */
    prop2?: string | null
    /** Additional property 3 (customizable field). */
    prop3?: string | null
}

/** Request model for adding or updating discount and price increase settings. */
export interface AddUpdateDiscountSettingsRequest {
    /**
     * Indicates whether discounts should be applied in the price list.
     * Default is `true`.
     */
    useDiscountsInPriceList: boolean
    /** A collection of work-related price increases (e.g., additional charges, surcharges). */
    workIncreases?: WorkIncrease[] | null
    /** A collection of spare parts price increases (e.g., markup rules). */
    spareIncreases?: SpareIncrease[] | null
}

/** Request model for adding or updating document-related settings. */
export interface AddUpdateDocumentsSettingsRequest {
    /**
     * The number of days to prevent notifications for unpaid cash documents. Default is `1`.
     * @format int32
     */
    cashNoNotificationPreventPeriod: number
    /**
     * The number of days to prevent notifications for paid cash documents. Default is `1`.
     * @format int32
     */
    cashNotificationPreventPeriod: number
    /** Enables or disables notifications when the execution status of a document changes. */
    enableNotificationChangeExecute: boolean
    /** Enables or disables notifications when the payment status of a document changes. */
    enableNotificationChangePaid: boolean
    /** Enables or disables the use of training documents within the system. */
    enableTrainingDocuments: boolean
    /** Indicates whether the system should suggest empty document numbers. */
    suggestEmptyNumbers: boolean
    /** Indicates whether the system should synchronize order and act numbers. */
    syncOrderAndActNo: boolean
    /** Indicates whether automatic document numbering is enabled. */
    useAutoDocumentNumbering: boolean
    orderNumberingType: OrderNumberingTypeEnum
}

/** Request model for adding or updating an employee's work schedule. */
export interface AddUpdateEmployeeScheduleRequest {
    /**
     * The date when the schedule starts.
     * @format date
     */
    scheduleStartDate: string
    scheduleType: ScheduleType
    /** The start time of the employee's workday. */
    workStartTime?: string | null
    /** The end time of the employee's workday. */
    workEndTime?: string | null
}

/** Request model for adding or updating general system settings. */
export interface AddUpdateGeneralSettingsRequest {
    /** The default interface language (e.g., "ru", "en"). Default is `"ru"`. */
    language?: string | null
    /** The current time zone of the system (e.g., "Europe/Minsk"). */
    currentTimeZone?: string | null
    timeFormat: TimeFormatEnum
    dateFormat: DateFormatEnum
    /** Indicates whether JivoChat integration is enabled. Default is `true`. */
    enableJivoChat: boolean
    /** Indicates whether client-side validation is enabled in the system. */
    enableClientValidation: boolean
    /** Indicates whether providing a client contact phone number is required. */
    isClientContactPhoneRequired: boolean
    smsTemplateMode: SmsTemplateModeEnum
    /**
     * Defines the visibility of Order Status feature.
     * Default is `Visible/Enabled`.
     */
    isStatusFeatureEnabled: boolean
}

/** Request model for adding or updating integration settings with the "Moi Zvonki" service. */
export interface AddUpdateMoiZvonkiSettingsRequest {
    /** Indicates whether the "Moi Zvonki" integration is enabled. */
    moiZvoinkiEnable: boolean
    /** The username used for authentication with the "Moi Zvonki" service. */
    moiZvoinkiUserName: string | null
    /** The API key used for secure access to the "Moi Zvonki" service. */
    moiZvoinkiApiKey: string | null
    /** The base API URL of the "Moi Zvonki" service. */
    moiZvoinkiApiUrl: string | null
}

/** Request model for adding or updating order-related settings. */
export interface AddUpdateOrdersSettings {
    commonMenu: CommonMenuEnum
    sparesMenu: SparesMenuEnum
    lockType: OrderLockTypeEnum
    lockReset: OrderLockResetEnum
    /**
     * Number of hours after which the order lock will be reset (used when `LockReset` is set to hours).
     * @format float
     */
    lockResetHours: number
    /** Indicates whether mileage information is required when creating or updating an order. */
    mileageRequired: boolean
    /** Indicates whether an event should be created automatically when an order is created. */
    createEvent: boolean
    /** Warranty conditions or notes associated with the order (optional). */
    warranty: string | null
    /** Indicates whether a client number is required when processing an order. */
    isClientNumberRequired: boolean
    /** Indicates whether updating the event status should also trigger additional updates elsewhere. */
    isEventStatusUpdateAlso: boolean
    /** Indicates whether status updates should be synchronized across all related entities. */
    updateStatusEverywhere: boolean
    /** Indicates whether a payment should be created automatically when the order reaches Paid status. */
    addPaymentOnPaidStatus: boolean
}

export interface AddUpdatePaymentCategoryRequest {
    name: string | null
}

/** Request model for adding or updating print settings in the system. */
export interface AddUpdatePrintSettingsRequest {
    /** Indicates whether to print the order document number on documents. */
    printOrderDocumentNumber: boolean
    /** Indicates whether to include the payment form in printed documents. */
    setPaymentForm: boolean
    /** Indicates whether to include the payment type in printed documents. */
    setPaymentType: boolean
    /** Indicates whether the document content should be scaled to fit a single page when printed. */
    fitToOnePage: boolean
    /** Indicates whether customer and company names should be filled in automatically on documents. */
    fillNames: boolean
    /** Indicates whether car details should be filled in automatically on documents. */
    fillCarDetails: boolean
    /** Indicates whether catalog numbers should be filled in automatically on documents. */
    fillCatalogNumber: boolean
    /** Custom name for the "Order Act" document. */
    nameOfOrderActDocument: string | null
    /** Custom name for the "Order" document. */
    nameOfOrderDocument: string | null
    /** Custom name for the "Request" document. */
    nameOfRequestDocument: string | null
    /** Custom name for the "Invoice" document. */
    nameOfInvoiceDocument: string | null
    /** Custom name for the "Act" document. */
    nameOfActDocument: string | null
    /** Custom name for the "Report" document. */
    nameOfReportDocument: string | null
    /**
     * Identifier of the contact template used in printed documents.
     * @format int32
     */
    contactsTemplate: number
    /** Indicates whether the act document name should follow legal naming conventions. */
    actNameUseLaw: boolean
    /** Indicates whether the order document name should follow legal naming conventions. */
    orderNameUseLaw: boolean
}

/** Request model for adding or updating a station contact. */
export interface AddUpdateStationContactRequest {
    /**
     * Unique identifier of the contact.
     * Use `0` when creating a new contact.
     * @format int32
     */
    id: number
    /** Phone number of the contact (required). */
    phone: string | null
    /** Full name of the contact person (required). */
    name: string | null
    /** Email address of the contact (optional). */
    email?: string | null
    /** Job position or role of the contact (optional). */
    position?: string | null
    type: ContactTypeEnum
    /** Indicates whether the contact is marked as deleted. Default is `false`. */
    deleted: boolean
}

/** Request model for adding or updating a station rate. */
export interface AddUpdateStationRateRequest {
    /**
     * Unique identifier of the rate.
     * Use `0` for creating a new rate.
     * @format int32
     */
    id: number
    /**
     * The sequential number of the rate (used as a reference in other entities).
     * @format int32
     */
    number: number
    /**
     * Sort order used for displaying rates in UI lists.
     * @format int32
     */
    order: number
    /** The title or name of the rate. */
    title: string | null
    /** An alternative description or display text for the rate (optional). */
    altText?: string | null
    /**
     * Value from norms database 1 (RepTimesDb1).
     * @format double
     */
    repTimesDb1: number
    /**
     * Value from norms database 2 (RepTimesDb2).
     * @format double
     */
    repTimesDb2: number
    /**
     * Value from norms database 3 (RepTimesDb3).
     * @format double
     */
    repTimesDb3: number
    /**
     * Value from norms database 4 (RepTimesDb4).
     * @format double
     */
    repTimesDb4: number
    /**
     * Value from norms database 5 (RepTimesDb5).
     * @format double
     */
    repTimesDb5: number
    currency: CurrencyCodeEnum
    /**
     * The base price associated with the rate.
     * @format double
     */
    price: number
    /** Indicates whether the rate is archived. */
    archived: boolean
}

/** Request model for adding or updating tax (VAT) settings. */
export interface AddUpdateTaxSettingsRequest {
    /**
     * The type of VAT applied (e.g., standard, reduced, custom).
     * @format int32
     */
    vatType: number
    /**
     * The VAT percentage rate applied to work/services.
     * @format double
     */
    workVat: number
    /**
     * The VAT percentage rate applied to spare parts.
     * @format double
     */
    spareVat: number
    /** The text description of VAT (e.g., legal notice or additional info). */
    vatText?: string | null
}

/** Request model for adding or updating alternative names of tenant system settings related to norms and technical data. */
export interface AddUpdateTenantSystemSettingsNormsNames {
    /** Alternative name for norms database 1 (RepTimesDb1). */
    repTimesDb1AltName?: string | null
    /** Alternative name for norms database 2 (RepTimesDb2). */
    repTimesDb2AltName?: string | null
    /** Alternative name for norms database 3 (RepTimesDb3). */
    repTimesDb3AltName?: string | null
    /** Alternative name for norms database 4 (RepTimesDb4). */
    repTimesDb4AltName?: string | null
    /** Alternative name for norms database 5 (RepTimesDb5). */
    repTimesDb5AltName?: string | null
    /** Alternative name for technical data database 2 (TechDataDb2). */
    techDataDb2AltName?: string | null
    /** Alternative name for technical data database 3 (TechDataDb3). */
    techDataDb3AltName?: string | null
    /** Alternative name for technical data database 4 (TechDataDb4). */
    techDataDb4AltName?: string | null
    /** Alternative name for technical data database 5 (TechDataDb5). */
    techDataDb5AltName?: string | null
}

export interface AddVehicleToProductRequest {
    modificationIds?: string[] | null
    repDb: RepTimesDbEnum
}

/**
 * Request model for adding webhook settings.
 * Defines the source and destination addresses for the webhook.
 */
export interface AddWebHookSettingsRequest {
    /** The source endpoint or system identifier from which the webhook is sent. */
    from: string | null
    /** The destination endpoint or system identifier to which the webhook is delivered. */
    to: string | null
}

export interface AdditionalDescriptionElement {
    value?: string | null
}

export interface AnalyticalReportRequest {
    statusIds?: OrderStatusEnum[] | null
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    showWithNumbers: boolean
    showWithoutNumbers: boolean
}

/**
 * Единый контракт ответа ошибки PlatformApiCore: runtime-сериализация в
 * Cardone.Web.PlatformApiCore.Configuration.Middlewares.HttpExceptionHandlerMiddleware и OpenAPI-схема в
 * Cardone.Web.PlatformApiCore.Configuration.Swagger.ProducesProblemDetailsOperationFilter используют один и тот же тип.
 */
export interface ApiProblemDetails {
    /** Имя базового класса исключения (`BadOperationException`, `ResourceNotFoundException`, ...). */
    Type?: string | null
    /** Имя конкретного типа исключения. Используется как discriminator в `oneOf`-схеме. */
    Title?: string | null
    /** @format int32 */
    Status?: number
    /** Код ошибки в PascalCase (для enum-based — значение соответствующего enum). */
    Detail?: string | null
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
 * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
 * как в прежней dictionary-реализации.
 */
export interface ApiProblemExtensions {
    /** Полезная нагрузка `BadOperationException.Result`. Middleware кладёт сюда camelCase `JsonNode`. */
    result?: any
    /** Ошибки валидации `BadRequestException`: имя поля (camelCase) → массив сообщений. */
    errors?: Record<string, string[]>
    /** Полезная нагрузка `BadOperationPromptException.Result` (диалог подтверждения). */
    prompt?: any
    /** Полный `ToString()` исключения. Заполняется только в Development для непредвиденных ошибок. */
    error?: string | null
    [key: string]: any
}

export interface AppInitialStateResponse {
    webTitle?: string | null
    appUserInitialState?: AppUserInitialStateResponse
    appSettingsInitialState?: AppSettingsInitialStateResponse
    appFeaturesInitialState?: TenantFeaturesResponse
    appAvailableTenants?: StationInfoResponse[] | null
    appToken?: string | null
}

export interface AppSettingsInitialStateResponse {
    portalUrl?: string | null
    publicSiteUrl?: string | null
    portalInstance?: string | null
    version?: string | null
    enableTrainingDocuments: boolean
    showAllDocuments: boolean
    promisedPaymentEnabled: boolean
    useAnnualOrderNumbering: boolean
    currency: CurrencyCodeEnum
    country: CountryEnum
    language: LanguageEnum
    /** @format int32 */
    maxNumberOfEmployeesAllowed: number
    enableJivoChat: boolean
    repTimesDb1Enable: boolean
    repTimesDb1AltName?: string | null
    repTimesDb2Enable: boolean
    repTimesDb2AltName?: string | null
    repTimesDb3Enable: boolean
    repTimesDb3AltName?: string | null
    repTimesDb4Enable: boolean
    repTimesDb4AltName?: string | null
    repTimesDb5Enable: boolean
    repTimesDb5AltName?: string | null
    techDataDb2Enable: boolean
    techDataDb2AltName?: string | null
    techDataDb3Enable: boolean
    techDataDb3AltName?: string | null
    techDataDb4Enable: boolean
    techDataDb4AltName?: string | null
    techDataDb5Enable: boolean
    techDataDb5AltName?: string | null
    warehouseEnabled: boolean
}

export interface AppUserInitialStateResponse {
    /**
     * Идентификатор сотрудника, под которым вошли. Снимок на момент входа — как DisplayName
     * и Position рядом; в токене сотрудника нет, там только логин и станция.
     * @format int32
     */
    employeeId: number
    displayName?: string | null
    position?: string | null
    phone?: string | null
    email?: string | null
    login?: string | null
    permissions?: string[] | null
    orderBusinessRules?: OrderBusinessRulesResponse
}

export interface ArchiveStockRequest {
    archived: boolean
    showInReports: boolean
    showInTransactions: boolean
}

export interface Area {
    /** @format int32 */
    id: number
    title?: string | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
    deleted: boolean
    overlapEvents: boolean
    googleCalendarId?: string | null
}

export interface AreaEmployeesResponse {
    /** @format int32 */
    areaId: number
    employees?: EmployeeBrowseResponse[] | null
}

export interface ArticleResponse {
    /** @format uuid */
    id: string
    name?: string | null
    brands?: BrandResponse[] | null
}

/** Ответ ошибки типа `AssignTaskException`. Код см. в поле `Detail`. */
export interface AssignTaskExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'AssignTaskException'. */
    Title?: 'AssignTaskException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccessDenied` — Only the creator or assignee can assign the task.
     */
    Detail?: AssignTaskErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for assigning a task to an employee. */
export interface AssignTaskRequest {
    /**
     * Employee ID to assign, or null to unassign.
     * @format int32
     */
    assigneeEmployeeId?: number | null
}

/**
 * Represents information about an attachment linked to an order,
 * including file metadata and API paths for accessing the file or its thumbnail.
 */
export interface AttachmentInfoResponse {
    /** The API path to download the full attachment file. */
    imagePath?: string | null
    /** The API path to download the thumbnail version of the attachment. */
    imageThumbnailPath?: string | null
    /** The original name of the attachment file. */
    name?: string | null
    /**
     * The date and time when the attachment was created or uploaded.
     * @format date-time
     */
    creationTime: string
}

export interface AudatexFindTaskResponse {
    tasks?: FindTaskElementResponse[] | null
    /** @format int32 */
    totalCount: number
}

/** Response model that represents the current Audatex integration settings. */
export interface AudatexSettingsResponse {
    /** The username used to authenticate with the Audatex service (if configured). */
    username?: string | null
    /** The password used to authenticate with the Audatex service (if configured). */
    password?: string | null
    /** Indicates whether the Audatex integration is enabled. */
    isEnabled: boolean
}

export interface AutocompleteClientSpareResponse {
    spareName?: string | null
    /** @format date-time */
    timeStamp: string
}

export interface AutocompleteStationSpareResponse {
    spareName?: string | null
    /** @format double */
    cost: number
    /** @format double */
    purchasePrice: number
    measure?: string | null
    catalogNumber?: string | null
    /** @format date-time */
    timeStamp: string
}

export interface AutocompleteWorkResponse {
    workDesc?: string | null
    vehicalDesc?: string | null
    /** @format double */
    normTime: number
    /** @format date-time */
    timeStamp: string
}

export interface BalanceReportFilter {
    /** @format uuid */
    stockId: string
    brandName?: string | null
    productName?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    tagCode?: string | null
    balance: BalanceFilterTypeEnum
}

export interface BalanceReportProductItem {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    productName?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    tagCode?: string | null
    brandName?: string | null
    /** @format double */
    count: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
}

export interface BalanceReportResponse {
    /** @format int32 */
    totalProducts: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVatTotal: number
    /** @format double */
    costTotal: number
    /** @format double */
    sellingPriceNoVatTotal: number
    /** @format double */
    sellingPriceVatTotal: number
    /** @format double */
    sellingPriceTotal: number
    /** @format double */
    profit: number
    products?: BalanceReportProductItem[] | null
}

/** Ответ ошибки типа `BillingException`. Код см. в поле `Detail`. */
export interface BillingExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'BillingException'. */
    Title?: 'BillingException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `CountryNotSupported` — Страна и валюта кабинета не поддерживаются: тарифного плана под них нет.
     * - `BankAccountNotConfigured` — Под страну и валюту кабинета не заведён банковский счёт — выставить счёт не на что.
     * - `OpenInvoiceExists` — У кабинета уже есть неоплаченный счёт.
     * - `TenantNotFound` — Кабинет не найден в биллинге.
     * - `CreationFailed` — Счёт не создался по иной причине; подробности в result.reason.
     * - `BillingUnavailable` — Биллинг временно недоступен: админский API не ответил или отверг запрос.
     */
    Detail?: BillingErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Response model with billing information for the tenant. */
export interface BillingInfoResponse {
    /**
     * Date when the tenant's activation expires (UTC).
     * @format date-time
     */
    activationExpireDateUtc: string
    /** Tenant subscription plan. */
    plan: TenantSubscriptionPlanEnum
    /** Tenant contract status. */
    contractStatus: TenantContractStatusEnum
    /**
     * Date when the contract was concluded (UTC).
     * @format date-time
     */
    contractDateUtc?: string | null
    /** Contract number. */
    contractNo?: string | null
    /**
     * Contract discount percentage (0-100).
     * @format int32
     */
    contractDiscount?: number | null
    /** List of branches associated with the tenant. */
    branches?: TenantBranchResponse[] | null
}

/** Response model with pricing information for the tenant's subscription plan. */
export interface BillingPricingResponse {
    /**
     * Price per month.
     * @format double
     */
    price: number
    /** Currency code (e.g., BYN, USD, EUR). */
    currency?: string | null
    /** Available discounts for different subscription periods. */
    discounts?: PricingDiscountResponse[] | null
}

/** Response model with billing settings for the tenant. */
export interface BillingSettingsResponse {
    /** Whether to send email notifications for invoices. */
    sendEmailEnabled: boolean
    /** Email address to send invoice notifications to. */
    sendEmailTo?: string | null
    /** Whether to create invoices automatically. */
    createInvoicesAutomatically: boolean
    /**
     * Number of days before subscription end to create invoice automatically.
     * @format int32
     */
    createInvoicesBeforeInDays: number
    /**
     * Billing period in months (1-12).
     * @format int32
     */
    billingPeriodInMonths: number
}

/**
 * Response model representing a client listed in the blacklist.
 * Contains display information, reason, and metadata about the blacklist entry.
 */
export interface BlackListClientResult {
    /** The display-friendly name of the client (e.g., full name or company name). */
    displayName?: string | null
    /** The reason why the client was added to the blacklist. */
    reason?: string | null
    /**
     * The date and time when the client was marked as blacklisted.
     * @format date-time
     */
    markedDate: string
    matchType: BlackListMatchType
}

/**
 * Ответ ошибки типа `BranchTenantNotAllowedException`. Код см. в поле `Detail`.
 *
 * Exception thrown when trying to access billing operations from a branch tenant. Billing operations are only allowed for main tenants.
 */
export interface BranchTenantNotAllowedExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'BranchTenantNotAllowedException'. */
    Title?: 'BranchTenantNotAllowedException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BranchTenantNotAllowed` — Billing operations are not allowed for a branch tenant; result contains tenantId and parentTenantId.
     */
    Detail?: BranchTenantNotAllowedErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface BrandResponse {
    name?: string | null
    article?: string | null
    description?: string | null
    part?: PartResponse
}

export interface BrowseCampaignResponse {
    /** @format int32 */
    id: number
    status: SmsCampaignStatusResponse
    title?: string | null
    message?: string | null
    isInstant: boolean
    /** @format date-time */
    scheduleDate?: string | null
    /** @format int32 */
    selectedSavedRecipientListId?: number | null
    errorMessage?: string | null
}

export interface BrowseCampaignResponsePaginatedCollection {
    page?: BrowseCampaignResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

/** Response model for a task bucket. */
export interface BucketResponse {
    /**
     * Bucket ID.
     * @format int32
     */
    id: number
    /** Display name of the bucket. */
    name?: string | null
    /** Lexorank position string for ordering. */
    position?: string | null
    /**
     * Number of tasks in this bucket.
     * @format int32
     */
    taskCount: number
    /**
     * When the bucket was created (UTC).
     * @format date-time
     */
    createdAt: string
    /**
     * When the bucket was last modified (UTC).
     * @format date-time
     */
    modifiedAt: string
}

export interface BulkDeleteIncomeDocumentRequest {
    ids?: string[] | null
}

export interface BulkDeleteOutcomeDocumentRequest {
    ids?: string[] | null
}

export interface BulkDeleteTransferDocumentRequest {
    ids?: string[] | null
}

export interface BuyerReferenceResponse {
    buyerId?: string | null
    buyerName?: string | null
}

export interface CalculateInvoiceCostForClientResponse {
    /** @format double */
    pricePerMonth: number
    /** @format int32 */
    months: number
    currency?: string | null
    /** @format double */
    periodDiscountPercent: number
    /** @format double */
    periodDiscountAmount: number
    /** @format double */
    tenantCost: number
    /** @format double */
    tenantDiscountPercent: number
    /** @format double */
    tenantDiscountAmount: number
    branchesSummary?: InvoiceBranchesSummaryResponse
    /** @format double */
    totalCost: number
    /** @format double */
    totalDiscountAmount: number
}

export interface CalendarReportItemResponse {
    date?: string | null
    title?: string | null
    description?: string | null
    employeeName?: string | null
    carName?: string | null
    clientName?: string | null
    status: EventStatusEnum
    /** @format double */
    wksCostTotal: number
    /** @format double */
    sprCostTotal: number
    type: EventTypeEnum
}

export interface CalendarReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    statusIds?: EventStatusEnum[] | null
    /** @format int32 */
    employeeId?: number | null
    showFullDetails: boolean
    eventTypes?: EventTypeEnum[] | null
    showArchived: boolean
    sortCol?: string | null
    sortAsc: boolean
}

export interface CalendarReportResponse {
    /** @format int32 */
    count: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    sprCostTotal: number
    reportsDetailed?: CalendarReportItemResponse[] | null
    reportsSummary?: CalendarReportItemResponse[] | null
}

/** Response model that represents the current calendar settings. */
export interface CalendarSettingsResponse {
    /** A collection of working areas (e.g., service areas, departments) configured in the calendar. */
    areas?: Area[] | null
    /**
     * The starting hour of the working day in the calendar. Default is `7`.
     * @format int32
     */
    startHour: number
    /**
     * The ending hour of the working day in the calendar. Default is `22`.
     * @format int32
     */
    endHour: number
    /**
     * The step interval (in minutes) for time slots in the calendar. Default is `30`.
     * @format int32
     */
    step: number
    /** Indicates whether synchronization with Google Calendar is enabled. Default is `false`. */
    enableSyncWithGoogleCalendar: boolean
}

export interface CallHistoryRecordResponse {
    /** @format int32 */
    clientId: number
    clientNumber?: string | null
    direction?: string | null
    startTime?: string | null
    srcNumber?: string | null
    duration?: string | null
    answerTime?: string | null
    uploadTime?: string | null
    srcId?: string | null
    clientName?: string | null
    srcSlot?: string | null
    recording?: string | null
    answered?: string | null
    dbCallId?: string | null
    eventPbxCallId?: string | null
    endTime?: string | null
}

export interface CampaignRecipientResponse {
    /** @format int32 */
    id: number
    clientContact?: SmsContactResponse
    status?: string | null
    phoneNumber?: string | null
    deliveryStatus?: SmsDeliveryStatusResponse
}

export interface CampaignResponse {
    /** @format int32 */
    id: number
    status: SmsCampaignStatusResponse
    title?: string | null
    message?: string | null
    isInstant: boolean
    /** @format date-time */
    scheduleDate?: string | null
    /** @format int32 */
    selectedSavedRecipientListId?: number | null
    errorMessage?: string | null
    recipients?: CampaignRecipientResponse[] | null
}

/** Ответ ошибки типа `CancelInvoiceException`. Код см. в поле `Detail`. */
export interface CancelInvoiceExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'CancelInvoiceException'. */
    Title?: 'CancelInvoiceException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `InvoiceNotOpen` — Only invoices in 'Open' or 'PartiallyPaid' status can be cancelled; result contains the current status.
     * - `InvoiceNotClientRequested` — Only client-requested invoices can be cancelled.
     * - `InvoiceHasPayments` — The invoice already has payments; result contains paymentsCount. Cancellation requires contacting support.
     */
    Detail?: CancelInvoiceErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for canceling an invoice. */
export interface CancelInvoiceRequest {
    /** Cancellation reason comment */
    comment?: string | null
}

export interface CarDashboardResponse {
    data?: CarResponse[] | null
    /** @format int32 */
    count: number
}

/**
 * Response model that represents detailed specifications of a car.
 * Typically used for displaying car information in UI or client applications.
 */
export interface CarDetailsResponse {
    /** A user-friendly display name for the car (e.g., "BMW 320d 2018"). */
    displayName?: string | null
    /** The manufacturer (make) of the car (e.g., BMW, Toyota). */
    manufacturer?: string | null
    /** The model of the car (e.g., 320d, Corolla). */
    model?: string | null
    /** The manufacturing year of the car. */
    year?: string | null
    /** The engine capacity in liters (e.g., "2.0"). */
    engineLitres?: string | null
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    fuelType?: FuelTypeEnum
}

export interface CarDuplicatesResponse {
    exists: boolean
    duplicates?: CarResponse[] | null
}

export interface CarFilterItemResponse {
    /** @format int32 */
    carId: number
    regNo?: string | null
    bodyNo?: string | null
    bodyNo2?: string | null
    shortTitle?: string | null
}

export interface CarModificationResponse {
    modificationId?: string | null
    displayName?: string | null
    manufacture?: string | null
    model?: string | null
    engineLitres?: string | null
    fuelTypeId: FuelTypeEnum
    yearsRange?: string | null
    repDb: RepTimesDbEnum
}

/**
 * Response model that represents a preview of car information.
 * Used for listing cars with essential details while omitting full specifications.
 */
export interface CarPreviewResponse {
    /**
     * The unique identifier of the car.
     * @format int32
     */
    id: number
    /**
     * The identifier of the car owner.
     * @format int32
     */
    ownerId: number
    /**
     * The current mileage of the car.
     * @format int32
     */
    mileage?: number | null
    /** A user-friendly name or alias for the car. */
    friendlyName?: string | null
    /** The manufacturing year of the car (optional). */
    year?: string | null
    /** The registration number (license plate) of the car (optional). */
    regNo?: string | null
    /** The primary body (chassis) number of the car (optional). */
    bodyNo?: string | null
    /** An alternative body (chassis) number of the car (optional). */
    bodyNo2?: string | null
    /** The manufacturer (make) of the car (optional). */
    manufacturer?: string | null
    /** The model of the car (optional). */
    model?: string | null
    /**
     * The engine capacity in liters (optional).
     * @format float
     */
    engineLitres?: number | null
    fuelType?: FuelTypeEnum
    vehicleType: VehicleTypeEnum
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    /** Additional notes or annotations for the car. */
    annotation?: string | null
    /**
     * The identifier for the first repair times database entry (optional).
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** The value/description for the first repair times database entry (optional). */
    repTimesDb1Value?: string | null
    /**
     * The identifier for the second repair times database entry (optional).
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** The value/description for the second repair times database entry (optional). */
    repTimesDb2Value?: string | null
    /** The identifier for the third repair times database entry (optional). */
    repTimesDb3Id?: string | null
    /** The value/description for the third repair times database entry (optional). */
    repTimesDb3Value?: string | null
    /** The identifier for the fourth repair times database entry (optional). */
    repTimesDb4Id?: string | null
    /** The value/description for the fourth repair times database entry (optional). */
    repTimesDb4Value?: string | null
    /** The identifier for the fifth repair times database entry (optional). */
    repTimesDb5Id?: string | null
    /** The value/description for the fifth repair times database entry (optional). */
    repTimesDb5Value?: string | null
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    owner?: ClientResponse
    /** A list of tags associated with the car (optional). */
    tags?: TagResponse[] | null
    /**
     * The date and time when the client record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the client record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

export interface CarPreviewResponsePaginatedCollection {
    page?: CarPreviewResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface CarRecycleBinMetadata {
    displayName?: string | null
    regNo?: string | null
    manufacturer?: string | null
    model?: string | null
}

/** Response model that represents detailed information about a car. */
export interface CarResponse {
    /**
     * The unique identifier of the car.
     * @format int32
     */
    id: number
    /** A user-friendly name or alias for the car. */
    friendlyName?: string | null
    /**
     * The identifier of the car owner.
     * @format int32
     */
    ownerId: number
    /**
     * The current mileage of the car.
     * @format int32
     */
    mileage?: number | null
    /** The manufacturing year of the car. */
    year?: string | null
    /** The registration number (license plate) of the car. */
    regNo?: string | null
    /** The primary body (chassis) number of the car. */
    bodyNo?: string | null
    /** An alternative body (chassis) number of the car. */
    bodyNo2?: string | null
    /** The manufacturer (make) of the car. */
    manufacturer?: string | null
    /** The model of the car. */
    model?: string | null
    /**
     * The engine capacity in liters.
     * @format float
     */
    engineLitres?: number | null
    fuelType?: FuelTypeEnum
    vehicleType: VehicleTypeEnum
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    /** Additional notes or annotations for the car. */
    annotation?: string | null
    /**
     * The identifier for the first repair times database entry.
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** The value/description for the first repair times database entry. */
    repTimesDb1Value?: string | null
    /**
     * The identifier for the second repair times database entry.
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** The value/description for the second repair times database entry. */
    repTimesDb2Value?: string | null
    /** The identifier for the third repair times database entry. */
    repTimesDb3Id?: string | null
    /** The value/description for the third repair times database entry. */
    repTimesDb3Value?: string | null
    /** The identifier for the fourth repair times database entry. */
    repTimesDb4Id?: string | null
    /** The value/description for the fourth repair times database entry. */
    repTimesDb4Value?: string | null
    /** The identifier for the fifth repair times database entry. */
    repTimesDb5Id?: string | null
    /** The value/description for the fifth repair times database entry. */
    repTimesDb5Value?: string | null
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    owner?: ClientResponse
    /** A list of tags associated with the car. */
    tags?: TagResponse[] | null
    /**
     * The date and time when the car record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the car record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

export interface CarSnapshotDataResponse {
    regNo?: string | null
    bodyNo?: string | null
    friendlyName?: string | null
    manufacturer?: string | null
    model?: string | null
    year?: string | null
    /** @format float */
    engineLitres?: number | null
    fuelType?: string | null
    transmission?: string | null
    /** @format int32 */
    mileage: number
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    owner?: EntityReferenceSnapshotResponse
    /** @format int32 */
    repTimesDb1Id?: number | null
    repTimesDb1Value?: string | null
    /** @format int32 */
    repTimesDb2Id?: number | null
    repTimesDb2Value?: string | null
    repTimesDb3Id?: string | null
    repTimesDb3Value?: string | null
    repTimesDb4Id?: string | null
    repTimesDb4Value?: string | null
    repTimesDb5Id?: string | null
    repTimesDb5Value?: string | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface CarSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: CarSnapshotDataResponse
}

/** Card payment form data used by the client to submit a payment to the gateway. */
export interface CardPaymentInfoResponse {
    /**
     * Payment gateway merchant identifier.
     * @format int32
     */
    merchantId: number
    /** Payment form language. */
    language?: string | null
    /** Order number (e.g., "1234-5"). */
    orderNumber?: string | null
    /** Order amount, formatted with two decimals. */
    orderAmount?: string | null
    /** Order currency code. */
    orderCurrency?: string | null
    /** Order comment / service description. */
    orderComment?: string | null
    /**
     * Payment delay in days.
     * @format int32
     */
    delay: number
    /** Payer email. */
    email?: string | null
    /** Payer mobile phone in E.164 format. */
    mobilePhone?: string | null
    /** Return URL. */
    urlReturn?: string | null
    /** Return URL on successful payment. */
    urlReturnOk?: string | null
    /** Return URL on cancelled payment. */
    urlReturnNo?: string | null
    /** Card payment flag. */
    cardPayment?: string | null
    /** Whether the gateway runs in test mode. */
    testMode: boolean
    /** Secret used to sign the payment form. */
    secret?: string | null
    /** Gateway form action URL. */
    formAction?: string | null
}

export interface CashboxPaymentResponse {
    /** @format uuid */
    id: string
    /** @format uuid */
    cashBoxId: string
    client?: PaymentClientResponse
    /** @format date-time */
    paymentDate: string
    /** @format uuid */
    parentPaymentId?: string | null
    /** @format uuid */
    paymentCategoryId?: string | null
    email?: string | null
    comment?: string | null
    /** @format double */
    amount: number
    paymentType: PaymentTypeEnum
    isFullPayment?: boolean | null
    isCanceled: boolean
    isReturned: boolean
    deleted: boolean
    createdBy?: string | null
    modifiedBy?: string | null
    payments?: CashboxTransactionResponse[] | null
    documentReference?: DocumentReferenceResponse
}

export interface CashboxPaymentResponsePaginatedCollection {
    page?: CashboxPaymentResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface CashboxResponse {
    /** @format uuid */
    id: string
    title?: string | null
    defaultCurrency: CurrencyCodeEnum
    cashboxType: CashBoxTypeEnum
    hidden: boolean
    username?: string | null
    password?: string | null
    isArchive: boolean
    /** @format double */
    balance?: number | null
    /** @format int32 */
    integrationId?: number | null
    /** @format date-time */
    createdAt: string
    createdBy?: string | null
    /** @format date-time */
    modifiedAt: string
    modifiedBy?: string | null
    balances?: CashboxTransactionResponse[] | null
}

export interface CashboxTransactionResponse {
    method: PaymentMethodEnum
    /** @format double */
    amount: number
}

export interface CatalogBarcodeItem {
    code?: string | null
    description?: string | null
}

export interface CatalogCostChangeItem {
    internalCode?: string | null
    changedBy?: string | null
    /** @format date-time */
    changedAt: string
    /** @format double */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    discount: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
    costRevaluationDocRef?: CatalogDocumentRef
}

export interface CatalogDocumentRef {
    /** @format uuid */
    documentId: string
    documentNo?: string | null
    documentType?: string | null
}

/** Ответ ошибки типа `CatalogImportException`. Код см. в поле `Detail`. */
export interface CatalogImportExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'CatalogImportException'. */
    Title?: 'CatalogImportException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `NoFiles` — Файлы не переданы.
     * - `FileReadFailed` — Не удалось прочитать файл или распаковать архив; подробности — в result.details.
     * - `ParseFailed` — Не удалось разобрать файл импорта; подробности — в result.details.
     */
    Detail?: CatalogImportErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface CatalogOecodeItem {
    code?: string | null
    description?: string | null
}

export interface CatalogProductResponse {
    /** @format uuid */
    productId: string
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    name?: string | null
    printName?: string | null
    catalogCode?: string | null
    vendorCode?: string | null
    internalCode?: string | null
    tagCode?: string | null
    measure?: string | null
    description?: string | null
    brandName?: string | null
    country?: string | null
    comment?: string | null
    /** @format double */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    discount: number
    /** @format double */
    minBalance: number
    /** @format double */
    weight: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
    supplierRef?: CatalogSupplierRef
    costChanges?: CatalogCostChangeItem[] | null
    barcodeList?: CatalogBarcodeItem[] | null
    oecodeList?: CatalogOecodeItem[] | null
}

export interface CatalogProductResponsePagedResult {
    page?: CatalogProductResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

/** Ответ ошибки типа `CatalogProductTagException`. Код см. в поле `Detail`. */
export interface CatalogProductTagExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'CatalogProductTagException'. */
    Title?: 'CatalogProductTagException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ProductIdsEmpty` — Список идентификаторов товаров пуст.
     * - `BadTagCode` — Код тега ссылается на несуществующую категорию каталога.
     */
    Detail?: CatalogProductTagErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface CatalogSupplierRef {
    /** @format uuid */
    supplierId: string
    supplierName?: string | null
    supplierUnp?: string | null
}

/** Ответ ошибки типа `CategoryTagException`. Код см. в поле `Detail`. */
export interface CategoryTagExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'CategoryTagException'. */
    Title?: 'CategoryTagException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `CategoryNotFound` — Корневая категория каталога не найдена.
     * - `ParentTagNotFound` — Родительский тег (ParentCode из тела запроса) не найден.
     * - `RootTagCannotBeDeleted` — Корневой тег категории нельзя удалить.
     * - `MoveNotAllowed` — Перемещение тега недопустимо; причина — в result.reason.
     */
    Detail?: CategoryTagErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `ChangePasswordException`. Код см. в поле `Detail`. */
export interface ChangePasswordExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ChangePasswordException'. */
    Title?: 'ChangePasswordException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadTokenCredentials` — Неверный app token
     * - `BadNewPassword_MustBeDifferentFromOldPassword` — Новый пароль совпадает со старым
     * - `BadNewPassword_MustMatchToConfirmPassword` — Подтверждение пароля не совпадает
     * - `BadOldPassword_Incorrect` — Неверный старый пароль
     */
    Detail?: ChangePasswordErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface ChangeProductCostRequest {
    /** @format double */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    discount: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
    costRevaluationDocRef?: CatalogDocumentRef
}

export interface ChangeProductTagRequest {
    /** @minLength 1 */
    tagCode: string
}

export interface ChangeProductsTagRequest {
    productIds: string[]
    /** @minLength 1 */
    tagCode: string
}

/** Request model for changing a task's status. */
export interface ChangeTaskStatusRequest {
    /** Task status values. */
    status: TaskStatusEnum
}

/** Represents a request to change a user's password. */
export interface ChangeUserPasswordRequest {
    /** Application token for authorization or identification. */
    appToken: string | null
    /** Current (old) password of the user. */
    oldPassword: string | null
    /** New password the user wants to set. */
    newPassword: string | null
    /**
     * Confirmation of the new password.
     * Must match Cardone.Web.PlatformApiCore.Features.Account.Models.ChangeUserPasswordRequest.NewPassword.
     */
    newPasswordConfirm: string | null
}

export interface CheckCarDuplicatesRequest {
    /** @format int32 */
    id?: number | null
    regNo?: string | null
    bodyNo?: string | null
}

export interface CheckClientDuplicatesRequest {
    clientId?: string | null
    displayName?: string | null
    address?: string | null
    phones?: string[] | null
    unp?: string | null
}

export interface CheckVerificationSmsRequest {
    verificationSid?: string | null
    code?: string | null
}

export interface CleanupClientsResponse {
    /** @format int32 */
    clientId: number
    clientName?: string | null
}

export interface CleanupResponse {
    clients?: CleanupClientsResponse[] | null
    /** @format int32 */
    totalClients: number
    vehicles?: CleanupVehiclesResponse[] | null
    /** @format int32 */
    totalVehicles: number
}

export interface CleanupVehiclesResponse {
    /** @format int32 */
    vehicleId: number
    vehicleName?: string | null
}

export interface ClientAbsenceResponse {
    /** @format int32 */
    id: number
    displayName?: string | null
    clientTypeCode: ClientTypeEnum
    /** @format int32 */
    ordersCount: number
    /** @format double */
    totalSum: number
    /** @format date-time */
    lastOrderDate: string
    contacts?: ClientContactResponse[] | null
}

export interface ClientAbsenceResponsePaginatedCollection {
    page?: ClientAbsenceResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface ClientCommonReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    documentOptions?: DocumentKindEnum[] | null
    clientType: OrderClientType
    /** @format int32 */
    clientId?: number | null
    /** @format double */
    costFrom: number
    /** @format double */
    costTo: number
    isNewClients: boolean
    manufactures?: string[] | null
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ClientCommonReportResult {
    /** @format int32 */
    orderTotalCount: number
    /** @format int32 */
    vehiclesCount: number
    /** @format double */
    wksDiscountAmountSum: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    wksProfitSum: number
    /** @format double */
    ctrProfitSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    ttlProfitSum: number
    /** @format double */
    wksCostNoVatSum: number
    /** @format double */
    ctrCostNoVatSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    wksCostVatSum: number
    /** @format double */
    ctrCostVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    wksCostTotalSum: number
    /** @format double */
    ctrCostTotalSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    discountWksClientSum: number
    /** @format double */
    discountWksCarSum: number
    /** @format double */
    discountWksTtlSum: number
    /** @format double */
    discountSprTtlSum: number
    /** @format double */
    discountYearSum: number
    /** @format double */
    wksNormsTotalSum: number
    /** @format double */
    cspCostTotalSum: number
    clients?: ClientsPersonalCommonResult[] | null
}

/** Request model for adding or updating a client contact. */
export interface ClientContactRequest {
    /**
     * The unique identifier of the contact (used for updates).
     * @format int32
     */
    id: number
    /**
     * The identifier of the client to whom this contact belongs.
     * @format int32
     */
    clientId: number
    /** The full name of the contact person (optional). */
    fullName?: string | null
    /** A label or description for the contact (e.g., "Director", "Assistant"). */
    label?: string | null
    /** The phone number of the contact. */
    phone?: string | null
    /** Indicates whether SMS messages are allowed for this contact. */
    allowSms: boolean
    /**
     * The position/order of the contact in the client’s contact list.
     * @format int32
     */
    position: number
    /** Indicates whether the contact is available on Viber. */
    isViber: boolean
    /** Indicates whether the contact is available on WhatsApp. */
    isWhatsApp: boolean
}

/**
 * Response model representing a client's contact information.
 * Contains details about the contact person, communication channels, and preferences.
 */
export interface ClientContactResponse {
    /**
     * The unique identifier of the contact record.
     * @format int32
     */
    id: number
    /**
     * The identifier of the client this contact belongs to.
     * @format int32
     */
    clientId: number
    /** The full name of the contact person (optional). */
    fullName?: string | null
    /** A label or role for the contact (e.g., "Director", "Accountant") (optional). */
    label?: string | null
    /** Indicates whether the contact is available on Viber. */
    isViber: boolean
    /** Indicates whether the contact is available on WhatsApp. */
    isWhatsApp: boolean
    /** The phone number of the contact (optional). */
    phone?: string | null
    /** Indicates whether the contact has allowed receiving SMS notifications. */
    allowSms: boolean
    /**
     * The display order or position of the contact within the client's contact list.
     * @format int32
     */
    position: number
}

export interface ClientContactSnapshotResponse {
    fullName?: string | null
    label?: string | null
    phone?: string | null
    allowSms: boolean
    /** @format int32 */
    position: number
    isViber: boolean
    isWhatsApp: boolean
}

export interface ClientDashboardResponse {
    data?: ClientPreviewResponse[] | null
    /** @format int32 */
    count: number
}

export interface ClientDuplicatesResponse {
    exists: boolean
    duplicates?: ClientResponse[] | null
}

export interface ClientErrorResponse {
    detail: ClientErrorCode
}

/**
 * Response model representing a simplified client entry,
 * typically used for filtering, dropdowns, or quick search results.
 */
export interface ClientFilterItemResponse {
    /**
     * The unique identifier of the client.
     * @format int32
     */
    id: number
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName: string | null
}

/**
 * Response model representing a preview of client information.
 * Used for listing clients with key attributes and related data.
 */
export interface ClientPreviewResponse {
    /**
     * The unique identifier of the client.
     * @format int32
     */
    id: number
    clientTypeCode: ClientTypeEnum
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName?: string | null
    /** The email address of the client (optional). */
    email?: string | null
    /** The Telegram contact of the client (optional). */
    telegram?: string | null
    /** The street address of the client (optional). */
    streetAddress?: string | null
    /** Additional notes or annotations about the client (optional). */
    annotation?: string | null
    /**
     * The general discount percentage applied to the client’s services.
     * @format int32
     */
    discountWorks: number
    /**
     * The discount percentage applied to spare parts.
     * @format int32
     */
    discountSpares: number
    /** The discount card number associated with the client (optional). */
    discountCard?: string | null
    /** Indicates whether the client is a resident (optional). */
    resident?: boolean | null
    /** The client’s birthday (optional). */
    birthday?: string | null
    /** Indicates whether the client requires follow-up calls. */
    isNeedCall: boolean
    /** Marks the client as a favorite. */
    isFavorite: boolean
    /** Indicates whether the client is marked as trusted. */
    isTrusted: boolean
    /** Indicates whether SMS notifications are disabled for this client. */
    banSms: boolean
    /** The description or reason for disabling SMS notifications (optional). */
    banSmsDescription?: string | null
    countryCode: CountryEnum
    /** The unique taxpayer identification number (UNP) of the client (optional). */
    unp?: string | null
    /** Custom property 2 (for extended data). */
    prop2?: string | null
    /** Custom property 3 (for extended data). */
    prop3?: string | null
    /** Client contacts */
    contacts?: ClientContactResponse[] | null
    /**
     * The date and time when the client record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the client record was last modified.
     * @format date-time
     */
    modifiedAt: string
    modifiedBy?: string | null
}

export interface ClientPreviewResponsePaginatedCollection {
    page?: ClientPreviewResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface ClientRecycleBinMetadata {
    displayName?: string | null
    clientTypeCode?: string | null
    email?: string | null
}

/**
 * Response model representing detailed client information.
 * Provides full data about a client, including contacts, banking details, discounts, and metadata.
 */
export interface ClientResponse {
    /**
     * The unique identifier of the client.
     * @format int32
     */
    id: number
    clientTypeCode: ClientTypeEnum
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName?: string | null
    /** The email address of the client (optional). */
    email?: string | null
    /** The Skype contact of the client (optional). */
    skype?: string | null
    /** The Telegram contact of the client (optional). */
    telegram?: string | null
    /** The street address of the client (optional). */
    streetAddress?: string | null
    /** Additional notes or annotations about the client (optional). */
    annotation?: string | null
    /** The name of the bank associated with the client (optional). */
    bank?: string | null
    /** The bank code (e.g., SWIFT or local code) (optional). */
    bankCode?: string | null
    /** The bank account number of the client (optional). */
    bankAccount?: string | null
    /** The address of the client’s bank (optional). */
    bankAddress?: string | null
    /** The full name of the company director (optional). */
    director?: string | null
    /** The full name of the company accountant (optional). */
    accountant?: string | null
    /**
     * The general discount percentage applied to the client’s services.
     * @format int32
     */
    discountWorks: number
    /**
     * The discount percentage applied to spare parts.
     * @format int32
     */
    discountSpares: number
    /** The discount card number associated with the client (optional). */
    discountCard?: string | null
    /** Indicates whether the client is a resident (optional). */
    resident?: boolean | null
    /** The client’s birthday (optional). */
    birthday?: string | null
    /** Indicates whether the client requires follow-up calls. */
    isNeedCall: boolean
    /** Marks the client as a favorite. */
    isFavorite: boolean
    /** Indicates whether the client is marked as trusted. */
    isTrusted?: boolean | null
    /** The contract identifier associated with the client (optional). */
    contract?: string | null
    /** The contract start date (optional). */
    contractDate?: string | null
    /** The contract end date (optional). */
    contractEndDate?: string | null
    /** The legal basis for the contract (optional). */
    based?: string | null
    /** Indicates whether SMS notifications are disabled for this client. */
    banSms: boolean
    /** The description or reason for disabling SMS notifications (optional). */
    banSmsDescription?: string | null
    /**
     * The rate number associated with the client.
     * @format int32
     */
    rateNumber?: number | null
    countryCode: CountryEnum
    /** The unique taxpayer identification number (UNP) of the client (optional). */
    unp?: string | null
    /** Custom property 2 (for extended data). */
    prop2?: string | null
    /** Custom property 3 (for extended data). */
    prop3?: string | null
    /** A list of contact persons associated with the client. */
    contacts?: ClientContactResponse[] | null
    /** A list of tags associated with the client. */
    tags?: TagResponse[] | null
    /** A list of sources from which the client was acquired. */
    sources?: SourceResponse[] | null
    /**
     * The date and time when the client record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the client record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

export interface ClientSnapshotDataResponse {
    clientTypeCode?: string | null
    countryCode?: string | null
    displayName?: string | null
    annotation?: string | null
    birthday?: string | null
    email?: string | null
    skype?: string | null
    telegram?: string | null
    streetAddress?: string | null
    /** @format int32 */
    discount: number
    /** @format int32 */
    discountParts: number
    discountCard?: string | null
    unp?: string | null
    bank?: string | null
    bankCode?: string | null
    bankAccount?: string | null
    bankAddress?: string | null
    director?: string | null
    accountant?: string | null
    contacts?: ClientContactSnapshotResponse[] | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface ClientSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: ClientSnapshotDataResponse
}

export interface ClientSpareSnapshotResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    position: number
    name?: string | null
    /** @format double */
    count: number
    measure?: string | null
    /** @format double */
    price: number
    catalogNumber?: string | null
    condition?: string | null
}

export interface ClientSparesReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    documentOptions?: DocumentKindEnum[] | null
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ClientSparesReportResponse {
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    wksNormsTotalSum: number
    /** @format double */
    wksCostNoVatSum: number
    /** @format double */
    wksCostVatSum: number
    /** @format double */
    wksCostTotalSum: number
    /** @format double */
    wksDiscountAmountSum: number
    /** @format double */
    wksProfitSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    ctrCostNoVatSum: number
    /** @format double */
    ctrCostVatSum: number
    /** @format double */
    ctrCostTotalSum: number
    /** @format double */
    ctrProfitSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    ttlProfitSum: number
    orders?: OrderStationReportResponse[] | null
}

export interface ClientStationReportResponse {
    /**
     * The unique identifier of the client.
     * @format int32
     */
    id: number
    clientTypeCode: ClientTypeEnum
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName?: string | null
    /** The email address of the client (optional). */
    email?: string | null
    /** The Skype contact of the client (optional). */
    skype?: string | null
    /** The Telegram contact of the client (optional). */
    telegram?: string | null
    /** The street address of the client (optional). */
    streetAddress?: string | null
    /** Additional notes or annotations about the client (optional). */
    annotation?: string | null
    /** The name of the bank associated with the client (optional). */
    bank?: string | null
    /** The bank code (e.g., SWIFT or local code) (optional). */
    bankCode?: string | null
    /** The bank account number of the client (optional). */
    bankAccount?: string | null
    /** The address of the client’s bank (optional). */
    bankAddress?: string | null
    /** The full name of the company director (optional). */
    director?: string | null
    /** The full name of the company accountant (optional). */
    accountant?: string | null
    /**
     * The general discount percentage applied to the client’s services.
     * @format int32
     */
    discountWorks: number
    /**
     * The discount percentage applied to spare parts.
     * @format int32
     */
    discountSpares: number
    /** The discount card number associated with the client (optional). */
    discountCard?: string | null
    /** Indicates whether the client is a resident (optional). */
    resident?: boolean | null
    /** The client’s birthday (optional). */
    birthday?: string | null
    /** Indicates whether the client requires follow-up calls. */
    isNeedCall: boolean
    /** Marks the client as a favorite. */
    isFavorite: boolean
    /** Indicates whether the client is marked as trusted. */
    isTrusted?: boolean | null
    /** The contract identifier associated with the client (optional). */
    contract?: string | null
    /** The contract start date (optional). */
    contractDate?: string | null
    /** The contract end date (optional). */
    contractEndDate?: string | null
    /** The legal basis for the contract (optional). */
    based?: string | null
    /** Indicates whether SMS notifications are disabled for this client. */
    banSms: boolean
    /** The description or reason for disabling SMS notifications (optional). */
    banSmsDescription?: string | null
    /**
     * The rate number associated with the client.
     * @format int32
     */
    rateNumber?: number | null
    countryCode: CountryEnum
    /** The unique taxpayer identification number (UNP) of the client (optional). */
    unp?: string | null
    /** Custom property 2 (for extended data). */
    prop2?: string | null
    /** Custom property 3 (for extended data). */
    prop3?: string | null
    /** A list of contact persons associated with the client. */
    contacts?: ClientContactResponse[] | null
    /**
     * The date and time when the client record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the client record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

export interface ClientsPersonalCommonResult {
    /** @format int32 */
    orderTotalCount: number
    /** @format int32 */
    vehiclesCount: number
    /** @format double */
    wksDiscountAmountSum: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    wksProfitSum: number
    /** @format double */
    ctrProfitSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    ttlProfitSum: number
    /** @format double */
    wksCostNoVatSum: number
    /** @format double */
    ctrCostNoVatSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    wksCostVatSum: number
    /** @format double */
    ctrCostVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    wksCostTotalSum: number
    /** @format double */
    ctrCostTotalSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    discountWksClientSum: number
    /** @format double */
    discountWksCarSum: number
    /** @format double */
    discountWksTtlSum: number
    /** @format double */
    discountSprTtlSum: number
    /** @format double */
    discountYearSum: number
    /** @format double */
    wksNormsTotalSum: number
    /** @format double */
    cspCostTotalSum: number
    /** @format int32 */
    clientId: number
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    client?: ClientResponse
    orders?: OrderStationReportResponse[] | null
}

export interface ClipboardFileResponse {
    /** @format uuid */
    id: string
    fileName?: string | null
    contentType?: string | null
    /** @format int64 */
    size: number
    tempUrl?: string | null
    /** @format date-time */
    uploadedAtUtc: string
}

export interface ClipboardFolderListResponse {
    folders?: ClipboardFolderSummaryResponse[] | null
    /** @format int32 */
    totalCount: number
}

/**
 * Ответ ошибки типа `ClipboardFolderNotFoundException`. Кодов нет — тип ошибки см. в поле `Title`.
 *
 * Thrown when a clipboard folder cannot be found for the current tenant.
 */
export interface ClipboardFolderNotFoundExceptionProblem {
    /** Всегда 'ResourceNotFoundException'. */
    Type?: 'ResourceNotFoundException'
    /** Discriminator. Всегда 'ClipboardFolderNotFoundException'. */
    Title?: 'ClipboardFolderNotFoundException'
    /** @format int32 */
    Status?: number
    /** Техническое сообщение исключения. Кодов у 404 нет — тип ошибки см. в `Title`. */
    Detail?: string
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface ClipboardFolderResponse {
    /** @format uuid */
    id: string
    name?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAtUtc: string
    /** @format date-time */
    expiresAtUtc: string
    files?: ClipboardFileResponse[] | null
}

export interface ClipboardFolderSummaryResponse {
    /** @format uuid */
    id: string
    name?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAtUtc: string
    /** @format date-time */
    expiresAtUtc: string
    /** @format int32 */
    filesCount: number
}

/** Response model that represents the current organization settings. */
export interface CommonSettingsResponse {
    /** Full legal name of the organization. */
    organizationName: string | null
    /** Brand or trade name of the organization (if different from the legal name). */
    brandName?: string | null
    /** Legal (registered) address of the organization. */
    legalAddress?: string | null
    /** Actual street address of the organization. */
    streetAddress?: string | null
    /** Full name of the organization’s director. */
    directorName?: string | null
    /** The legal basis on which the director acts (e.g., “Charter”, “Power of Attorney”). */
    basedOn?: string | null
    /** The organization’s registration number (UNP / taxpayer identification). */
    unp?: string | null
    /** Additional property 1 (customizable field). */
    prop1?: string | null
    /** Additional property 2 (customizable field). */
    prop2?: string | null
    /** Additional property 3 (customizable field). */
    prop3?: string | null
}

export interface ContactResponse {
    /** @format uuid */
    id: string
    name?: string | null
    phone?: string | null
    email?: string | null
    label?: string | null
}

/** Ответ ошибки типа `ContractException`. Код см. в поле `Detail`. */
export interface ContractExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ContractException'. */
    Title?: 'ContractException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `StationBankAccountIdIsMissing` — StationBankAccountId is required for the contract.
     * - `UsedInDocuments` — Контракт используется в складских документах (приход/расход) — удаление запрещено.
     */
    Detail?: ContractErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface ContractFileListResponse {
    files?: ContractFileResponse[] | null
    /** @format int32 */
    totalCount: number
}

export interface ContractFileResponse {
    /** @format uuid */
    id: string
    fileName?: string | null
    contentType?: string | null
    /** @format int64 */
    size: number
    tempUrl?: string | null
    /** @format date-time */
    createdAtUtc: string
}

export interface ContractListItemResponse {
    /** @format uuid */
    id: string
    contractNo?: string | null
    /** @format uuid */
    stationBankAccountId: string
    /** @format date-time */
    signedAt: string
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate?: string | null
    type: ContractType
    /** @format double */
    workDiscount: number
    /** @format double */
    spareDiscount: number
    /** @format double */
    contractorDiscount: number
    /** @format int32 */
    paymentDeferment: number
    notes?: string | null
    supplierRef?: SupplierReferenceResponse
    buyerRef?: BuyerReferenceResponse
    signedBy?: string | null
    signedByPosition?: string | null
    signedOnBasis?: string | null
    warrantyObligations?: string | null
}

export interface ContractListItemResponsePaginatedCollection {
    page?: ContractListItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface ContractSnapshotDataResponse {
    contractNo?: string | null
    contractType?: string | null
    /** @format date-time */
    signedAt: string
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate?: string | null
    supplierName?: string | null
    buyerName?: string | null
    /** @format double */
    workDiscount: number
    /** @format double */
    spareDiscount: number
    /** @format double */
    contractorDiscount: number
    /** @format int32 */
    paymentDeferment: number
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface ContractSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: ContractSnapshotDataResponse
}

/** Represents contact person details of a contractor. */
export interface ContractorContactResponse {
    /**
     * Unique identifier of the contact.
     * @format int32
     */
    id: number
    /**
     * Identifier of the contractor this contact belongs to.
     * @format int32
     */
    contractorId: number
    /** Full name of the contact person. */
    fullName?: string | null
    /** Phone number of the contact person. */
    phoneNumber?: string | null
}

export interface ContractorReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    documentOptions?: DocumentKindEnum[] | null
    /** @format int32 */
    contractorId?: number | null
    /** @format int32 */
    employeeId?: number | null
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ContractorReportResponse {
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    wksNormsTotalSum: number
    /** @format double */
    wksCostNoVatSum: number
    /** @format double */
    wksCostVatSum: number
    /** @format double */
    wksCostTotalSum: number
    /** @format double */
    wksDiscountAmountSum: number
    /** @format double */
    wksProfitSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    ctrCostNoVatSum: number
    /** @format double */
    ctrCostVatSum: number
    /** @format double */
    ctrCostTotalSum: number
    /** @format double */
    ctrProfitSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    ttlProfitSum: number
    orders?: OrderStationReportResponse[] | null
}

/** Represents contractor details returned in a response. */
export interface ContractorResponse {
    /**
     * Unique identifier of the contractor.
     * @format int32
     */
    id: number
    /** Full legal name of the contractor (organization or individual). */
    fullName?: string | null
    /** Taxpayer Identification Number (TIN) or equivalent company identifier. */
    tin?: string | null
    /** Official address of the contractor. */
    address?: string | null
    /** Website of the contractor, if available. */
    site?: string | null
    /** Additional notes or annotations about the contractor. */
    annotation?: string | null
    /**
     * Date and time when the contractor record was created.
     * @format date-time
     */
    created: string
    /**
     * Date and time when the contractor record was last modified.
     * @format date-time
     */
    modified: string
    /** List of contractor's contact persons with their details. */
    contacts?: ContractorContactResponse[] | null
}

export interface ContractorResponsePaginatedCollection {
    page?: ContractorResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface ContractorWorkSnapshotResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    position: number
    workDesc?: string | null
    /** @format double */
    inputPrice: number
    /** @format double */
    vat: number
    /** @format double */
    costTotal: number
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    contractor?: EntityReferenceSnapshotResponse
}

export interface ContractorsAnalyticalReportResponse {
    summary?: ContractorsSummaryResponse
    raitings?: ContractorsRatingSetResponse
    visits?: ContractorsVisitSetResponse
}

export interface ContractorsAverageBillRatingResponse {
    /** @format int32 */
    clientId: number
    clientName?: string | null
    /** @format double */
    averageBill: number
    /** @format double */
    averageBillPersent: number
}

export interface ContractorsMonthVisitResponse {
    /** @format int32 */
    year: number
    /** @format int32 */
    month: number
    /** @format int32 */
    orderCount: number
}

export interface ContractorsOrdersRatingResponse {
    /** @format int32 */
    clientId: number
    clientName?: string | null
    /** @format int32 */
    orderCount: number
    /** @format double */
    orderPersent: number
}

export interface ContractorsRatingSetResponse {
    ordersRaiting?: ContractorsOrdersRatingResponse[] | null
    repairTimeRaiting?: ContractorsRepairTimeRatingResponse[] | null
    workCostRaiting?: ContractorsWorkCostRatingResponse[] | null
    averageBillRaiting?: ContractorsAverageBillRatingResponse[] | null
}

export interface ContractorsRepairTimeRatingResponse {
    /** @format int32 */
    clientId: number
    clientName?: string | null
    /** @format double */
    normTimeTotalSum: number
    /** @format double */
    normTimePersent: number
}

export interface ContractorsSummaryResponse {
    /** @format int32 */
    clientTotalCount: number
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    orderNormTimeGrandTotalSum: number
    /** @format double */
    orderWorkCostGrandTotalSum: number
    /** @format double */
    orderWorkCostGrandTotalSumByCash: number
    /** @format double */
    orderWorkCostGrandTotalSumByCashless: number
}

export interface ContractorsVisitSetResponse {
    weekdayVisit?: ContractorsWeekdayVisitResponse[] | null
    monthVisit?: ContractorsMonthVisitResponse[] | null
}

export interface ContractorsWeekdayVisitResponse {
    /** @format int32 */
    dayOfWeek: number
    /** @format int32 */
    orderCount: number
}

export interface ContractorsWorkCostRatingResponse {
    /** @format int32 */
    clientId: number
    clientName?: string | null
    /** @format double */
    workTotalCostSum: number
    /** @format double */
    workTotalCostPersent: number
}

/** Ответ ошибки типа `CopyStorageLocationsException`. Код см. в поле `Detail`. */
export interface CopyStorageLocationsExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'CopyStorageLocationsException'. */
    Title?: 'CopyStorageLocationsException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `SourceStockNotFound` — The source stock was not found; result contains sourceStockId.
     * - `SourceAndTargetStocksMustBeDifferent` — The source and the target stocks must be different.
     */
    Detail?: CopyStorageLocationsErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for creating a new bucket. */
export interface CreateBucketRequest {
    /** Display name of the bucket. Required, max 200 characters. */
    name?: string | null
}

/** Response returned after creating a bucket. */
export interface CreateBucketResponse {
    /**
     * Primary key of the created bucket.
     * @format int32
     */
    id: number
}

export interface CreateCustomerWorksListItemRequest {
    name?: string | null
}

export interface CreateInvoiceForClientResponse {
    /** @format int32 */
    invoiceId: number
    /** @format int32 */
    months: number
    /** @format double */
    totalCost: number
}

/** Request model for creating an invoice. */
export interface CreateInvoiceRequest {
    /**
     * Number of months for the subscription (1-12).
     * @format int32
     */
    months: number
    /** Optional comment for the invoice. */
    comment?: string | null
}

/** Request model for creating a new note. */
export interface CreateNoteRequest {
    /** The description of the note. */
    description?: string | null
    /** Indicates whether the note is visible to all users, if false the note is personal (visible only to the owner) */
    isPublic: boolean
    /** Indicates whether the note should be pinned to the top of the list. */
    isPinned: boolean
}

/** Request model for creating a new storage location. */
export interface CreateStorageLocationRequest {
    /** Unique code/identifier for the storage location (e.g., "A-01", "B-15"). */
    code?: string | null
    /** Additional notes or description. */
    comment?: string | null
}

export interface CreateStorageLocationResponse {
    /** @format uuid */
    storageLocationId: string
}

/** Request model for creating a new task. */
export interface CreateTaskRequest {
    /** Short title of the task. Required, max 500 characters. */
    title?: string | null
    /** Optional detailed description. Max 2000 characters. */
    description?: string | null
    /**
     * Optional employee to assign the task to.
     * @format int32
     */
    assigneeEmployeeId?: number | null
    /** Represents the resource types that can be associated with a task. */
    resourceType?: TaskResourceTypeEnum
    /** Optional resource identifier the task is associated with. */
    resourceId?: string | null
    /**
     * Optional due date (UTC).
     * @format date-time
     */
    dueDate?: string | null
}

/** Response returned after creating a task. */
export interface CreateTaskResponse {
    /**
     * Primary key of the created task.
     * @format int32
     */
    id: number
}

/** Request model for creating a new Telemost promotion. */
export interface CreateTelemostPromotionRequest {
    /** Title of the promotion. */
    title?: string | null
    /** Detailed description of the promotion (optional). */
    description?: string | null
    /**
     * Date when the promotion expires (optional, null = no expiration).
     * @format date-time
     */
    expirationDate?: string | null
    /** Whether the promotion is active and should be displayed. */
    isActive: boolean
}

/** Request model for creating a new team member. */
export interface CreateTelemostTeamMemberRequest {
    /** Full name of the team member (required). */
    displayName?: string | null
    /** Position/role of the team member (required). */
    position?: string | null
    /** Short biography or description (optional, up to 1000 characters). */
    bio?: string | null
}

export interface CrossResponse {
    partInfo?: PartInfoResponse
}

export interface CustomerWorkSnapshotResponse {
    /** @format int32 */
    id: number
    title?: string | null
}

export interface CustomerWorksListItemResponse {
    /** @format int32 */
    id: number
    name?: string | null
}

export interface CustomerWorksListItemResponsePaginatedCollection {
    page?: CustomerWorksListItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface DataConnectionsResponse {
    orders?: OrderResponse[] | null
    preOrders?: PreOrderDetailsResponse[] | null
    events?: EventResponse[] | null
}

export interface DateTimeNullableRangeValue {
    /** @format date-time */
    from?: string | null
    /** @format date-time */
    to?: string | null
}

export interface Db2ExclusiveWorkTimeRecordResponse {
    /** @format int64 */
    workId: number
    workType?: string | null
    workName?: string | null
    /** @format double */
    originalHours: number
}

export interface Db2ManufactureNodeResponse {
    /** @format int32 */
    id: number
    name?: string | null
    /** @format int32 */
    parentId: number
    models?: Db2ModelNodeResponse[] | null
}

export interface Db2ModelNodeResponse {
    /** @format int32 */
    id: number
    name?: string | null
    /** @format int32 */
    parentId: number
    years?: Db2YearNodeResponse[] | null
}

export interface Db2ModificationTechnicalDetailsResponse {
    /** @format int32 */
    modificationId: number
    modificationName?: string | null
    /** @format int32 */
    yearFrom: number
    /** @format int32 */
    yearTo: number
    bodyType?: string | null
    driveType?: string | null
    /** @format int32 */
    kw: number
    /** @format int32 */
    hp: number
    /** @format int32 */
    capacity: number
    /** @format int32 */
    cylinder: number
    /** @format int32 */
    valvesPerCylinder: number
    engineType?: string | null
    fuelType?: string | null
    fuelSupplyType?: string | null
    brakeSystemType?: string | null
    catalystType?: string | null
}

export interface Db2TechnicalDataCategoryResponse {
    /** @format int32 */
    categoryId: number
    categoryText?: string | null
}

export interface Db2TechnicalDataItemResponse {
    /** @format int32 */
    subCategoryId: number
    subCategoryText?: string | null
    itemText?: string | null
    qualText?: string | null
    valueText?: string | null
    addText?: string | null
    /** @format int32 */
    itemSort: number
    /** @format int32 */
    subCategorySort: number
}

export interface Db2VariantNodeResponse {
    /** @format int32 */
    id: number
    name?: string | null
    /** @format int32 */
    parentId: number
    /** @format int32 */
    modificationId: number
    /** @format int32 */
    typeId: number
    fuel?: string | null
    /** @format double */
    litres: number
}

export interface Db2WorkAreaNodeResponse {
    /** @format int32 */
    areaMainGroupId: number
    /** @format int32 */
    areaSubGroupId: number
    areaName?: string | null
    areaNumber?: string | null
    /** @format int32 */
    levelNumber: number
    children?: Db2WorkAreaNodeResponse[] | null
}

export interface Db2WorkTimeRecordResponse {
    /** @format int32 */
    areaId: number
    /** @format int64 */
    workId: number
    workName?: string | null
    workType?: string | null
    /** @format double */
    originalHours: number
    isComposite: boolean
}

export interface Db2YearNodeResponse {
    /** @format int32 */
    id: number
    name?: string | null
    /** @format int32 */
    parentId: number
    variants?: Db2VariantNodeResponse[] | null
}

export interface Db3EngineCodeNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    variants?: Db3VariantNodeResponse[] | null
    hp?: string | null
    kw?: string | null
    yearsRange?: string | null
    engine?: string | null
    code?: string | null
}

export interface Db3EngineNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    codes?: Db3EngineCodeNodeResponse[] | null
    engineText?: string | null
    litres?: string | null
    fuelType?: string | null
    freeText?: string | null
}

export interface Db3ManufactureNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    models?: Db3ModelNodeResponse[] | null
}

export interface Db3ModelItemResponse {
    name?: string | null
    description?: string | null
    value?: string | null
}

export interface Db3ModelNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    engines?: Db3EngineNodeResponse[] | null
}

export interface Db3PartRecordResponse {
    adPartsId?: string | null
    description?: string | null
}

export interface Db3SectionModelResponse {
    section?: string | null
    subSections?: Db3SubSectionModelResponse[] | null
}

export interface Db3SubSectionModelResponse {
    subSection?: string | null
    models?: Db3ModelItemResponse[] | null
}

export interface Db3VariantNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    modificationId?: string | null
}

export interface Db3WorkAreaNodeResponse {
    /** @format int32 */
    groupSequence: number
    /** @format int32 */
    subgroupSequence: number
    areaName?: string | null
    children?: Db3WorkAreaNodeResponse[] | null
}

export interface Db3WorkIncludedRecordResponse {
    /** @format int32 */
    id: number
    complexWorkId?: string | null
    adWorkId?: string | null
    adRepairId?: string | null
    action?: string | null
    actionDescription?: string | null
    description?: string | null
    /** @format int32 */
    sequence: number
}

export interface Db3WorkTimeRecordResponse {
    areaId?: string | null
    adRepairId?: string | null
    adWorkId?: string | null
    description?: string | null
    action?: string | null
    actionDescription?: string | null
    complexWorkId?: string | null
    /** @format double */
    normTime: number
    /** @format int32 */
    sequence: number
    hasParts: boolean
    hasIncludedWorks: boolean
}

export interface Db3YearNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    manufactures?: Db3ManufactureNodeResponse[] | null
}

export interface Db4DataItemIndentResponse {
    techDataItemId?: string | null
    title?: string | null
    value?: string | null
    unit?: string | null
}

export interface Db4ManufactureNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    models?: Db4ModelNodeResponse[] | null
}

export interface Db4ModelNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    modifications?: Db4ModificationNodeResponse[] | null
}

export interface Db4ModificationNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    variants?: Db4VariantNodeResponse[] | null
    engineCode?: string | null
    engineCapacity?: string | null
    enginePowerKw?: string | null
    engineType?: string | null
}

export interface Db4RelatedWorkResponse {
    hpId?: string | null
    hpDataId?: string | null
    hpDataAwnr?: string | null
    title?: string | null
    time?: string | null
}

export interface Db4TechDataItemResponse {
    techDataItemId?: string | null
    componentHeaderId?: string | null
    title?: string | null
    value?: string | null
    unit?: string | null
    indent: boolean
    hasIndents: boolean
    indents?: Db4DataItemIndentResponse[] | null
}

export interface Db4TechDataMenuItemResponse {
    componentHeaderId?: string | null
    title?: string | null
    hasDataItems: boolean
    items?: Db4TechDataItemResponse[] | null
}

export interface Db4TechDataMenuResponse {
    generalHeaderId?: string | null
    title?: string | null
}

export interface Db4VariantNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    modificationId?: string | null
}

export interface Db4WorkAreaNodeResponse {
    areaId?: string | null
    areaSubId?: string | null
    areaName?: string | null
    children?: Db4WorkAreaNodeResponse[] | null
}

export interface Db4WorkTimeRecordResponse {
    id?: string | null
    hpDataAwnr?: string | null
    workAreaId?: string | null
    nodeHierarchy?: string | null
    title?: string | null
    oeCode?: string | null
    /** @format double */
    time: number
    hasParts: boolean
    hasIncludedWorks: boolean
    hasRelatedWorks: boolean
}

export interface Db4YearNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    manufactures?: Db4ManufactureNodeResponse[] | null
}

export interface Db5ManufactureNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    models?: Db5ModelNodeResponse[] | null
}

export interface Db5ModelNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    modifications?: Db5ModificationNodeResponse[] | null
}

export interface Db5ModificationNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    variants?: Db5VariantNodeResponse[] | null
}

export interface Db5TechDataCategoryItemResponse {
    headerTitle?: string | null
    headerId?: string | null
    value?: string | null
    propertyName?: string | null
    unit?: string | null
}

export interface Db5TechDataCategoryResponse {
    title?: string | null
}

export interface Db5VariantNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    modificationId?: string | null
    engineCode?: string | null
    engineCapacity?: string | null
    enginePowerKw?: string | null
    engineType?: string | null
    /** @format double */
    weight: number
    most?: string | null
}

export interface Db5WorkAreaNodeResponse {
    areaId?: string | null
    areaSubId?: string | null
    areaName?: string | null
    children?: Db5WorkAreaNodeResponse[] | null
}

export interface Db5WorkTimeRecordResponse {
    id?: string | null
    hpDataAwnr?: string | null
    workAreaId?: string | null
    nodeHierarchy?: string | null
    title?: string | null
    oeCode?: string | null
    /** @format double */
    time: number
    hasParts: boolean
    hasIncludedWorks: boolean
    hasRelatedWorks: boolean
}

export interface Db5YearNodeResponse {
    id?: string | null
    parentId?: string | null
    name?: string | null
    manufactures?: Db5ManufactureNodeResponse[] | null
}

export interface DecimalNullableRangeValue {
    /** @format double */
    from?: number | null
    /** @format double */
    to?: number | null
}

/** Ответ ошибки типа `DeleteCashboxException`. Код см. в поле `Detail`. */
export interface DeleteCashboxExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'DeleteCashboxException'. */
    Title?: 'DeleteCashboxException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `CashboxAlreadyArchived` — The cashbox is already archived; result contains cashboxId.
     */
    Detail?: DeleteCashboxErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `DeleteNoteException`. Код см. в поле `Detail`. */
export interface DeleteNoteExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'DeleteNoteException'. */
    Title?: 'DeleteNoteException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccessDenied` — The current user can only delete their own notes.
     */
    Detail?: DeleteNoteErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for deleting multiple orders in a single batch operation. */
export interface DeleteOrderBatchRequest {
    /**
     * The list of unique order identifiers to be deleted.
     * This collection must contain at least one valid order ID.
     */
    ids: number[] | null
}

/** Ответ ошибки типа `DeleteOrderFileException`. Код см. в поле `Detail`. */
export interface DeleteOrderFileExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'DeleteOrderFileException'. */
    Title?: 'DeleteOrderFileException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `TenantMismatch` — The file belongs to a different tenant than the current one.
     */
    Detail?: DeleteOrderFileErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Ответ ошибки типа `DeleteProductPromptException`. Код см. в поле `Detail`.
 *
 * Deleting a catalog product that still has stock transactions is blocked; the caller may retry with forceDelete=true to hide it anyway (DELETE /api/wh/catalog/products/{id}).
 */
export interface DeleteProductPromptExceptionProblem {
    /** Всегда 'BadOperationPromptException'. */
    Type?: 'BadOperationPromptException'
    /** Discriminator. Всегда 'DeleteProductPromptException'. */
    Title?: 'DeleteProductPromptException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ProductHasTransactions`
     */
    Detail?: DeleteProductPromptExceptionCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface DeleteStockResponse {
    success: boolean
    incomeDocumentsExists: boolean
    outcomeDocumentsExists: boolean
    transferDocumentsExists: boolean
}

/** Ответ ошибки типа `DeleteStorageLocationException`. Код см. в поле `Detail`. */
export interface DeleteStorageLocationExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'DeleteStorageLocationException'. */
    Title?: 'DeleteStorageLocationException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `StorageLocationInUse` — The storage location is referenced by stock products and cannot be deleted; result contains storageLocationId.
     */
    Detail?: DeleteStorageLocationErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `DeleteTaskException`. Код см. в поле `Detail`. */
export interface DeleteTaskExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'DeleteTaskException'. */
    Title?: 'DeleteTaskException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccessDenied` — Only the creator or assignee can delete the task.
     */
    Detail?: DeleteTaskErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface DetailTaskResponse {
    id?: string | null
    spares?: SpareAudatexResponse[] | null
    works?: WorkAudatexResponse[] | null
    paints?: PaintAudatexResponse[] | null
}

/** Response model that represents the current discount and price increase settings of the system. */
export interface DiscountSettingsResponse {
    /** Indicates whether discounts are applied in the price list. */
    useDiscountsInPriceList: boolean
    /** A collection of work-related price increases (e.g., additional charges, surcharges). */
    workIncreases?: WorkIncrease[] | null
    /** A collection of spare parts price increases (e.g., markup rules). */
    spareIncreases?: SpareIncrease[] | null
}

export interface DocumentKingKeyTextOptionResponse {
    key: DocumentKindEnum
    text?: string | null
    checked: boolean
}

export interface DocumentReferenceRequest {
    id: string | null
    documentType: DocumentTypeEnum
}

export interface DocumentReferenceResponse {
    id?: string | null
    title?: string | null
    /** @format date */
    documentDate?: string | null
    documentType: DocumentTypeEnum
}

export interface DocumentSetDocumentWithInfoDto {
    /** @format uuid */
    id: string
    incomeDocuments?: WarehouseIncomeDocumentReferenceWithInfoDto[] | null
    outcomeDocuments?: WarehouseOutcomeDocumentReferenceWithInfoDto[] | null
}

export interface DocumentSetIncomeDocRef {
    /** @format uuid */
    documentId: string
    documentType: IncomeDocumentTypeEnum
    /** @format date-time */
    createdAt: string
}

export interface DocumentSetOutcomeDocRef {
    /** @format uuid */
    documentId: string
    documentType: OutcomeDocumentTypeEnum
    /** @format date-time */
    createdAt: string
}

export interface DocumentSetResponse {
    /** @format uuid */
    id: string
    incomeDocuments?: DocumentSetIncomeDocRef[] | null
    outcomeDocuments?: DocumentSetOutcomeDocRef[] | null
}

/** Response model that represents the current system document settings. */
export interface DocumentsSettingsResponse {
    /**
     * The number of days to prevent notifications for unpaid cash documents.
     * @format int32
     */
    cashNoNotificationPreventPeriod: number
    /**
     * The number of days to prevent notifications for paid cash documents.
     * @format int32
     */
    cashNotificationPreventPeriod: number
    /** Indicates whether notifications are enabled when the execution status of a document changes. */
    enableNotificationChangeExecute: boolean
    /** Indicates whether notifications are enabled when the payment status of a document changes. */
    enableNotificationChangePaid: boolean
    /** Indicates whether training documents are enabled in the system. */
    enableTrainingDocuments: boolean
    /** Indicates whether the system should suggest empty document numbers. */
    suggestEmptyNumbers: boolean
    /** Indicates whether the system synchronizes order and act numbers. */
    syncOrderAndActNo: boolean
    /** Indicates whether automatic document numbering is enabled. */
    useAutoDocumentNumbering: boolean
    orderNumberingType: OrderNumberingTypeEnum
}

export interface DuplicateProductResponse {
    /** @format uuid */
    productId: string
    name?: string | null
    catalogCode?: string | null
    vendorCode?: string | null
    internalCode?: string | null
    tagCode?: string | null
    measure?: string | null
    description?: string | null
    brandName?: string | null
    country?: string | null
    /** @format double */
    cost: number
    /** @format double */
    sellingPrice: number
}

/** Ответ ошибки типа `EmployeeAccountException`. Код см. в поле `Detail`. */
export interface EmployeeAccountExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'EmployeeAccountException'. */
    Title?: 'EmployeeAccountException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccountAlreadyActivated` — The employee account is already activated (createAccount, joinAccount, activate).
     * - `EmployeeAlreadyHasLogin` — The employee already has a login bound to them (createAccount, joinAccount).
     * - `AccountAlreadyExists` — An account with the given login is already used by another employee of the station (createAccount, joinAccount, activate).
     * - `BadAccountCredentials` — Login or password do not match an existing account (joinAccount).
     * - `AccountCreateFailed` — The account could not be created; result contains the identity status (createAccount).
     * - `ActivationRequiresAccessGranted` — The account must be granted access before it can be activated (activate).
     * - `DeactivationRequiresAccessGranted` — The account has no granted access, so there is nothing to deactivate (deactivate).
     * - `SelfDeactivateNotAllowed` — An employee cannot deactivate their own account (deactivate).
     */
    Detail?: EmployeeAccountErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * На browse он отображает совсем мало информации, но почти во всем портале юзаются практически все поля
 * Поэтому лучше наследовать все
 */
export interface EmployeeBrowseResponse {
    /** @format int32 */
    id: number
    /** Full name of the employee */
    fullName: string | null
    /** Short name of the employee */
    shortName: string | null
    /** Job position of the employee */
    position: string | null
    /** Address of the employee */
    address?: string | null
    /** Primary phone number of the employee */
    primaryPhone?: string | null
    /** Secondary phone number of the employee */
    secondaryPhone?: string | null
    /** Email address of the employee */
    email?: string | null
    /** Birth date of the employee */
    birthDay?: string | null
    /** Indicates whether the employee is shown as responsible */
    showAsResponsible: boolean
    /**
     * Interest rate for the responsible role
     * @format double
     */
    interestRateResponsible: number
    /** Indicates whether the employee is shown as an executor */
    showAsExecutor: boolean
    /** Whether to use a common interest rate for all types of work */
    useCommonWorkInterestRate: boolean
    /**
     * Common interest rate for all types of work
     * @format double
     */
    workInterestRate?: number | null
    /**
     * Interest rate for spare parts
     * @format double
     */
    spareInterestRate: number
    /** Notes for the employee */
    annotation?: string | null
    /** Indicates whether employee-related documents are visible or hidden */
    showAllDocuments: boolean
    permissions: EmployeePermissions
    /** Indicates whether the employee has been granted access */
    isAccessGranted: boolean
    /** Indicates whether the employee’s account is activated */
    isAccountActivated: boolean
    /** Login name of the employee */
    login?: string | null
    /** Access to the CarDone/Favicar mobile application - Master */
    isMobileAccessEnabledForMaster: boolean
    /**
     * Date and time when the employee record was created
     * @format date-time
     */
    created: string
    /**
     * Date and time when the employee record was last modified
     * @format date-time
     */
    modified: string
    /** Indicates whether the employee record is archived */
    isArchive: boolean
    /**
     * Indicates whether the employee record is marked as deleted
     * This field is required for correctly displaying a deleted executor in the order.
     */
    deleted: boolean
    /** Detailed information about the employee’s rates */
    employeeRates?: EmployeeRateResponse[] | null
    /** Response model that represents the work schedule of an employee */
    employeeSchedule?: EmployeeScheduleResponse
}

export interface EmployeeBrowseResponsePaginatedCollection {
    page?: EmployeeBrowseResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

/** Ответ ошибки типа `EmployeeException`. Код см. в поле `Detail`. */
export interface EmployeeExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'EmployeeException'. */
    Title?: 'EmployeeException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AlreadyArchived` — The employee is already archived.
     * - `SelfArchiveNotAllowed` — Users cannot archive their own employee record.
     * - `NotArchived` — The employee is not archived.
     * - `PermissionsRequireActiveAccount` — Permissions can be read or assigned only for an employee with an active account.
     */
    Detail?: EmployeeErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Represents a preview of an employee.
 * Used to display a list of employees without detailed information.
 */
export interface EmployeePreviewResponse {
    /**
     * Unique identifier of the employee.
     * @format int32
     */
    id: number
    /** Full name of the employee. */
    fullName?: string | null
    /**
     * Short or abbreviated version of the employee's name
     * (e.g., J.D. Smith).
     */
    shortName?: string | null
    /** Primary phone number of the employee. */
    primaryPhone?: string | null
    /** Secondary phone number of the employee, if available. */
    secondaryPhone?: string | null
    /** Job title or position of the employee. */
    position?: string | null
}

/** Response model that represents the details of an employee's rate configuration. */
export interface EmployeeRateResponse {
    /**
     * The unique identifier of the employee rate record.
     * @format int32
     */
    id: number
    /**
     * The identifier of the station rate associated with this employee rate.
     * @format int32
     */
    stationRateId: number
    /**
     * The interest rate (percentage) applied for this employee rate.
     * @format double
     */
    interestRate: number
    employeeRateType: EmployeeRateTypeEnum
    /**
     * The date and time when this employee rate was created.
     * @format date-time
     */
    created: string
    /**
     * The date and time when this employee rate was last modified.
     * @format date-time
     */
    modified: string
}

/** Response model representing detailed information about an employee */
export interface EmployeeResponse {
    /** @format int32 */
    id: number
    /** Full name of the employee */
    fullName: string | null
    /** Short name of the employee */
    shortName: string | null
    /** Job position of the employee */
    position: string | null
    /** Address of the employee */
    address?: string | null
    /** Primary phone number of the employee */
    primaryPhone?: string | null
    /** Secondary phone number of the employee */
    secondaryPhone?: string | null
    /** Email address of the employee */
    email?: string | null
    /** Birth date of the employee */
    birthDay?: string | null
    /** Indicates whether the employee is shown as responsible */
    showAsResponsible: boolean
    /**
     * Interest rate for the responsible role
     * @format double
     */
    interestRateResponsible: number
    /** Indicates whether the employee is shown as an executor */
    showAsExecutor: boolean
    /** Whether to use a common interest rate for all types of work */
    useCommonWorkInterestRate: boolean
    /**
     * Common interest rate for all types of work
     * @format double
     */
    workInterestRate?: number | null
    /**
     * Interest rate for spare parts
     * @format double
     */
    spareInterestRate: number
    /** Notes for the employee */
    annotation?: string | null
    /** Indicates whether employee-related documents are visible or hidden */
    showAllDocuments: boolean
    permissions: EmployeePermissions
    /** Indicates whether the employee has been granted access */
    isAccessGranted: boolean
    /** Indicates whether the employee’s account is activated */
    isAccountActivated: boolean
    /** Login name of the employee */
    login?: string | null
    /** Access to the CarDone/Favicar mobile application - Master */
    isMobileAccessEnabledForMaster: boolean
    /**
     * Date and time when the employee record was created
     * @format date-time
     */
    created: string
    /**
     * Date and time when the employee record was last modified
     * @format date-time
     */
    modified: string
    /** Indicates whether the employee record is archived */
    isArchive: boolean
    /**
     * Indicates whether the employee record is marked as deleted
     * This field is required for correctly displaying a deleted executor in the order.
     */
    deleted: boolean
    /** Detailed information about the employee’s rates */
    employeeRates?: EmployeeRateResponse[] | null
    /** Response model that represents the work schedule of an employee */
    employeeSchedule?: EmployeeScheduleResponse
}

/** Detailed response model for an employee's work schedule. */
export interface EmployeeScheduleDetailsResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    employeeId: number
    /** @format date */
    scheduleStartDate: string
    scheduleType: ScheduleType
    /** HH:mm */
    workStartTime?: string | null
    /** HH:mm */
    workEndTime?: string | null
}

/** Response model that represents the work schedule of an employee */
export interface EmployeeScheduleResponse {
    /**
     * Unique identifier of the schedule record
     * @format int32
     */
    id: number
    /**
     * Date when the schedule starts
     * @format date
     */
    scheduleStartDate: string
    scheduleType: ScheduleType
    /** The start time of the employee's workday. */
    workStartTime?: string | null
    /** The end time of the employee's workday. */
    workEndTime?: string | null
}

export interface EmployeeSnapshotDataResponse {
    fullName?: string | null
    shortName?: string | null
    position?: string | null
    showAsMaster: boolean
    showAsEmployee: boolean
    isAccessGranted: boolean
    isAccountActivated: boolean
    cardoneLogin?: string | null
    /** @format date-time */
    created: string
    /** @format date-time */
    modified: string
}

export interface EmployeeSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: EmployeeSnapshotDataResponse
}

/** Reference to a related entity captured inside a snapshot (id + display name). */
export interface EntityReferenceSnapshotResponse {
    id?: string | null
    displayName?: string | null
}

/** Ответ ошибки типа `EstablishConnectionException`. Код см. в поле `Detail`. */
export interface EstablishConnectionExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'EstablishConnectionException'. */
    Title?: 'EstablishConnectionException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `LinkAlreadyExists` — A link between this preorder and order already exists; result contains preOrderId and orderId.
     */
    Detail?: EstablishConnectionErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface EventClientDto {
    displayName?: string | null
    phone: string | null
}

/** Represents a client-supplied spare part attached to an event. */
export interface EventClientSpareResponse {
    /**
     * Unique identifier of the client spare record.
     * @format int32
     */
    id: number
    /** Human-readable name of the spare part. */
    spareName?: string | null
    /** Catalog/part number (SKU, OEM/aftermarket code). */
    catalogNumber?: string | null
    /**
     * Quantity of the spare part (can be fractional for fluids/consumables).
     * @format double
     */
    count: number
    /** Unit of measure (e.g., "pcs", "l", "kg", "m"). */
    measure?: string | null
    condition: OrderClientSpareConditionEnum
    /**
     * Per-unit input price provided for this spare part (tenant currency). Use `decimal` for money.
     * @format double
     */
    inputPrice: number
}

export interface EventDashboardResponse {
    data?: EventPreviewResponse[] | null
    /** @format int32 */
    count: number
}

/** Represents notification preferences for an event. */
export interface EventNotificationDto {
    /** Whether to send a notification when the event is created. */
    createNotification: boolean
    /** Whether to send reminder notifications before the event starts. */
    reminderNotification: boolean
}

export interface EventPreviewCarResponse {
    displayName?: string | null
    regNo?: string | null
}

export interface EventPreviewClientResponse {
    displayName?: string | null
    phone?: string | null
}

export interface EventPreviewResponse {
    /** @format int32 */
    id: number
    type: EventTypeEnum
    /** @format int32 */
    areaId: number
    /** @format int32 */
    employeeId: number
    status: EventStatusEnum
    /** @format date-time */
    startUtc: string
    /** @format date-time */
    endUtc: string
    title?: string | null
    /** @format int32 */
    carId?: number | null
    carData?: EventPreviewCarResponse
    /** @format int32 */
    clientId?: number | null
    clientData?: EventPreviewClientResponse
    /** @format double */
    ttlCostTotal: number
}

/**
 * Represents a scheduled event with links to related entities,
 * pricing totals, notification options, and audit metadata.
 */
export interface EventResponse {
    /**
     * Unique identifier of the event.
     * @format int32
     */
    id: number
    type: EventTypeEnum
    /**
     * Identifier of the area/location where the event takes place.
     * @format int32
     */
    areaId: number
    /**
     * Identifier of the responsible employee.
     * @format int32
     */
    responsibleId: number
    /**
     * Source
     * @format int32
     */
    sourceId?: number | null
    status: EventStatusEnum
    /**
     * Scheduled start time in UTC.
     * @format date-time
     */
    startUtc: string
    /**
     * Scheduled end time in UTC.
     * @format date-time
     */
    endUtc: string
    /** Short title/subject of the event. */
    title?: string | null
    /** Detailed description/notes for the event. */
    description?: string | null
    /**
     * Related vehicle identifier, if any.
     * @format int32
     */
    vehicleId?: number | null
    /**
     * Related client identifier, if any.
     * @format int32
     */
    clientId?: number | null
    /** Represents notification preferences for an event. */
    eventNotification?: EventNotificationDto
    /**
     * Lightweight vehicle DTO for embedding into event payloads/responses.
     * Includes display fields and cross-references to multiple RepTimes catalogs.
     */
    vehicleData?: EventVehicleDto
    clientData?: EventClientDto
    /** Customer-requested work items (free-form list). */
    customerWork?: string[] | null
    /** Station-performed works associated with the event (optional). */
    stationWorks?: EventStationWorkResponse[] | null
    /** Station-supplied spare parts associated with the event (optional). */
    stationSpares?: EventStationSpareResponse[] | null
    /** Client-supplied spare parts associated with the event (optional). */
    clientSpares?: EventClientSpareResponse[] | null
    /**
     * Total cost of works/services.
     * @format double
     */
    wksCostTotal: number
    /**
     * Total cost of spare parts.
     * @format double
     */
    sprCostTotal: number
    /**
     * Overall total cost (works + spares).
     * @format double
     */
    ttlCostTotal: number
    /** Linked Google Calendar identifier (optional). */
    googleCalendarId?: string | null
    /** Linked Google Calendar event identifier (optional). */
    googleEventId?: string | null
    /**
     * Timestamp when the event was created.
     * @format date-time
     */
    created: string
    /** Login/identifier of the user who created the event (optional). */
    createdBy?: string | null
    /**
     * Timestamp when the event was last modified.
     * @format date-time
     */
    modified: string
    /** Login/identifier of the user who last modified the event (optional). */
    modifiedBy?: string | null
}

export interface EventStationSpareResponse {
    /**
     * Id
     * @format int32
     */
    id: number
    /** The name/description of the spare part. */
    spareName?: string | null
    /** Country of origin for the spare part (optional). */
    country?: string | null
    /** The brand name of the spare part (optional). */
    brandName?: string | null
    /** Vendor code (article number provided by manufacturer or supplier, optional). */
    vendorCode?: string | null
    /** Catalog number (article) of the spare part (optional). */
    catalogNumber?: string | null
    /**
     * The quantity of the spare part used in the order.
     * @format double
     */
    count: number
    /** Unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * VAT Rate
     * @format double
     */
    vatRate: number
    /**
     * Base input price (per unit) without VAT.
     * @format double
     */
    inputPriceNoVat: number
    /**
     * Total input price without VAT for all items (InputPriceNoVat * Count).
     * @format double
     */
    inputPriceNoVatTotal: number
    /**
     * VAT amount applied to the input price.
     * @format double
     */
    inputPriceVat: number
    /**
     * Input price (per unit) including VAT.
     * @format double
     */
    inputPrice: number
    /**
     * Total input price including VAT for all items.
     * @format double
     */
    inputPriceTotal: number
    /**
     * Absolute markup (extra charge) applied to the spare part.
     * @format double
     */
    extraAmount: number
    /**
     * Percentage markup applied to the spare part.
     * @format double
     */
    extraPercent: number
    /**
     * Selling price per unit without VAT.
     * @format double
     */
    priceNoVat: number
    /**
     * Total selling price without VAT for all items.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount applied to the selling price.
     * @format double
     */
    priceVat: number
    /**
     * Selling price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * Total selling price including VAT for all items.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to this spare part.
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount applied.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount included in the cost.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments for this spare part. */
    notes?: string | null
    /**
     * Identifier of the stock (warehouse) from which the spare part was taken.
     * @format uuid
     */
    stockId?: string | null
    /**
     * Identifier of the product in stock system.
     * @format uuid
     */
    productId?: string | null
    /** Internal code of the spare part in stock system (optional). */
    internalCode?: string | null
    status: OrderStationSparesStatusEnum
}

/**
 * Represents a station-performed work line attached to an event
 * with pricing, VAT, discount, cost breakdowns, and metadata.
 */
export interface EventStationWorkResponse {
    /**
     * Unique identifier of the work line.
     * @format int32
     */
    id: number
    /** Display name of the work (what is shown on documents/UI). */
    displayName?: string | null
    /**
     * Quantity of work (e.g., hours or units).
     * @format double
     */
    count: number
    /**
     * Optional rate code/number from your price list (tariff identifier).
     * @format int32
     */
    rateNumber: number
    /**
     * Optional price per rate unit (e.g., price per hour) excluding VAT.
     * @format double
     */
    ratePrice: number
    /**
     * Standard (normative) time per unit (e.g., hours for this operation).
     * @format double
     */
    normTime: number
    /**
     * Total normative time = `NormTime × Count`.
     * @format double
     */
    normTimeTotal: number
    /**
     * VAT Rate
     * @format double
     */
    vatRate: number
    /**
     * Unit price excluding VAT (net).
     * @format double
     */
    priceNoVat: number
    /**
     * Total price excluding VAT (net) for the line.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount for the line (commonly total).
     * @format double
     */
    priceVat: number
    /**
     * Unit price including VAT (gross).
     * @format double
     */
    price: number
    /**
     * Total price including VAT (gross) for the line.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to the line (0–100).
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount in currency (how much was subtracted).
     * @format double
     */
    discountAmount: number
    /**
     * Unit internal cost excluding VAT (net).
     * @format double
     */
    costNoVat: number
    /**
     * Total internal cost excluding VAT (net) for the line.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount calculated from internal cost (commonly total).
     * @format double
     */
    costVat: number
    /**
     * Total internal cost including VAT (gross) for the line.
     * @format double
     */
    costTotal: number
    workSource: WorkSourceEnum
    /** If true, hides the normative time in printed documents/UI. */
    isHideNormTime: boolean
    status: OrderWorkStatusEnum
}

/**
 * Lightweight vehicle DTO for embedding into event payloads/responses.
 * Includes display fields and cross-references to multiple RepTimes catalogs.
 */
export interface EventVehicleDto {
    /** Human-friendly vehicle name shown in UI (e.g., "VW Passat B7 2.0 TDI"). */
    displayName?: string | null
    /** Vehicle registration number / license plate. */
    regNo?: string | null
    /**
     * RepTimesDb1 internal identifier (numeric), if linked.
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** RepTimesDb1 human-readable value/title. */
    repTimesDb1Value?: string | null
    /**
     * RepTimesDb2 internal identifier (numeric), if linked.
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** RepTimesDb2 human-readable value/title. */
    repTimesDb2Value?: string | null
    /** RepTimesDb3 internal identifier (may be string-based), if linked. */
    repTimesDb3Id?: string | null
    /** RepTimesDb3 human-readable value/title. */
    repTimesDb3Value?: string | null
    /** RepTimesDb4 internal identifier (may be string-based), if linked. */
    repTimesDb4Id?: string | null
    /** RepTimesDb4 human-readable value/title. */
    repTimesDb4Value?: string | null
    /** RepTimesDb5 internal identifier (may be string-based), if linked. */
    repTimesDb5Id?: string | null
    /** RepTimesDb5 human-readable value/title. */
    repTimesDb5Value?: string | null
}

export interface ExecutorCommonReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    documentOptions?: DocumentKindEnum[] | null
    workRates?: number[] | null
    vehicleType?: VehicleTypeEnum
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ExecutorCommonReportResponse {
    /** Response model representing detailed information about an employee */
    employee?: EmployeeResponse
    data?: ExecutorReportCommonDataResponse
}

export interface ExecutorDetailsReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    documentOptions?: DocumentKindEnum[] | null
    workRates?: number[] | null
    vehicleType?: VehicleTypeEnum
    /** @format int32 */
    employeeId: number
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ExecutorDetailsReportResponse {
    /** @format int32 */
    orderId: number
    orderNo?: string | null
    actNo?: string | null
    /** @format date-time */
    orderDate?: string | null
    /** @format date-time */
    estimateDate?: string | null
    /** @format date-time */
    paymentDueDate?: string | null
    /** @format date-time */
    paymentDate?: string | null
    /** @format double */
    wksDiscountAmount: number
    /** @format double */
    sprDiscountAmount: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    wksProfit: number
    /** @format double */
    ctrProfit: number
    /** @format double */
    sprProfit: number
    /** @format double */
    ttlProfit: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    ctrCostNoVat: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    ctrCostVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    ctrCostTotal: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    cspCostTotal: number
    /** @format double */
    discountWksClient: number
    /** @format double */
    discountWksCar: number
    /** @format double */
    discountWksTtl: number
    /** @format double */
    discountSprTtl: number
    /** @format double */
    discountYear: number
    /** @format int32 */
    ownerId: number
    /** @format int32 */
    clientId: number
    /** @format int32 */
    payerId: number
    /** @format int32 */
    carId: number
    /** @format int32 */
    mileage: number
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    owner?: ClientResponse
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    client?: ClientResponse
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    payer?: ClientResponse
    /** Response model that represents detailed information about a car. */
    car?: CarResponse
    /** Response model representing detailed information about an employee */
    responsible?: EmployeeResponse
    stationWorks?: OrderStationWorkResponse[] | null
    contractorWorks?: OrderContractorWorkResponse[] | null
    stationSpares?: OrderStationSpareResponse[] | null
    clientSpares?: OrderClientSpareResponse[] | null
}

export interface ExecutorReportCommonDataResponse {
    /** @format int32 */
    employeeId: number
    /** @format double */
    normTimeSum: number
    /** @format double */
    amountPartSum: number
    /** @format int32 */
    orderCount: number
}

/** Ответ ошибки типа `ExportException`. Код см. в поле `Detail`. */
export interface ExportExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ExportException'. */
    Title?: 'ExportException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `VersionNotSupported` — Запрошенная версия экспорта не поддерживается этим эндпоинтом.
     */
    Detail?: ExportErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface FinancialPaymentsReportResponse {
    /** @format int32 */
    paymentCount: number
    /** @format int32 */
    creditPaymentCount: number
    /** @format double */
    creditPaymentSum: number
    /** @format int32 */
    debitPaymentCount: number
    /** @format double */
    debitPaymentSum: number
    payments?: CashboxPaymentResponse[] | null
}

export interface FinancialPaymentsRequest {
    sortAsc: boolean
    sortCol?: string | null
    /** @format uuid */
    cashboxId: string
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    isFullPayment?: boolean | null
    paymentTypes?: PaymentTypeEnum[] | null
    /** Категории платежей. Пусто или не задано — фильтр по категории не применяется. */
    paymentCategories?: string[] | null
    paymentMethods?: PaymentMethodEnum[] | null
}

export interface FindTaskElementResponse {
    id?: string | null
    number?: string | null
    status?: string | null
    vin?: string | null
    plateNumber?: string | null
    manufacturer?: string | null
    model?: string | null
    /** @format date-time */
    created: string
}

export interface FlowApiSettingsResponse {
    isEnabled: boolean
    token?: string | null
}

/** Response model that represents the current general system settings. */
export interface GeneralSettingsResponse {
    /** The default interface language (e.g., "ru", "en"). Default is `"ru"`. */
    language?: string | null
    /** The currently selected time zone identifier. */
    currentTimeZone?: string | null
    /** A list of all available system time zones with display names. */
    allTimeZones?: string[] | null
    timeFormat: TimeFormatEnum
    dateFormat: DateFormatEnum
    /** Indicates whether JivoChat integration is enabled. Default is `true`. */
    enableJivoChat: boolean
    /** Indicates whether client-side validation is enabled in the system. */
    enableClientValidation: boolean
    /** Indicates whether providing a client contact phone number is required. */
    isClientContactPhoneRequired: boolean
    smsTemplateMode: SmsTemplateModeEnum
    /**
     * Defines the visibility of Order Status feature.
     * Default is `Visible/Enabled`.
     */
    isStatusFeatureEnabled: boolean
}

export interface GetByFilterRequest {
    contractId: string | null
}

export interface GetCallsHistoryRequest {
    user?: string | null
    /** @format date-time */
    from: string
    /** @format date-time */
    to?: string | null
}

export interface GetMatchingCategoriesRequest {
    catalogCodes?: string[] | null
}

export interface GetNonAttendanceReportRequest {
    /** @format date-time */
    startDate: string
    /** @format int32 */
    ordersCount: number
    fiz: boolean
    org: boolean
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
}

export interface GetTenantRegistrationFormValuesResponse {
    tariffOptions?: TenantRegistrationFormOption[] | null
    countryOptions?: TenantRegistrationFormOption[] | null
    languageOptions?: TenantRegistrationFormOption[] | null
    defaultLanguage?: string | null
    defaultCountry?: string | null
    defaultTariff?: string | null
}

export interface GetTipsSummaryRequest {
    orders?: number[] | null
    cars?: number[] | null
    clients?: number[] | null
}

/** Response model that represents the current Google API service account settings. */
export interface GoogleApiSettingsResponse {
    /** The type of the service account (usually "service_account"). */
    type?: string | null
    /** The Google Cloud project identifier. */
    projectId?: string | null
    /** The unique identifier of the private key. */
    privateKeyId?: string | null
    /** The private key string used for authentication. */
    privateKey?: string | null
    /** The client email address associated with the service account. */
    clientEmail?: string | null
    /** The client ID associated with the service account. */
    clientId?: string | null
    /** The authentication URI (used for OAuth2 flow). */
    authUri?: string | null
    /** The token URI used to obtain access tokens. */
    tokenUri?: string | null
    /** The URL for the authentication provider’s X.509 public certificates. */
    authProviderX509CertUrl?: string | null
    /** The URL for the client’s X.509 public certificate. */
    clientX509CertUrl?: string | null
}

/** Request to import a clipboard folder into an existing order. */
export interface ImportFromClipboardRequest {
    /**
     * Identifier of the clipboard folder to import.
     * @format uuid
     */
    folderId: string
}

/** Result of importing a clipboard folder into an order. */
export interface ImportFromClipboardResponse {
    /** Files that ended up attached to the order (order matches the source folder). */
    importedFiles?: OrderFileResponse[] | null
}

export interface ImportParsedInfo {
    orderNo?: string | null
    currency: CurrencyCodeEnum
}

export interface ImportParsingResponse {
    success: boolean
    message?: string | null
    fileName?: string | null
    info?: ImportParsedInfo
    data?: ParsedLineItem[] | null
}

export interface ImportProductItem {
    /** @minLength 1 */
    catalogCode: string
    /** @minLength 1 */
    tagCode: string
    /** @minLength 1 */
    name: string
    printName?: string | null
    /** @minLength 1 */
    measure: string
    brandName?: string | null
    country?: string | null
    /** @format double */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format int32 */
    discount: number
    /** @format double */
    minBalance: number
    /** @format double */
    weight: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
}

export interface ImportProductsRequest {
    products: ImportProductItem[]
}

/** Ответ ошибки типа `ImportTestException`. Код см. в поле `Detail`. */
export interface ImportTestExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ImportTestException'. */
    Title?: 'ImportTestException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `FileEmpty` — Файл не передан или пуст.
     * - `FileInvalid` — Содержимое файла не удалось расшифровать/распознать.
     */
    Detail?: ImportTestErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface ImportedCarResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    ownerId: number
    /** @format int32 */
    mileage: number
    year?: string | null
    regNo?: string | null
    bodyNo?: string | null
    bodyNo2?: string | null
    manufacturer?: string | null
    model?: string | null
    /** @format float */
    engineLitres?: number | null
    /** @format int32 */
    fuelTypeId?: number | null
    /** @format int32 */
    residentType: number
    transmission?: string | null
    annotation?: string | null
    /** @format int32 */
    repTimesDb1Id?: number | null
    repTimesDb1Value?: string | null
    /** @format int32 */
    repTimesDb2Id?: number | null
    repTimesDb2Value?: string | null
    repTimesDb3Id?: string | null
    repTimesDb3Value?: string | null
    repTimesDb4Id?: string | null
    repTimesDb4Value?: string | null
    repTimesDb5Id?: string | null
    repTimesDb5Value?: string | null
}

export interface ImportedClientResponse {
    /** @format int32 */
    id: number
    clientTypeCode: ClientTypeEnum
    displayName?: string | null
    email?: string | null
    skype?: string | null
    telegram?: string | null
    streetAddress?: string | null
    annotation?: string | null
    unp?: string | null
    bank?: string | null
    bankCode?: string | null
    bankAccount?: string | null
    bankAddress?: string | null
    director?: string | null
    accountant?: string | null
    /** @format date-time */
    created: string
    /** @format date-time */
    modified: string
    /** @format int32 */
    discount: number
    /** @format int32 */
    discountParts: number
    discountCard?: string | null
    resident?: boolean | null
    birthday?: string | null
    isNeedCall: boolean
    isFavorite: boolean
    banSms: boolean
    isTrusted: boolean
    primaryPhone?: string | null
    secondaryPhone?: string | null
    tertiaryPhone?: string | null
    directorPhone?: string | null
    accountantPhone?: string | null
}

export interface IncomeDocumentListItemResponse {
    /** @format uuid */
    id: string
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    documentType: IncomeDocumentTypeEnum
    status: IncomeDocumentStatusEnum
    stock?: WarehouseStockReferenceDto
    bank?: WarehouseBankAccountReferenceDto
    responsible?: WarehouseEmployeeReferenceDto
    supplier?: WarehouseSupplierReferenceDto
    buyer?: WarehouseBuyerReferenceDto
    /** @format date-time */
    estimatedShippingDate?: string | null
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    balance: number
    comment?: string | null
}

export interface IncomeDocumentListItemResponsePaginatedCollection {
    page?: IncomeDocumentListItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

/** Ответ ошибки типа `IncomeDocumentReadonlyException`. Код см. в поле `Detail`. */
export interface IncomeDocumentReadonlyExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'IncomeDocumentReadonlyException'. */
    Title?: 'IncomeDocumentReadonlyException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
     */
    Detail?: IncomeDocumentReadonlyErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface IncomeDocumentResponse {
    /** @format uuid */
    id: string
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    documentType: IncomeDocumentTypeEnum
    status: IncomeDocumentStatusEnum
    stockRef?: WarehouseStockReferenceDto
    bankAccountRef?: WarehouseBankAccountReferenceDto
    responsibleRef?: WarehouseEmployeeReferenceDto
    buyerRef?: WarehouseBuyerReferenceDto
    buyerContractRef?: WarehouseContractReferenceDto
    supplierRef?: WarehouseSupplierReferenceDto
    supplierContractRef?: WarehouseContractReferenceDto
    /** @format date-time */
    estimatedShippingDate?: string | null
    products?: IncomeProductDto[] | null
    /** @format double */
    vat: number
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    balance: number
    comment?: string | null
}

export interface IncomeDocumentSnapshotDataResponse {
    documentType?: string | null
    status?: string | null
    stockTitle?: string | null
    bankAccountName?: string | null
    responsibleName?: string | null
    buyerName?: string | null
    buyerContractNo?: string | null
    supplierName?: string | null
    supplierContractNo?: string | null
    /** @format date-time */
    estimatedShippingDate?: string | null
    /** @format double */
    vat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    balance: number
    products?: IncomeProductSnapshotResponse[] | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface IncomeDocumentSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: IncomeDocumentSnapshotDataResponse
}

export interface IncomeProductDto {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    vendorCode?: string | null
    country?: string | null
    catalogCode?: string | null
    /** Идентификатор партии во внешней системе. */
    externalId?: string | null
    /** Номер грузовой таможенной декларации. */
    customsDeclarationNumber?: string | null
    /**
     * Срок годности партии.
     * @format date-time
     */
    expirationDate?: string | null
    /** Номер сертификата соответствия. */
    certificateNumber?: string | null
    name?: string | null
    measure?: string | null
    /** @format double */
    count: number
    /** @format int32 */
    vat: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    priceVat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format int32 */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVat: number
    /** @format double */
    costTotal: number
    /** @format double */
    extraPercent: number
    /** @format double */
    extraAmount: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
}

export interface IncomeProductSnapshotResponse {
    vendorCode?: string | null
    catalogCode?: string | null
    name?: string | null
    measure?: string | null
    /** @format double */
    count: number
    /** @format int32 */
    vat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format int32 */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format double */
    costTotal: number
    /** @format double */
    sellingPrice: number
}

export interface IncomeReportFilter {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    documentType?: IncomeDocumentTypeEnum[] | null
    stockId?: string[] | null
    bankAccountId?: string[] | null
    vendorCode?: string | null
    catalogCode?: string | null
    tagCode?: string | null
    brandName?: string | null
    /** @format uuid */
    supplierId: string
    buyerId?: string | null
}

export interface IncomeReportProductItem {
    /** @format uuid */
    documentId: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    documentType: IncomeDocumentTypeEnum
    /** @format uuid */
    productId: string
    productName?: string | null
    internalCode?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    measure?: string | null
    tagCode?: string | null
    brandName?: string | null
    stockRef?: ReportStockRef
    bankAccountRef?: ReportBankAccountRef
    responsibleRef?: ReportEmployeeRef
    supplierRef?: ReportSupplierRef
    buyerRef?: ReportBuyerRef
    /** @format double */
    count: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costTotal: number
    /** @format double */
    costVat: number
    /** @format int32 */
    vat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceNoVatTotal: number
    /** @format int32 */
    discount: number
    /** @format double */
    discountAmount: number
}

export interface IncomeReportResponse {
    /** @format int32 */
    totalDocuments: number
    /** @format int32 */
    totalProducts: number
    /** @format double */
    grandCostTotal: number
    /** @format double */
    grandSellingPriceTotal: number
    products?: IncomeReportProductItem[] | null
    hasMore: boolean
}

export interface Int32NullableRangeValue {
    /** @format int32 */
    from?: number | null
    /** @format int32 */
    to?: number | null
}

export interface IntKeyTexOptionResponse {
    /** @format int32 */
    key: number
    text?: string | null
    checked: boolean
}

export interface IntercarsImportResponse {
    id?: string | null
    orderId?: string | null
    billTo?: string | null
    shipTo?: string | null
    deliveryMethod?: string | null
    /** @format date-time */
    creationDate?: string | null
    currencyCode?: string | null
    /** @format double */
    ttlCostTotal: number
    spares?: ParsedLineResponse[] | null
}

export interface InventoryAddResponse {
    /** @format uuid */
    documentId: string
}

export interface InventoryDetailsResponse {
    /** @format uuid */
    id: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    stockRef?: InventoryStockRef
    responsibleRef?: InventoryEmployeeRef
    isPublished: boolean
    comment?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    products?: InventoryProductResponse[] | null
}

/** Ответ ошибки типа `InventoryDocumentReadonlyException`. Код см. в поле `Detail`. */
export interface InventoryDocumentReadonlyExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'InventoryDocumentReadonlyException'. */
    Title?: 'InventoryDocumentReadonlyException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
     */
    Detail?: InventoryDocumentReadonlyErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface InventoryEmployeeRef {
    id?: string | null
    name?: string | null
}

export interface InventoryListItemResponse {
    /** @format uuid */
    id: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    stockRef?: InventoryStockRef
    responsibleRef?: InventoryEmployeeRef
    isPublished: boolean
    comment?: string | null
    /** @format int32 */
    totalProducts: number
    /** @format int32 */
    totalRevised: number
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
}

export interface InventoryProductCreateItem {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    name?: string | null
    catalogCode?: string | null
    brandName?: string | null
    measure?: string | null
    /** @format double */
    stockCount: number
    /** @format double */
    reviseCount: number
    isRevised: boolean
    comment?: string | null
}

export interface InventoryProductDeleteItem {
    internalCode?: string | null
}

export interface InventoryProductResponse {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    name?: string | null
    catalogCode?: string | null
    brandName?: string | null
    measure?: string | null
    /** @format double */
    stockCount: number
    /** @format double */
    reviseCount: number
    isRevised: boolean
    comment?: string | null
}

export interface InventoryProductUpdateItem {
    internalCode?: string | null
    /** @format double */
    reviseCount: number
    isRevised: boolean
    comment?: string | null
}

export interface InventoryStockRef {
    /** @format uuid */
    stockId: string
    stockTitle?: string | null
}

export interface InvoiceBranchResponse {
    branchName?: string | null
    /** @format double */
    discountPercent: number
    /** @format double */
    discountAmount: number
    /** @format double */
    cost: number
}

export interface InvoiceBranchesSummaryResponse {
    branches?: InvoiceBranchResponse[] | null
    /** @format double */
    discountSum: number
    /** @format double */
    totalSum: number
}

/** Invoice list item response model */
export interface InvoiceListItemResponse {
    /**
     * Invoice identifier
     * @format int32
     */
    invoiceId: number
    /** Invoice formatted number (e.g., "1234-5") */
    invoiceNumber?: string | null
    /** Invoice status enumeration */
    status: InvoiceStatusEnum
    /**
     * Payment expiry date
     * @format date
     */
    paymentExpiryDate: string
    /**
     * Invoice creation date
     * @format date
     */
    invoiceDate: string
    /** Is invoice promised (deferred payment) */
    isPromised: boolean
    /**
     * Subscription period in months
     * @format int32
     */
    months: number
    /**
     * Total invoice amount
     * @format double
     */
    sum: number
    /**
     * Remaining balance to be paid
     * @format double
     */
    balance: number
    /** Currency code (e.g., "BYN", "USD") */
    currency?: string | null
}

/** Request model for linking (joining) an existing account to an employee. */
export interface JoinEmployeeAccountRequest {
    /** The login/username of the existing account to be linked. */
    login: string | null
    /** The password of the existing account to confirm access. */
    password?: string | null
}

export interface KeyTexOptionResponse {
    key?: string | null
    text?: string | null
    checked: boolean
}

/** LKassa attribute value. */
export interface LkassaAttributeValueResponse {
    /** @format int32 */
    intValue?: number | null
    /** @format double */
    doubleValue?: number | null
    stringValue?: string | null
    /** @format date-time */
    dateValue?: string | null
    /** @format int32 */
    dimId?: number | null
}

export interface LkassaAuthRequest {
    /** @format uuid */
    cashboxId: string
}

/** LKassa cash register attached to a user. */
export interface LkassaCashBoxResponse {
    /** @format int32 */
    cashId: number
    manufacturerNum?: string | null
    regNum?: string | null
    /** @format date-time */
    openDate: string
    /** @format date-time */
    closeDate?: string | null
    /** @format int32 */
    posId: number
    /** @format int32 */
    depId?: number | null
    /** LKassa dimension/status reference value. */
    status?: LkassaDimStatusResponse
    /** @format date-time */
    expirationDate: string
    /** LKassa dimension/status reference value. */
    applicationScope?: LkassaDimStatusResponse
    currency?: LkassaDimStatusResponse[] | null
    /** @format date-time */
    regNumIssueDate: string
    /** @format date-time */
    certNotBeforeDate: string
    /** @format date-time */
    certNotAfterDate: string
    /** LKassa dimension/status reference value. */
    version?: LkassaDimStatusResponse
    zxreportByDep: boolean
    zxreportNonNullableSum: boolean
    /** @format int32 */
    tariffId: number
    /** @format int32 */
    defaultDepId?: number | null
    defaultItemType?: string | null
    defaultPaymentType?: string | null
    checkShiftCashBalance: boolean
    ordersEnable: boolean
}

/** LKassa dimension/status reference value. */
export interface LkassaDimStatusResponse {
    /** @format int32 */
    dimId: number
    /** @format int32 */
    parentId?: number | null
    dimType?: string | null
    code?: string | null
    name?: string | null
    isLeaf?: boolean | null
    attributes?: Record<string, LkassaAttributeValueResponse>
}

/** LKassa shift information. */
export interface LkassaShiftResponse {
    /**
     * Shift identifier.
     * @format int32
     */
    shiftId: number
    /**
     * Shift number.
     * @format int32
     */
    shiftNumber: number
    /**
     * Cash register identifier.
     * @format int32
     */
    cashId: number
    /**
     * User identifier.
     * @format int32
     */
    userId: number
    /**
     * POS identifier.
     * @format int32
     */
    posId: number
    /**
     * Shift open date.
     * @format date-time
     */
    openDate?: string | null
    /**
     * Shift close date.
     * @format date-time
     */
    closeDate?: string | null
}

/** LKassa current shift statistics. */
export interface LkassaShiftStatsResponse {
    /**
     * Number of tickets in the shift.
     * @format int32
     */
    ticketsCount: number
    /**
     * Total sales amount.
     * @format double
     */
    salesTotal: number
    /**
     * Total refunds amount.
     * @format double
     */
    refundsTotal: number
}

/** LKassa OAuth token. */
export interface LkassaTokenResponse {
    /** Access token. */
    accessToken?: string | null
    /** Token type. */
    tokenType?: string | null
    /** Refresh token. */
    refreshToken?: string | null
    /**
     * Token lifetime in seconds.
     * @format int32
     */
    expiresIn: number
}

export interface LkassaTwoFaRequest {
    twoFaCode?: string | null
}

/** LKassa current user information. */
export interface LkassaUserInfoResponse {
    login?: string | null
    /** @format int32 */
    userId: number
    /** @format int32 */
    orgId: number
    /** @format date-time */
    openDate: string
    /** @format date-time */
    closeDate?: string | null
    userCode?: string | null
    firstName?: string | null
    middleName?: string | null
    lastName?: string | null
    cashBoxes?: LkassaCashBoxResponse[] | null
    roles?: string[] | null
    phone?: string | null
    email?: string | null
    status?: string | null
    authType?: string | null
}

/** Ответ ошибки типа `LockOrderException`. Код см. в поле `Detail`. */
export interface LockOrderExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'LockOrderException'. */
    Title?: 'LockOrderException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `UserNotFound` (HTTP 403) — Employee record for the current user was not found.
     * - `AlreadyLocked` (HTTP 409) — The order is locked by another user; result contains the current lock state.
     */
    Detail?: LockOrderErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface MatchedCategoryItem {
    tagCode?: string | null
    categoryName?: string | null
}

export interface ModelFilterResponse {
    manufacturer?: string | null
    /** @format int32 */
    ordersCount: number
}

export interface MoiZvonkiFiltersResponse {
    users?: MoiZvonkiUserResponse[] | null
}

/** Response model that represents the current integration settings for the "Moi Zvonki" service. */
export interface MoiZvonkiSettingsResponse {
    /** Indicates whether the "Moi Zvonki" integration is enabled. */
    moiZvoinkiEnable: boolean
    /** The username used for authentication with the "Moi Zvonki" service. */
    moiZvoinkiUserName?: string | null
    /** The API key used for secure access to the "Moi Zvonki" service. */
    moiZvoinkiApiKey?: string | null
    /** The base API URL of the "Moi Zvonki" service. */
    moiZvoinkiApiUrl?: string | null
}

export interface MoiZvonkiSmsTemplateResponse {
    /** @format int32 */
    id: number
    name?: string | null
    description?: string | null
    text?: string | null
}

export interface MoiZvonkiUserResponse {
    displayName?: string | null
    email?: string | null
}

/** Request model for reordering a bucket. */
export interface MoveBucketRequest {
    /**
     * ID of the bucket before the target position, or null if moving to the first position.
     * @format int32
     */
    previousBucketId?: number | null
    /**
     * ID of the bucket after the target position, or null if moving to the last position.
     * @format int32
     */
    nextBucketId?: number | null
}

/** Response returned after moving a bucket. */
export interface MoveBucketResponse {
    /** The computed lexorank position. */
    position?: string | null
}

/** Request model for moving a task within a bucket. */
export interface MoveTaskRequest {
    /**
     * ID of the task above the target position, or null if inserting at the top.
     * @format int32
     */
    previousTaskId?: number | null
    /**
     * ID of the task below the target position, or null if inserting at the bottom.
     * @format int32
     */
    nextTaskId?: number | null
}

/** Response returned after moving a task. */
export interface MoveTaskResponse {
    /** The computed lexorank position, or null if removed from bucket. */
    positionInBucket?: string | null
}

/** Response model for a calendar event in the Personal Navigator. */
export interface NavigatorCalendarEventResponse {
    /**
     * The unique identifier of the calendar event.
     * @format int32
     */
    eventId: number
    /**
     * The unique identifier of the client (nullable if event has no client).
     * @format int32
     */
    clientId?: number | null
    /** The display name of the client. */
    clientName?: string | null
    /**
     * The unique identifier of the car (nullable if event has no car).
     * @format int32
     */
    carId?: number | null
    /** The model of the car. */
    carModel?: string | null
    carRegNumber?: string | null
    description?: string | null
    /**
     * The start date and time of the event in UTC.
     * @format date-time
     */
    startDateTimeUtc: string
    /**
     * The end date and time of the event in UTC.
     * @format date-time
     */
    endDateTimeUtc: string
    status: EventStatusEnum
}

/** Response model for a car in the Personal Navigator. */
export interface NavigatorCarResponse {
    /**
     * The unique identifier of the car.
     * @format int32
     */
    carId: number
    /** The display name of the car. */
    carName?: string | null
    /** The registration number of the car. */
    carRegNumber?: string | null
}

/** Response model for a favorite client in the Personal Navigator. */
export interface NavigatorFavoriteClientResponse {
    /**
     * The unique identifier of the client.
     * @format int32
     */
    clientId: number
    /** The display name of the client. */
    clientName?: string | null
    email?: string | null
    /** The primary phone number of the client. */
    phone?: string | null
}

/**
 * Response model for the Favorites tab
 * Groups different types of favorites (clients, cars, documents)
 */
export interface NavigatorFavoritesResponse {
    /** List of favorite clients. */
    clients?: NavigatorFavoriteClientResponse[] | null
}

/** Response model for an order in the Personal Navigator. */
export interface NavigatorOrderResponse {
    /**
     * The unique identifier of the order.
     * @format int32
     */
    orderId: number
    /**
     * The unique identifier of the client.
     * @format int32
     */
    clientId: number
    /** The display name of the client. */
    clientName?: string | null
    /**
     * The unique identifier of the car.
     * @format int32
     */
    carId: number
    /** The model of the car. */
    carModel?: string | null
    /** The registration number of the car. */
    carRegNumber?: string | null
    /**
     * The date when the order was created.
     * @format date-time
     */
    orderDate: string
    /** The order number. */
    orderNumber?: string | null
    /** The act number. */
    actNumber?: string | null
    orderStatus: OrderStatus
}

/** A task item in the Personal Navigator. */
export interface NavigatorTaskResponse {
    /**
     * Primary key.
     * @format int32
     */
    id: number
    /** Short title of the task. */
    title?: string | null
    /** Optional detailed description. */
    description?: string | null
    /** Task status values. */
    status: TaskStatusEnum
    /**
     * Optional due date (UTC).
     * @format date-time
     */
    dueDate?: string | null
    /** Resource type the task is associated with, or null. */
    resourceType?: string | null
    /** Resource identifier, or null. */
    resourceId?: string | null
    /**
     * Timestamp when the task was created (UTC).
     * @format date-time
     */
    createdAt: string
    /** True when the task has a due date in the past and is not yet completed. */
    isOverdue: boolean
}

/** Aggregated response containing the current user's tasks split into two lists. */
export interface NavigatorTasksResponse {
    /** Tasks created by the current user. */
    createdByMe?: NavigatorTaskResponse[] | null
    /** Tasks assigned to the current user but created by someone else. */
    assignedToMe?: NavigatorTaskResponse[] | null
}

export interface NewsPostResponse {
    /** @format uuid */
    id: string
    title?: string | null
    url?: string | null
    /** @format date-time */
    createdAt: string
    translations?: NewsTranslationResponse[] | null
}

export interface NewsTranslationResponse {
    title?: string | null
    url?: string | null
    language?: string | null
}

/** Ответ ошибки типа `NipException`. Код см. в поле `Detail`. */
export interface NipExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'NipException'. */
    Title?: 'NipException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `InvalidTin` — Идентификатор (УНП для Беларуси / NIP для Польши) не соответствует формату выбранной страны.
     * - `CountryNotSupported` — Поиск по реестру не поддерживается для выбранной страны (доступны только Беларусь и Польша).
     */
    Detail?: NipErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface NipResponse {
    prop1?: string | null
    prop2?: string | null
    prop3?: string | null
    address?: string | null
    title?: string | null
    /** Company status returned by the NIP/TIN lookup. */
    companyStatus: CompanyStatusEnum
}

/** Response model for a note. */
export interface NoteResponse {
    /**
     * The unique identifier of the note.
     * @format int32
     */
    id: number
    /** The identifier of the user who created the note. */
    ownerId?: string | null
    /** The content/description of the note. */
    description?: string | null
    /** Indicates whether the note is visible to all users (true) or only to the owner (false). */
    isPublic: boolean
    /** Indicates whether the note is pinned to the top of the list. */
    isPinned: boolean
    /**
     * The timestamp when the note was created (UTC).
     * @format date-time
     */
    createdAt: string
    /**
     * The timestamp when the note was last modified (UTC).
     * @format date-time
     */
    modifiedAt: string
}

/**
 * Response model representing a summarized view of an order for browsing or listing purposes.
 * Includes identifiers, financial metrics, related entities, and metadata.
 */
export interface OrderBrowseResponse {
    /**
     * Unique identifier of the order.
     * @format int32
     */
    id: number
    /**
     * Identifier of the responsible employee for the order.
     * @format int32
     */
    responsibleId: number
    /**
     * Identifier of the owner (station or entity) associated with the order.
     * @format int32
     */
    ownerId: number
    /**
     * Identifier of the client linked to the order.
     * @format int32
     */
    clientId: number
    /**
     * Identifier of the payer (if different from the client).
     * @format int32
     */
    payerId: number
    /**
     * Identifier of the vehicle associated with the order.
     * @format int32
     */
    vehicleId: number
    /**
     * Identifier of the bank account associated with the order.
     * @format uuid
     */
    bankAccount?: string | null
    /** Order number (may be null if not assigned). */
    orderNo?: string | null
    /** Act number associated with the order (may be null). */
    actNo?: string | null
    /** Indicates whether this order is a training/demo order. */
    isTraining: boolean
    /** Additional notes attached to the order. */
    notes?: string | null
    numberingType: OrderNumberingTypeEnum
    status: OrderStatusEnum
    currency: CurrencyCodeEnum
    /**
     * The date when the order was created/registered.
     * @format date-time
     */
    orderDate: string
    /**
     * The estimated completion date of the order.
     * @format date-time
     */
    estimateDate: string
    /**
     * The due date for payment (if applicable).
     * @format date-time
     */
    paymentDueDate?: string | null
    /**
     * The actual date of payment (if completed).
     * @format date-time
     */
    paymentDate?: string | null
    cashPayment: boolean
    /**
     * Discount amount applied to works.
     * @format double
     */
    wksDiscountAmount: number
    /**
     * Discount amount applied to spares.
     * @format double
     */
    sprDiscountAmount: number
    /**
     * Total discount amount applied to the order.
     * @format double
     */
    ttlDiscountAmount: number
    /**
     * Profit from works.
     * @format double
     */
    wksProfit: number
    /**
     * Profit from contractors.
     * @format double
     */
    ctrProfit: number
    /**
     * Profit from spares.
     * @format double
     */
    sprProfit: number
    /**
     * Total profit from the order.
     * @format double
     */
    ttlProfit: number
    /**
     * Works cost including VAT.
     * @format double
     */
    wksCostVat: number
    /**
     * Contractor cost including VAT.
     * @format double
     */
    ctrCostVat: number
    /**
     * Spare parts cost including VAT.
     * @format double
     */
    sprCostVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    ttlCostVat: number
    /**
     * Works cost total.
     * @format double
     */
    wksCostTotal: number
    /**
     * Contractor cost total.
     * @format double
     */
    ctrCostTotal: number
    /**
     * Spare parts cost total.
     * @format double
     */
    sprCostTotal: number
    /**
     * Overall order cost total.
     * @format double
     */
    ttlCostTotal: number
    /**
     * Total work norms (standard times).
     * @format double
     */
    wksNormsTotal: number
    /**
     * Cost of customer spares.
     * @format double
     */
    cspCostTotal: number
    /**
     * Current balance of the order.
     * @format double
     */
    balance: number
    /**
     * Date when the order was created in the system.
     * @format date-time
     */
    created: string
    /**
     * Date when the order was last modified.
     * @format date-time
     */
    modified: string
    /** Response model that represents detailed information about a car. */
    vehicle?: CarResponse
    /**
     * Response model representing a preview of client information.
     * Used for listing clients with key attributes and related data.
     */
    owner?: ClientPreviewResponse
    /**
     * Response model representing a preview of client information.
     * Used for listing clients with key attributes and related data.
     */
    client?: ClientPreviewResponse
    /**
     * Response model representing a preview of client information.
     * Used for listing clients with key attributes and related data.
     */
    payer?: ClientPreviewResponse
    /**
     * Represents a preview of an employee.
     * Used to display a list of employees without detailed information.
     */
    responsible?: EmployeePreviewResponse
    /** Response model that represents the details of a station bank account. */
    stationBankAccount?: StationBankAccountResponse
    /** List of employees who worked on this order. */
    workers?: EmployeePreviewResponse[] | null
    /** Tags attached to this order (categorization/metadata). */
    tags?: TagResponse[] | null
}

export interface OrderBrowseResponsePaginatedCollection {
    page?: OrderBrowseResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

/** Ответ ошибки типа `OrderBusinessRuleException`. Код см. в поле `Detail`. */
export interface OrderBusinessRuleExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OrderBusinessRuleException'. */
    Title?: 'OrderBusinessRuleException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `OrderReopeningNotAllowed` — RestrictOrderReopening: попытка понизить статус закрытого заказа. result содержит orderId и targetStatus.
     * - `DocumentReissueNotAllowed` — RestrictOrderReopening: попытка переоформить закрытый документ — сменить номер заказа или акта либо признак учебного заказа. result содержит orderId.
     * - `ClosedOrderMutationNotAllowed` — RestrictClosedOrders: заказ оплачен и изменению не подлежит. result содержит orderId.
     * - `FinalizedOrderMutationNotAllowed` — RestrictOrderReopening: заказ в финальном статусе, содержимое менять нельзя. Проверяется только в MobileApi. result содержит orderId и status.
     * - `NotOwnOrderMutationNotAllowed` — RestrictOthersOrders: сотрудник не указан ответственным по этому заказу. result содержит orderId.
     * - `OthersOrderResponsibleChangeNotAllowed` — RestrictOthersOrderResponsible: менять ответственного в чужом заказе нельзя. result содержит orderId.
     * - `StatusTransitionNotAllowed` — ForbiddenTargetStatuses: перевод в этот статус сотруднику запрещён. result содержит targetStatus и, если заказ уже существует, orderId.
     */
    Detail?: OrderBusinessRuleErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Персональные ограничения сотрудника на работу с заказами. Все поля — запреты:
 * выключенный флаг и пустой список всегда означают «ограничения нет».
 */
export interface OrderBusinessRulesRequest {
    /**
     * Запрещает понижать статус закрытого заказа и переоформлять номера документов.
     * Из финального статуса остаётся разрешён только переход «Выполнен» → «Оплачен».
     */
    restrictOrderReopening: boolean
    /** Запрещает любые изменения оплаченного заказа, включая дату оплаты. */
    restrictClosedOrders: boolean
    /**
     * Статусы, в которые сотруднику запрещено переводить заказ.
     * Допустимы только «Выполнен» и «Оплачен». Null и пустой список — ничего не запрещено.
     */
    forbiddenTargetStatuses?: OrderStatusEnum[] | null
    /**
     * Запрещает менять ответственного в чужом заказе; остальное в нём менять можно.
     * В своём заказе ответственного менять можно.
     */
    restrictOthersOrderResponsible: boolean
    /**
     * Запрещает изменять чужой заказ вообще. Строже предыдущего; при обоих включённых
     * побеждает это. Видеть и печатать чужие заказы не мешает ни то, ни другое.
     */
    restrictOthersOrders: boolean
}

export interface OrderBusinessRulesResponse {
    restrictOrderReopening: boolean
    restrictClosedOrders: boolean
    forbiddenTargetStatuses?: OrderStatusEnum[] | null
    restrictOthersOrderResponsible: boolean
    restrictOthersOrders: boolean
}

/**
 * Response model representing detailed client information.
 * Provides full data about a client, including contacts, banking details, discounts, and metadata.
 */
export interface OrderClientResponse {
    /**
     * The unique identifier of the client.
     * @format int32
     */
    id: number
    clientTypeCode: ClientTypeEnum
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName?: string | null
    /** The email address of the client (optional). */
    email?: string | null
    /** The Skype contact of the client (optional). */
    skype?: string | null
    /** The Telegram contact of the client (optional). */
    telegram?: string | null
    /** The street address of the client (optional). */
    streetAddress?: string | null
    /** Additional notes or annotations about the client (optional). */
    annotation?: string | null
    /** The name of the bank associated with the client (optional). */
    bank?: string | null
    /** The bank code (e.g., SWIFT or local code) (optional). */
    bankCode?: string | null
    /** The bank account number of the client (optional). */
    bankAccount?: string | null
    /** The address of the client’s bank (optional). */
    bankAddress?: string | null
    /** The full name of the company director (optional). */
    director?: string | null
    /** The full name of the company accountant (optional). */
    accountant?: string | null
    /**
     * The general discount percentage applied to the client’s services.
     * @format int32
     */
    discountWorks: number
    /**
     * The discount percentage applied to spare parts.
     * @format int32
     */
    discountSpares: number
    /** The discount card number associated with the client (optional). */
    discountCard?: string | null
    /** Indicates whether the client is a resident (optional). */
    resident?: boolean | null
    /** The client’s birthday (optional). */
    birthday?: string | null
    /** Indicates whether the client requires follow-up calls. */
    isNeedCall: boolean
    /** Marks the client as a favorite. */
    isFavorite: boolean
    /** Indicates whether the client is marked as trusted. */
    isTrusted: boolean
    /** The contract identifier associated with the client (optional). */
    contract?: string | null
    /** The contract start date (optional). */
    contractDate?: string | null
    /** The contract end date (optional). */
    contractEndDate?: string | null
    /** The legal basis for the contract (optional). */
    based?: string | null
    /** Indicates whether SMS notifications are disabled for this client. */
    banSms: boolean
    /** The description or reason for disabling SMS notifications (optional). */
    banSmsDescription?: string | null
    /**
     * The rate number associated with the client.
     * @format int32
     */
    rateNumber?: number | null
    countryCode: CountryEnum
    /** The unique taxpayer identification number (UNP) of the client (optional). */
    unp?: string | null
    /** Custom property 2 (for extended data). */
    prop2?: string | null
    /** Custom property 3 (for extended data). */
    prop3?: string | null
    /** A list of sources from which the client was acquired. */
    sources?: SourceResponse[] | null
    /** Client contacts */
    contacts?: ClientContactResponse[] | null
    /**
     * The date and time when the client record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the client record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

/**
 * Represents a spare part provided by the client and attached to an order.
 * Includes details such as name, quantity, pricing, and usage status.
 */
export interface OrderClientSpareResponse {
    /**
     * Unique identifier of the client spare part record.
     * @format int32
     */
    id: number
    /**
     * The position (sorting index) of the spare part in the order’s spare list.
     * @format int32
     */
    position: number
    /** The catalog number of the spare part (optional, may come from a catalog or be manually entered). */
    catalogNumber?: string | null
    /** The name/description of the spare part provided by the client. */
    spareName?: string | null
    /** The unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * The quantity of the spare part provided by the client.
     * @format float
     */
    count: number
    condition: OrderClientSpareConditionEnum
    /**
     * The input price of the spare part (value assigned, before markup).
     * @format double
     */
    inputPrice: number
}

/**
 * Represents a contractor-provided work item within an order,
 * including its financial and descriptive details.
 */
export interface OrderContractorWorkResponse {
    /**
     * Unique identifier of the contractor work record.
     * @format int32
     */
    id: number
    /**
     * The position (sorting index) of the work in the order’s contractor work list.
     * @format int32
     */
    position: number
    /**
     * The identifier of the contractor who performed the work.
     * @format int32
     */
    contractorId: number
    /** The description of the contractor's work (e.g., "Wheel alignment", "Painting"). */
    workDesc?: string | null
    /**
     * The applied VAT (Value Added Tax) percentage for this work.
     * @format double
     */
    vat: number
    /**
     * The initial input price without vat
     * @format double
     */
    inputPriceNoVat: number
    /**
     * The initial input price (cost provided by contractor, before taxes).
     * @format double
     */
    inputPriceVat: number
    /**
     * The initial input price (cost provided by contractor, before taxes).
     * @format double
     */
    inputPrice: number
    /** @format double */
    extraAmount: number
    /** @format double */
    extraPercent: number
    /**
     * The cost of the work excluding VAT.
     * @format double
     */
    costNoVat: number
    /**
     * The VAT amount applied to the cost of the work.
     * @format double
     */
    costVat: number
    /**
     * The total cost including VAT.
     * @format double
     */
    costTotal: number
    /**
     * The calculated profit margin for this contractor work.
     * @format double
     */
    profit: number
    /** Represents contractor details returned in a response. */
    contractor?: ContractorResponse
}

/** Represents a user-defined (customer) work entry associated with an order. */
export interface OrderCustomerWorkResponse {
    /**
     * Unique identifier of the customer work.
     * @format int32
     */
    id: number
    /**
     * The position (order index) of the work item in the list.
     * Used for sorting and execution sequence.
     * @format int32
     */
    position: number
    /** Title or description of the customer work. */
    title?: string | null
    /**
     * Date and time when this customer work entry was created.
     * @format date-time
     */
    created: string
    /** User identifier (login/username) of the creator of this entry. */
    createdBy?: string | null
    /**
     * Date and time when this customer work entry was last modified.
     * @format date-time
     */
    modified: string
    /** User identifier (login/username) of the person who last modified this entry. */
    modifiedBy?: string | null
}

export interface OrderDashboardPreviewResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    ownerId: number
    /** @format int32 */
    clientId: number
    /** @format int32 */
    payerId?: number | null
    /** @format int32 */
    vehicalId: number
    orderNo?: string | null
    actNo?: string | null
    status: OrderStatus
    /** @format date-time */
    orderDate: string
    /** @format date-time */
    estimateDate?: string | null
    /** @format date-time */
    paymentDueDate?: string | null
    /** @format date-time */
    paymentDate?: string | null
    /** @format double */
    wksDiscountAmount: number
    /** @format double */
    sprDiscountAmount: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    wksProfit: number
    /** @format double */
    ctrProfit: number
    /** @format double */
    sprProfit: number
    /** @format double */
    ttlProfit: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    ctrCostVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    ctrCostTotal: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    cspCostTotal: number
    /** @format double */
    balance: number
    /**
     * Response model that represents a preview of car information.
     * Used for listing cars with essential details while omitting full specifications.
     */
    car?: CarPreviewResponse
    /**
     * Response model representing a preview of client information.
     * Used for listing clients with key attributes and related data.
     */
    owner?: ClientPreviewResponse
    /**
     * Response model representing a preview of client information.
     * Used for listing clients with key attributes and related data.
     */
    client?: ClientPreviewResponse
    /**
     * Response model representing a preview of client information.
     * Used for listing clients with key attributes and related data.
     */
    payer?: ClientPreviewResponse
    /** @format date-time */
    created: string
    /** @format date-time */
    modified: string
}

export interface OrderDashboardResponse {
    data?: OrderDashboardPreviewResponse[] | null
    /** @format int32 */
    count: number
}

/**
 * Ответ ошибки типа `OrderFileException`. Код см. в поле `Detail`.
 *
 * Thrown when an order-file upload is rejected during validation. Carries a typed plus structured parameters (via the base Result) so the UI can render its own localized message instead of parsing text.
 */
export interface OrderFileExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OrderFileException'. */
    Title?: 'OrderFileException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `Empty` — The uploaded file has zero length.
     * - `TooLarge` — The uploaded file exceeds the maximum allowed size.
     * - `InvalidType` — The uploaded file has an unsupported content type.
     */
    Detail?: OrderFileErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Response containing a list of order files. */
export interface OrderFileListResponse {
    /** List of files attached to the order. */
    files?: OrderFileResponse[] | null
    /**
     * Total number of files.
     * @format int32
     */
    totalCount: number
}

/** Represents a file attached to an order with secure temporary access URL. */
export interface OrderFileResponse {
    /**
     * Unique file identifier in media storage.
     * @format uuid
     */
    id: string
    /** Original file name. */
    fileName?: string | null
    /** MIME content type of the file (e.g. image/jpeg). */
    contentType?: string | null
    /**
     * File size in bytes.
     * @format int64
     */
    size: number
    /** Temporary secure URL for accessing the file (~15 minutes). */
    tempUrl?: string | null
    /**
     * UTC timestamp when the file was uploaded.
     * @format date-time
     */
    createdAtUtc: string
}

/**
 * Response model representing the lock status of an order.
 * Contains information about whether the order is locked,
 * who locked it, and when it was last changed.
 */
export interface OrderLockStatusResponse {
    /**
     * The date and time when the lock status was last changed.
     * @format date-time
     */
    lastChanged: string
    /** Indicates whether the order is currently locked. */
    locked: boolean
    /** The login or identifier of the user who locked the order. */
    lockedBy?: string | null
    /** Response model representing detailed information about an employee */
    employee?: EmployeeResponse
}

/** Represents details about a single missed (skipped) order number. */
export interface OrderMissedNumberModel {
    /** The skipped order number (may be null if the number was not assigned). */
    orderNo?: string | null
    /**
     * The date associated with the missed order number.
     * @format date-time
     */
    orderDate: string
}

/**
 * Represents the response containing information about missed (skipped) order numbers
 * and the next available order number.
 */
export interface OrderMissedNumberResponse {
    /** The list of missed (skipped) order numbers with their corresponding dates. */
    missed?: OrderMissedNumberModel[] | null
    /**
     * The next available order number in the sequence.
     * @format int32
     */
    next: number
}

export interface OrderNumberRequest {
    /** @format int32 */
    orderId: number
    orderActTextNo?: string | null
}

/** Ответ ошибки типа `OrderNumberingException`. Код см. в поле `Detail`. */
export interface OrderNumberingExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OrderNumberingException'. */
    Title?: 'OrderNumberingException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `OrderNumberExists` — The order number is already in use.
     * - `ActNumberExists` — The act number is already in use.
     * - `InvalidNumberFormat` — The number does not match the configured numbering format.
     * - `InvalidNumberingType` — The configured numbering type is not supported.
     */
    Detail?: OrderNumberingErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface OrderPreviewInfoResponse {
    /** @format int32 */
    orderId: number
    orderNo?: string | null
    orderStatus: OrderStatusEnum
    /** @format date-time */
    orderDate: string
    actNo?: string | null
    totalSum?: string | null
    /** @format int32 */
    mileage: number
    vehicleRegNo?: string | null
    vehicleVin?: string | null
    vehicleId?: string | null
}

export interface OrderRecycleBinMetadata {
    orderNo?: string | null
    actNo?: string | null
    status: OrderStatusEnum
    /** @format date-time */
    orderDate: string
}

/**
 * Represents the full details of an order, including metadata,
 * financial calculations, related clients, vehicle, and child objects.
 */
export interface OrderResponse {
    /**
     * Unique identifier of the order.
     * @format int32
     */
    id: number
    /** Concurrency version token. */
    version?: string | null
    /**
     * Identifier of the associated bank account.
     * @format uuid
     */
    bankAccount: string
    /**
     * Identifier of the responsible employee for the order.
     * @format int32
     */
    employeeId: number
    /**
     * Identifier of the owner (organization or person) of the order.
     * @format int32
     */
    ownerId: number
    /**
     * Identifier of the client who requested the order.
     * @format int32
     */
    clientId: number
    /**
     * Identifier of the payer responsible for the payment.
     * @format int32
     */
    payerId: number
    /**
     * Identifier of the associated vehicle.
     * @format int32
     */
    vehicleId: number
    /**
     * Optional identifier of the contract associated with this order.
     * @format uuid
     */
    contractId?: string | null
    status: OrderStatusEnum
    numberingType: OrderNumberingTypeEnum
    /** The assigned order number (if available). */
    orderNo?: string | null
    /** The associated act number (if available). */
    actNo?: string | null
    /**
     * Current mileage of the vehicle (if specified).
     * @format int32
     */
    mileage?: number | null
    /** Indicates whether the order is a training/demo order. */
    isTraining: boolean
    /** Proxy number (if applicable). */
    proxyNumber?: string | null
    /** Description of malfunctions reported by the client. */
    malfunctions?: string | null
    /** Additional notes for the order. */
    notes?: string | null
    /** Recommendations provided for the order. */
    recommendation?: string | null
    /** Warranty information related to the order. */
    warranty?: string | null
    /**
     * Date when the order was created/issued.
     * @format date-time
     */
    orderDate: string
    /**
     * Estimated completion date for the order.
     * @format date-time
     */
    estimateDate: string
    /**
     * Due date for payment (if defined).
     * @format date-time
     */
    paymentDueDate?: string | null
    /**
     * Actual payment date (if payment was made).
     * @format date-time
     */
    paymentDate?: string | null
    /**
     * VAT (НДС) applied to works.
     * @format double
     */
    worksVat: number
    /**
     * VAT (НДС) applied to spares.
     * @format double
     */
    sparesVat: number
    /** TODO: Remove */
    cashPayment: boolean
    /**
     * Order balance.
     * @format double
     */
    balance: number
    /**
     * Total discount applied to works.
     * @format double
     */
    wksDiscountAmount: number
    /**
     * Total discount applied to spares.
     * @format double
     */
    sprDiscountAmount: number
    /**
     * Total discount amount across the order.
     * @format double
     */
    ttlDiscountAmount: number
    /**
     * Profit from works.
     * @format double
     */
    wksProfit: number
    /**
     * Profit from contractors.
     * @format double
     */
    ctrProfit: number
    /**
     * Profit from spares.
     * @format double
     */
    sprProfit: number
    /**
     * Total profit across the order.
     * @format double
     */
    ttlProfit: number
    /**
     * Works cost excluding VAT.
     * @format double
     */
    wksCostNoVat: number
    /**
     * Contractor cost excluding VAT.
     * @format double
     */
    ctrCostNoVat: number
    /**
     * Spares cost excluding VAT.
     * @format double
     */
    sprCostNoVat: number
    /**
     * Total cost excluding VAT.
     * @format double
     */
    ttlCostNoVat: number
    /**
     * Works VAT amount.
     * @format double
     */
    wksCostVat: number
    /**
     * Contractor VAT amount.
     * @format double
     */
    ctrCostVat: number
    /**
     * Spares VAT amount.
     * @format double
     */
    sprCostVat: number
    /**
     * Total VAT amount.
     * @format double
     */
    ttlCostVat: number
    /**
     * Works cost including VAT.
     * @format double
     */
    wksCostTotal: number
    /**
     * Contractor cost including VAT.
     * @format double
     */
    ctrCostTotal: number
    /**
     * Spares cost including VAT.
     * @format double
     */
    sprCostTotal: number
    /**
     * Total cost including VAT.
     * @format double
     */
    ttlCostTotal: number
    /**
     * Total norms for works.
     * @format double
     */
    wksNormsTotal: number
    /**
     * Contractor spare part cost.
     * @format double
     */
    cspCostTotal: number
    /**
     * Discount based on client-specific rules for works.
     * @format double
     */
    discountWksClient: number
    /**
     * Discount based on car-specific rules for works.
     * @format double
     */
    discountWksCar: number
    /**
     * Total discount for works.
     * @format double
     */
    discountWksTtl: number
    /**
     * Total discount for spares.
     * @format double
     */
    discountSprTtl: number
    /**
     * Discount applied by year-based rules.
     * @format double
     */
    discountYear: number
    /**
     * Order creation timestamp.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * Order last modification timestamp.
     * @format date-time
     */
    modifiedAt: string
    modifiedBy?: string | null
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    owner?: OrderClientResponse
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    client?: OrderClientResponse
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    payer?: OrderClientResponse
    /** Response model that represents detailed information about a car. */
    vehicle?: OrderVehicleResponse
    /** List of customer works (external work items provided by the client). */
    customerWorks?: OrderCustomerWorkResponse[] | null
    /** List of works included in the order. */
    orderWorks?: OrderStationWorkResponse[] | null
    /** List of contractor works performed under the order. */
    contractorWorks?: OrderContractorWorkResponse[] | null
    /** List of client-provided spare parts. */
    clientSpares?: OrderClientSpareResponse[] | null
    /** List of station-provided spare parts. */
    stationSpares?: OrderStationSpareResponse[] | null
    /** List of tags assigned to the order. */
    tags?: TagResponse[] | null
}

export interface OrderSearchResultResponse {
    id?: string | null
    orderNo?: string | null
    orderStatus: OrderStatusEnum
    /** @format date-time */
    orderDate: string
    regNo?: string | null
    bodyNo?: string | null
    modificationName?: string | null
    ownerFullName?: string | null
    clientFullName?: string | null
    employeeFullName?: string | null
}

export interface OrderSnapshotDataResponse {
    orderNo?: string | null
    actNo?: string | null
    orderNumberingType?: string | null
    /** @format date-time */
    orderDate: string
    /** @format date-time */
    estimateDate?: string | null
    /** @format date-time */
    paymentDueDate?: string | null
    /** @format date-time */
    paymentDate?: string | null
    status?: string | null
    /** @format double */
    balance: number
    /** @format double */
    totalCost: number
    /** @format double */
    totalProfit: number
    malfunctions?: string | null
    notes?: string | null
    recommendation?: string | null
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    employee?: EntityReferenceSnapshotResponse
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    owner?: EntityReferenceSnapshotResponse
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    client?: EntityReferenceSnapshotResponse
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    payer?: EntityReferenceSnapshotResponse
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    car?: EntityReferenceSnapshotResponse
    /** @format int32 */
    mileage: number
    proxyNumber?: string | null
    customerWorks?: CustomerWorkSnapshotResponse[] | null
    clientSpares?: ClientSpareSnapshotResponse[] | null
    stationSpares?: StationSpareSnapshotResponse[] | null
    orderWorks?: OrderWorkSnapshotResponse[] | null
    contractorWorks?: ContractorWorkSnapshotResponse[] | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface OrderSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: OrderSnapshotDataResponse
}

export interface OrderStationReportResponse {
    /** @format int32 */
    orderId: number
    orderNo?: string | null
    actNo?: string | null
    /** @format date-time */
    orderDate: string
    /** @format date-time */
    estimateDate: string
    /** @format date-time */
    paymentDueDate?: string | null
    /** @format date-time */
    paymentDate?: string | null
    /** @format double */
    wksDiscountAmount: number
    /** @format double */
    sprDiscountAmount: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    wksProfit: number
    /** @format double */
    ctrProfit: number
    /** @format double */
    sprProfit: number
    /** @format double */
    ttlProfit: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    ctrCostNoVat: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    ctrCostVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    ctrCostTotal: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    cspCostTotal: number
    /** @format double */
    discountWksClient: number
    /** @format double */
    discountWksCar: number
    /** @format double */
    discountWksTtl: number
    /** @format double */
    discountSprTtl: number
    /** @format double */
    discountYear: number
    /** @format int32 */
    ownerId: number
    /** @format int32 */
    clientId: number
    /** @format int32 */
    payerId: number
    /** @format int32 */
    vehicleId: number
    /** @format int32 */
    mileage: number
    owner?: ClientStationReportResponse
    client?: ClientStationReportResponse
    payer?: ClientStationReportResponse
    vehicle?: VehicleStationReportResult
    customerWorks?: OrderCustomerWorkResponse[] | null
    stationWorks?: OrderStationWorkResponse[] | null
    contractorWorks?: OrderContractorWorkResponse[] | null
    stationSpares?: OrderStationSpareResponse[] | null
    clientSpares?: OrderClientSpareResponse[] | null
    /** @format double */
    balance: number
}

/**
 * Represents a spare part provided by the station (workshop) and attached to an order.
 * Contains detailed financial calculations, stock linkage, and metadata.
 */
export interface OrderStationSpareResponse {
    /**
     * Unique identifier of the station spare record.
     * @format int32
     */
    id: number
    /**
     * The position (sorting index) of the spare part in the order’s spare list.
     * @format int32
     */
    position: number
    /** The name/description of the spare part. */
    spareName?: string | null
    /** Country of origin for the spare part (optional). */
    country?: string | null
    /** The brand name of the spare part (optional). */
    brandName?: string | null
    /** Vendor code (article number provided by manufacturer or supplier, optional). */
    vendorCode?: string | null
    /** Catalog number (article) of the spare part (optional). */
    catalogNumber?: string | null
    /**
     * The quantity of the spare part used in the order.
     * @format double
     */
    count: number
    /** Unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * Identifier of the employee responsible for this spare part.
     * @format int32
     */
    responsibleId: number
    /**
     * Base input price (per unit) without VAT.
     * @format double
     */
    inputPriceNoVat: number
    /**
     * Total input price without VAT for all items (InputPriceNoVat * Count).
     * @format double
     */
    inputPriceNoVatTotal: number
    /**
     * VAT amount applied to the input price.
     * @format double
     */
    inputPriceVat: number
    /**
     * Input price (per unit) including VAT.
     * @format double
     */
    inputPrice: number
    /**
     * Total input price including VAT for all items.
     * @format double
     */
    inputPriceTotal: number
    /**
     * Absolute markup (extra charge) applied to the spare part.
     * @format double
     */
    extraAmount: number
    /**
     * Percentage markup applied to the spare part.
     * @format double
     */
    extraPercent: number
    /**
     * Selling price per unit without VAT.
     * @format double
     */
    priceNoVat: number
    /**
     * Total selling price without VAT for all items.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount applied to the selling price.
     * @format double
     */
    priceVat: number
    /**
     * Selling price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * Total selling price including VAT for all items.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to this spare part.
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount applied.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount included in the cost.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments for this spare part. */
    notes?: string | null
    /**
     * Calculated profit for this spare part (selling price - cost).
     * @format double
     */
    profit: number
    /**
     * Identifier of the stock (warehouse) from which the spare part was taken.
     * @format uuid
     */
    stockId?: string | null
    /**
     * Identifier of the product in stock system.
     * @format uuid
     */
    productId?: string | null
    /** Internal code of the spare part in stock system (optional). */
    internalCode?: string | null
    status: OrderStationSparesStatusEnum
}

/**
 * Represents a station work entry within an order, including details about
 * the performed work, pricing, costs, and assigned employees.
 */
export interface OrderStationWorkResponse {
    /**
     * Unique identifier of the station work entry.
     * @format int32
     */
    id: number
    /**
     * Position (ordering) of this work within the order.
     * @format int32
     */
    position: number
    /** Identifier of the work item (from catalog or external source). */
    workId?: string | null
    /** Description of the work performed. */
    workDesc?: string | null
    workSource: WorkSourceEnum
    /**
     * Quantity of work items.
     * @format double
     */
    count: number
    /**
     * Standard norm time for a single unit of this work.
     * @format double
     */
    normTime: number
    /**
     * Total calculated norm time (NormTime × Count).
     * @format double
     */
    normTimeTotal: number
    /**
     * Identifier of the responsible employee.
     * @format int32
     */
    responsibleId: number
    /**
     * Optional rate number (used for calculating pricing based on station rate tables).
     * @format int32
     */
    rateNumber?: number | null
    /**
     * Price per unit (rate price).
     * @format double
     */
    ratePrice: number
    /**
     * Price without VAT for a single unit of work.
     * @format double
     */
    priceNoVat: number
    /**
     * Total price without VAT (PriceNoVat × Count).
     * @format double
     */
    priceNoVatTotal: number
    /**
     * Price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * VAT amount for the work.
     * @format double
     */
    priceVat: number
    /**
     * Total price including VAT.
     * @format double
     */
    priceTotal: number
    /**
     * Applied discount percentage.
     * @format double
     */
    discount: number
    /**
     * Discount amount in absolute value.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT (CostNoVat × Count).
     * @format double
     */
    costNoVatTotal: number
    /**
     * Cost of VAT applied to this work.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments about the work. */
    notes?: string | null
    /**
     * Calculated profit (difference between price and cost).
     * @format double
     */
    profit: number
    /** Indicates whether the norm time should be hidden in reports/UI. */
    isHideNormTime: boolean
    /** Indicates whether this work should be excluded from order calculations. */
    ignoreWorkOnCalc: boolean
    status: OrderWorkStatusEnum
    calc: EmployeeCalcTypeEnum
    /** List of employees assigned to this work. */
    workers?: OrderWorkEmployeeResponse[] | null
}

export interface OrderStatusKeyTexOptionResponse {
    key: OrderStatusEnum
    checked: boolean
}

/** Ответ ошибки типа `OrderStockCheckException`. Код см. в поле `Detail`. */
export interface OrderStockCheckExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OrderStockCheckException'. */
    Title?: 'OrderStockCheckException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadStockRef` — The order references warehouse stocks that do not exist.
     * - `BadStockReserves` — Not enough free stock to reserve the order products; result contains only the lacking products grouped by stock.
     * - `BadStockBalance` — Not enough stock balance to ship the order products; result contains only the lacking products grouped by stock.
     */
    Detail?: OrderStockCheckErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: {
        /** Типизированная полезная нагрузка. Какие коды её заполняют — см. описания значений `Detail`. */
        result?: OrderStockShortage[] | null
        /** Ошибки валидации `BadRequestException`: имя поля (camelCase) → массив сообщений. */
        errors?: Record<string, string[]>
        /** Полезная нагрузка `BadOperationPromptException.Result` (диалог подтверждения). */
        prompt?: any
        /** Полный `ToString()` исключения. Заполняется только в Development для непредвиденных ошибок. */
        error?: string | null
        [key: string]: any
    }
}

export interface OrderStockShortage {
    /** @format uuid */
    stockId: string
    products?: OrderStockShortageProduct[] | null
}

export interface OrderStockShortageProduct {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    /** @format double */
    inStock: number
    /** @format double */
    inReserve: number
    /** @format double */
    reserveCount?: number | null
    /** @format double */
    inDocument?: number | null
    /** @format double */
    inCredit?: number | null
}

export interface OrderTipSummaryItem {
    /** @format int32 */
    id: number
    note?: string | null
    recommendation?: string | null
    malfunctions?: string | null
    orderNo?: string | null
    /** @format date-time */
    orderDate: string
}

export interface OrderToggleCommentInfoResponse {
    /** @format int32 */
    orderId: number
    orderNo?: string | null
    /** @format date-time */
    orderDate: string
    orderDateFormatted?: string | null
    /** @format int32 */
    vehicleId: number
    vehicleModification?: string | null
    comment?: string | null
    isHidden: boolean
}

/** Request model for updating the status of a specific order. */
export interface OrderUpdateStatusRequest {
    /**
     * The unique identifier of the order whose status needs to be updated.
     * @format int32
     */
    orderId: number
    status: OrderStatusEnum
}

/** Response model that represents detailed information about a car. */
export interface OrderVehicleResponse {
    /**
     * The unique identifier of the car.
     * @format int32
     */
    id: number
    /** A user-friendly name or alias for the car. */
    friendlyName: string | null
    /**
     * The identifier of the car owner.
     * @format int32
     */
    ownerId: number
    /**
     * The current mileage of the car.
     * @format int32
     */
    mileage?: number | null
    /** The manufacturing year of the car. */
    year?: string | null
    /** The registration number (license plate) of the car. */
    regNo?: string | null
    /** The primary body (chassis) number of the car. */
    bodyNo?: string | null
    /** An alternative body (chassis) number of the car. */
    bodyNo2?: string | null
    /** The manufacturer (make) of the car. */
    manufacturer?: string | null
    /** The model of the car. */
    model?: string | null
    /**
     * The engine capacity in liters.
     * @format float
     */
    engineLitres?: number | null
    fuelType?: FuelTypeEnum
    vehicleType: VehicleTypeEnum
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    /** Additional notes or annotations for the car. */
    annotation?: string | null
    /**
     * The identifier for the first repair times database entry.
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** The value/description for the first repair times database entry. */
    repTimesDb1Value?: string | null
    /**
     * The identifier for the second repair times database entry.
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** The value/description for the second repair times database entry. */
    repTimesDb2Value?: string | null
    /** The identifier for the third repair times database entry. */
    repTimesDb3Id?: string | null
    /** The value/description for the third repair times database entry. */
    repTimesDb3Value?: string | null
    /** The identifier for the fourth repair times database entry. */
    repTimesDb4Id?: string | null
    /** The value/description for the fourth repair times database entry. */
    repTimesDb4Value?: string | null
    /** The identifier for the fifth repair times database entry. */
    repTimesDb5Id?: string | null
    /** The value/description for the fifth repair times database entry. */
    repTimesDb5Value?: string | null
    /**
     * The date and time when the client record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the client record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

/**
 * Response model representing the details of an employee's involvement in a specific order work item.
 * Contains information about time worked, share of work, and calculated payment/interest.
 */
export interface OrderWorkEmployeeResponse {
    /**
     * Unique identifier of the employee.
     * @format int32
     */
    employeeId: number
    /**
     * Norm time (in hours) assigned to the employee for this work item.
     * @format float
     */
    normTime: number
    /**
     * Percentage of the total work assigned to the employee.
     * @format double
     */
    percentage: number
    /**
     * Absolute part of the work amount assigned to the employee.
     * @format double
     */
    amountPart: number
    /**
     * Employee’s interest rate (percentage of profit or cost applied).
     * @format double
     */
    interestRate: number
    /**
     * Calculated interest amount for the employee based on the interest rate.
     * @format double
     */
    interestAmount: number
    /**
     * Rate price per unit of work assigned to the employee.
     * @format double
     */
    ratePrice: number
}

export interface OrderWorkSnapshotResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    position: number
    workId?: string | null
    workDesc?: string | null
    workSource?: string | null
    /** @format double */
    count: number
    /** @format double */
    normTime: number
    /** @format double */
    ratePrice: number
    /** @format double */
    costVat: number
    /** @format double */
    costTotal: number
    /** @format double */
    discount: number
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    responsible?: EntityReferenceSnapshotResponse
    workers?: EntityReferenceSnapshotResponse[] | null
}

export interface OrdersAnalyticalReportResponse {
    summary?: OrdersSummaryItemResponse[] | null
    raitings?: OrdersRatingSetResponse
    statistic?: OrdersStatisticSetResponse
}

export interface OrdersComplexityRatingResponse {
    workDesc?: string | null
    /** @format int32 */
    workTotalCount: number
    /** @format double */
    normTimeTotalSum: number
    /** @format double */
    normTimePersent: number
}

export interface OrdersDayStatisticResponse {
    /** @format int32 */
    month: number
    /** @format int32 */
    day: number
    /** @format int32 */
    orderCount: number
}

export interface OrdersEngagementRatingResponse {
    workDesc?: string | null
    /** @format int32 */
    employeeCount: number
}

export interface OrdersMonthStatisticResponse {
    /** @format int32 */
    month: number
    /** @format int32 */
    year: number
    /** @format int32 */
    orderCount: number
}

export interface OrdersProfitableRatingResponse {
    workDesc?: string | null
    /** @format int32 */
    workTotalCount: number
    /** @format double */
    workCostTotalSum: number
    /** @format double */
    workCostPersent: number
}

export interface OrdersRatingSetResponse {
    profitableRaiting?: OrdersProfitableRatingResponse[] | null
    notProfitableRaiting?: OrdersProfitableRatingResponse[] | null
    complexityRaiting?: OrdersComplexityRatingResponse[] | null
    engagementRaiting?: OrdersEngagementRatingResponse[] | null
}

/** Response model that represents the current order-related settings of the system. */
export interface OrdersSettingsResponse {
    commonMenu: CommonMenuEnum
    sparesMenu: SparesMenuEnum
    lockType: OrderLockTypeEnum
    lockReset: OrderLockResetEnum
    /**
     * Number of hours after which the order lock is reset (when `LockReset` is set to hours).
     * @format float
     */
    lockResetHours: number
    /** Indicates whether mileage information is required when creating or updating an order. */
    mileageRequired: boolean
    /** Indicates whether an event should be automatically created when an order is created. */
    createEvent: boolean
    /** Warranty conditions or notes associated with the order. */
    warranty?: string | null
    /** Indicates whether a client number is required when processing an order. */
    isClientNumberRequired: boolean
    /** Indicates whether updating the event status should also trigger additional updates. */
    isEventStatusUpdateAlso: boolean
    /** Indicates whether status updates should be synchronized across all related entities. */
    updateStatusEverywhere: boolean
    /** Indicates whether a payment should be created automatically when the order reaches Paid status. */
    addPaymentOnPaidStatus: boolean
}

export interface OrdersStatisticSetResponse {
    dayStatistics?: OrdersDayStatisticResponse[] | null
    monthStatistics?: OrdersMonthStatisticResponse[] | null
}

export interface OrdersSummaryItemResponse {
    /** @format int32 */
    orderStatus: number
    /** @format int32 */
    orderCount: number
    /** @format double */
    normTimeTotalSum: number
    /** @format double */
    workCostTotalSum: number
    /** @format double */
    workCostTotalSumByCash: number
    /** @format double */
    workCostTotalSumByCashless: number
}

/**
 * Response model representing information about an organization,
 * including registration, address, and liquidation details.
 */
export interface OrganizationResponse {
    /**
     * Unique taxpayer number (УНП) of the organization.
     * @format int32
     */
    unp: number
    /** Full legal name of the organization. */
    fullName?: string | null
    /** Short (abbreviated) name of the organization. */
    shortName?: string | null
    /** Registered address of the organization. */
    address?: string | null
    /** Date of registration of the organization (string representation). */
    regDate?: string | null
    /**
     * Identifier of the inspection authority supervising the organization.
     * @format int32
     */
    inspectionId: number
    /** Current status of the organization (e.g., Active, Liquidated). */
    status?: string | null
    /** Date of liquidation (if applicable, string representation). */
    likvDate?: string | null
    /** Reason for liquidation (if applicable). */
    likvReason?: string | null
    /** Indicates whether the entity is an individual entrepreneur. */
    isIndividual: boolean
}

export interface OutcomeDocumentListItemResponse {
    /** @format uuid */
    id: string
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    documentType: OutcomeDocumentTypeEnum
    status: OutcomeDocumentStatusEnum
    stock?: WarehouseStockReferenceDto
    bank?: WarehouseBankAccountReferenceDto
    responsible?: WarehouseEmployeeReferenceDto
    supplier?: WarehouseSupplierReferenceDto
    buyer?: WarehouseBuyerReferenceDto
    orderRef?: WarehouseOrderReferenceDto
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    comment?: string | null
}

export interface OutcomeDocumentListItemResponsePaginatedCollection {
    page?: OutcomeDocumentListItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

/** Ответ ошибки типа `OutcomeDocumentPublishException`. Код см. в поле `Detail`. */
export interface OutcomeDocumentPublishExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OutcomeDocumentPublishException'. */
    Title?: 'OutcomeDocumentPublishException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentAlreadyPublished` — The document is already published.
     * - `DocumentHasEmptyProducts` — The document has no products.
     * - `DocumentHasProductsWithZeroCount` — The document contains products with zero count.
     * - `BadStockBalance` — Хендлер бросает доменный ; в этот код его переводит Web-слой, передавая payload уже в платформенных response-моделях.
     */
    Detail?: OutcomeDocumentPublishErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: {
        /** Типизированная полезная нагрузка. Какие коды её заполняют — см. описания значений `Detail`. */
        result?: StockBalanceProductResponse[] | null
        /** Ошибки валидации `BadRequestException`: имя поля (camelCase) → массив сообщений. */
        errors?: Record<string, string[]>
        /** Полезная нагрузка `BadOperationPromptException.Result` (диалог подтверждения). */
        prompt?: any
        /** Полный `ToString()` исключения. Заполняется только в Development для непредвиденных ошибок. */
        error?: string | null
        [key: string]: any
    }
}

/** Ответ ошибки типа `OutcomeDocumentReadonlyException`. Код см. в поле `Detail`. */
export interface OutcomeDocumentReadonlyExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OutcomeDocumentReadonlyException'. */
    Title?: 'OutcomeDocumentReadonlyException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
     */
    Detail?: OutcomeDocumentReadonlyErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface OutcomeDocumentResponse {
    /** @format uuid */
    id: string
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    documentType: OutcomeDocumentTypeEnum
    status: OutcomeDocumentStatusEnum
    stockRef?: WarehouseStockReferenceDto
    bankAccountRef?: WarehouseBankAccountReferenceDto
    responsibleRef?: WarehouseEmployeeReferenceDto
    buyerRef?: WarehouseBuyerReferenceDto
    orderRef?: WarehouseOrderReferenceDto
    buyerContractRef?: WarehouseContractReferenceDto
    supplierRef?: WarehouseSupplierReferenceDto
    supplierContractRef?: WarehouseContractReferenceDto
    /** @format date-time */
    estimatedSaleDate?: string | null
    /** @format date-time */
    estimatedPaymentDate?: string | null
    products?: OutcomeProductDto[] | null
    /** @format double */
    vat: number
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    ttlInputPriceNoVat: number
    /** @format double */
    ttlInputPriceVat: number
    /** @format double */
    ttlInputPriceTotal: number
    comment?: string | null
}

export interface OutcomeDocumentSnapshotDataResponse {
    documentType?: string | null
    status?: string | null
    stockTitle?: string | null
    bankAccountName?: string | null
    responsibleName?: string | null
    buyerName?: string | null
    buyerContractName?: string | null
    supplierName?: string | null
    supplierContractName?: string | null
    /** @format date-time */
    estimatedSaleDate?: string | null
    /** @format date-time */
    estimatedPaymentDate?: string | null
    /** @format double */
    vat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    ttlInputPriceTotal: number
    products?: OutcomeProductSnapshotResponse[] | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface OutcomeDocumentSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: OutcomeDocumentSnapshotDataResponse
}

/** Ответ ошибки типа `OutcomeDocumentUnpublishException`. Код см. в поле `Detail`. */
export interface OutcomeDocumentUnpublishExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'OutcomeDocumentUnpublishException'. */
    Title?: 'OutcomeDocumentUnpublishException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentMustBePublished` — Only a published document can be unpublished.
     */
    Detail?: OutcomeDocumentUnpublishErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface OutcomeProductDto {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    name?: string | null
    measure?: string | null
    /** @format double */
    count: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    priceVat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format double */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format int32 */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVat: number
    /** @format double */
    costTotal: number
    /** @format double */
    inputPriceNoVat: number
    /** @format double */
    inputPriceNoVatTotal: number
    /** @format double */
    inputPriceVat: number
    /** @format double */
    inputPrice: number
    /** @format double */
    inputPriceTotal: number
    /** @format double */
    extraAmount: number
    /** @format double */
    extraPercent: number
}

export interface OutcomeProductSnapshotResponse {
    vendorCode?: string | null
    catalogCode?: string | null
    name?: string | null
    measure?: string | null
    /** @format double */
    count: number
    /** @format int32 */
    vat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format double */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format double */
    costTotal: number
    /** @format double */
    inputPriceTotal: number
    /** @format double */
    extraAmount: number
    /** @format double */
    extraPercent: number
}

export interface OutcomeReportFilter {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    documentType?: OutcomeDocumentTypeEnum[] | null
    /** @format uuid */
    stockId: string
    /** @format uuid */
    bankAccountId: string
    vendorCode?: string | null
    catalogCode?: string | null
    tagCode?: string | null
    brandName?: string | null
}

export interface OutcomeReportProductItem {
    /** @format uuid */
    documentId: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    documentType: OutcomeDocumentTypeEnum
    /** @format uuid */
    incomeDocumentId?: string | null
    incomeDocumentNo?: string | null
    /** @format uuid */
    productId: string
    productName?: string | null
    internalCode?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    measure?: string | null
    tagCode?: string | null
    brandName?: string | null
    stockRef?: ReportStockRef
    bankAccountRef?: ReportBankAccountRef
    responsibleRef?: ReportEmployeeRef
    /** @format double */
    count: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costTotal: number
    /** @format double */
    costVat: number
    /** @format int32 */
    vat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    inputPriceNoVat: number
    /** @format double */
    inputPriceNoVatTotal: number
    /** @format double */
    profitNoVat: number
    /** @format int32 */
    discount: number
    /** @format double */
    discountAmount: number
}

export interface OutcomeReportResponse {
    /** @format int32 */
    totalDocuments: number
    /** @format int32 */
    totalProducts: number
    /** @format double */
    grandCostNoVatTotal: number
    /** @format double */
    grandInputPriceNoVatTotal: number
    /** @format double */
    grandProfitNoVat: number
    products?: OutcomeReportProductItem[] | null
    hasMore: boolean
}

export interface PaintAudatexResponse {
    title?: string | null
    /** @format double */
    costTotal: number
    /** @format double */
    normTimeTotal: number
}

export interface ParsedLineItem {
    name?: string | null
    catalogCode?: string | null
    /** Идентификатор товара во внешней системе. */
    externalId?: string | null
    vendorCode?: string | null
    measure?: string | null
    description?: string | null
    brandName?: string | null
    country?: string | null
    /** @format double */
    vat: number
    /** @format double */
    count: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    priceVat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    costTotal: number
}

export interface ParsedLineResponse {
    name?: string | null
    catalogCode?: string | null
    vendorCode?: string | null
    measure?: string | null
    description?: string | null
    brandName?: string | null
    country?: string | null
    /** @format double */
    vat: number
    /** @format double */
    count: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    priceVat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    costTotal: number
}

export interface PartInfoResponse {
    article?: string | null
    brand?: string | null
}

export interface PartResponse {
    partInfo?: PartInfoResponse
    crosses?: CrossResponse[] | null
}

export interface PaymentCategoryResponse {
    /** @format uuid */
    id: string
    name?: string | null
    isArchive: boolean
}

export interface PaymentClientRequest {
    id?: string | null
    clientType: PaymentClientTypeEnum
}

export interface PaymentClientResponse {
    id?: string | null
    clientType: PaymentClientTypeEnum
    title?: string | null
}

/** Ответ ошибки типа `PaymentDocumentException`. Код см. в поле `Detail`. */
export interface PaymentDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'PaymentDocumentException'. */
    Title?: 'PaymentDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentReferenceInvalid` — The document reference id has an invalid format; result contains documentId and documentType.
     * - `OrderNotFound` — The order referenced by the payment was not found; result contains orderId.
     * - `ClientNotFound` — The client of the referenced order was not found; result contains clientId.
     * - `WhIncomeDocumentNotFound` — The referenced warehouse income document was not found; result contains documentId.
     * - `WhOutcomeDocumentNotFound` — The referenced warehouse outcome document was not found; result contains documentId.
     */
    Detail?: PaymentDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `PaymentOperationException`. Код см. в поле `Detail`. */
export interface PaymentOperationExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'PaymentOperationException'. */
    Title?: 'PaymentOperationException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `CashboxNotFound` — The cashbox referenced by the payment was not found; result contains cashboxId.
     * - `CashboxArchived` — The cashbox is archived and closed for operations; result contains cashboxId.
     * - `NotEnoughMoney` — The cashbox balance is not sufficient for the outcome operation.
     */
    Detail?: PaymentOperationErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface PhoneCallsHistoryResponse {
    /** @format int64 */
    resultsCount: number
    /** @format int64 */
    resultsRemains: number
    /** @format int64 */
    resultsNextOffset: number
    results?: CallHistoryRecordResponse[] | null
}

export interface PreOrderBrowseResponse {
    /** @format uuid */
    id: string
    status: PreOrderStatusEnum
    title?: string | null
    description?: string | null
    /** @format date-time */
    plannedArrival?: string | null
    /** @format int32 */
    carId?: number | null
    carFriendlyName?: string | null
    carRegNo?: string | null
    /** @format int32 */
    clientId?: number | null
    clientName?: string | null
    clientPrimaryPhone?: string | null
    /** @format double */
    ttlCostTotal: number
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    events?: PreOrderCalendarEvent[] | null
}

export interface PreOrderBrowseResponsePaginatedCollection {
    page?: PreOrderBrowseResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface PreOrderCalendarEvent {
    /** @format int32 */
    eventId: number
    area?: string | null
    /** @format date-time */
    startUtc: string
    /** @format date-time */
    endUtc: string
}

export interface PreOrderCar {
    friendlyName?: string | null
    regNo?: string | null
    bodyNo?: string | null
    manufacturer?: string | null
    model?: string | null
    /** @format float */
    engineLitres?: number | null
    /** @format int32 */
    fuelTypeId?: number | null
    transmission?: string | null
    /** @format int32 */
    repTimesDb1Id?: number | null
    /** @format int32 */
    repTimesDb2Id?: number | null
    repTimesDb3Id?: string | null
    repTimesDb4Id?: string | null
    repTimesDb5Id?: string | null
    year?: string | null
    annotation?: string | null
}

export interface PreOrderClient {
    displayName?: string | null
    clientTypeCode: ClientTypeEnum
    streetAddress?: string | null
    email?: string | null
    annotation?: string | null
    /** @format int32 */
    discountWorks: number
    /** @format int32 */
    discountSpares: number
}

export interface PreOrderClientSpare {
    /** @format int32 */
    id: number
    /** @format int32 */
    position: number
    spareName?: string | null
    catalogNumber?: string | null
    measure?: string | null
    /** @format double */
    count: number
    condition: OrderClientSpareConditionEnum
    /** @format double */
    inputPrice: number
}

export interface PreOrderClientWork {
    workDesc?: string | null
    /** @format int32 */
    position: number
}

export interface PreOrderDashboardResponse {
    data?: PreorderPreviewResponse[] | null
    /** @format int32 */
    count: number
}

export interface PreOrderDeleteRequest {
    ids?: string[] | null
    deleteCalendarEvents: boolean
}

export interface PreOrderDetailsResponse {
    /** @format uuid */
    id: string
    status: PreOrderStatusEnum
    title?: string | null
    description?: string | null
    /** @format date-time */
    plannedArrival: string
    primaryPhone?: string | null
    sources?: number[] | null
    /** @format int32 */
    employeeId: number
    employee?: PreOrderEmployee
    /** @format int32 */
    carId?: number | null
    car?: PreOrderCar
    /** @format int32 */
    clientId?: number | null
    client?: PreOrderClient
    events?: PreOrderCalendarEvent[] | null
    stationWorks?: PreOrderStationWork[] | null
    clientWorks?: PreOrderClientWork[] | null
    stationSpares?: PreOrderStationSpare[] | null
    clientSpares?: PreOrderClientSpare[] | null
    totals?: PreOrderTotals
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt?: string | null
}

export interface PreOrderEmployee {
    /** @format int32 */
    id: number
    fullName?: string | null
}

export interface PreOrderEventsCreateCalendarEvent {
    /** @format int32 */
    areaId: number
    /** @format date-time */
    startUtc: string
    /** @format date-time */
    endUtc: string
}

export interface PreOrderEventsCreatePayload {
    create?: PreOrderEventsCreateCalendarEvent[] | null
}

export interface PreOrderEventsUpdatePayload {
    create?: PreOrderEventsCreateCalendarEvent[] | null
    delete?: number[] | null
    disconnect?: number[] | null
    connect?: number[] | null
}

export interface PreOrderPayload {
    status: PreOrderStatusEnum
    /** @format int32 */
    employeeId: number
    /** @format date-time */
    plannedArrival: string
    title?: string | null
    sources?: number[] | null
    description?: string | null
    primaryPhone: string | null
    /** @format int32 */
    carId?: number | null
    car?: PreOrderCar
    /** @format int32 */
    clientId?: number | null
    client?: PreOrderClient
    stationWorks?: PreOrderStationWork[] | null
    clientWorks?: PreOrderClientWork[] | null
    stationSpares?: PreOrderStationSpare[] | null
    clientSpares?: PreOrderClientSpare[] | null
    totals?: PreOrderTotals
}

export interface PreOrderStationSpare {
    /** @format int32 */
    id: number
    /** @format int32 */
    position: number
    spareName?: string | null
    /** @format int32 */
    responsibleId: number
    country?: string | null
    brandName?: string | null
    catalogNumber?: string | null
    vendorCode?: string | null
    /** @format double */
    count: number
    measure?: string | null
    notes?: string | null
    /** @format double */
    inputPriceNoVat: number
    /** @format double */
    inputPriceNoVatTotal: number
    /** @format double */
    inputPriceVat: number
    /** @format double */
    inputPrice: number
    /** @format double */
    inputPriceTotal: number
    /** @format double */
    extraAmount: number
    /** @format double */
    extraPercent: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    priceVat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
    /** @format double */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVat: number
    /** @format double */
    costTotal: number
    /** @format double */
    profit: number
    /** @format uuid */
    stockId?: string | null
    internalCode?: string | null
    /** @format uuid */
    productId?: string | null
    status: OrderStationSparesStatusEnum
}

export interface PreOrderStationWork {
    /** @format int32 */
    id: number
    workId?: string | null
    workDesc?: string | null
    workSource: WorkSourceEnum
    /** @format double */
    count: number
    /** @format int32 */
    responsibleId: number
    /** @format double */
    normTime: number
    /** @format double */
    normTimeTotal: number
    /** @format int32 */
    rateNumber?: number | null
    /** @format double */
    ratePrice: number
    /** @format int32 */
    position: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    price: number
    /** @format double */
    priceVat: number
    /** @format double */
    priceTotal: number
    /** @format double */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    costVat: number
    /** @format double */
    costTotal: number
    status: OrderWorkStatusEnum
}

export interface PreOrderTotals {
    /** @format double */
    vatWorks: number
    /** @format double */
    vatSpares: number
    /** @format double */
    wksDiscountAmount: number
    /** @format double */
    sprDiscountAmount: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    wksNormsTotal: number
}

export interface PreorderPreviewResponse {
    /** @format uuid */
    id: string
    status: PreOrderStatusEnum
    title?: string | null
    description?: string | null
    /** @format date-time */
    plannedArrival: string
    primaryPhone?: string | null
    /** @format int32 */
    employeeId: number
    /** @format int32 */
    carId?: number | null
    car?: PreOrderCar
    /** @format int32 */
    clientId?: number | null
    client?: PreOrderClient
    /** @format double */
    ttlCostTotal: number
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
}

export interface PriceListCategoryResponse {
    /** @format uuid */
    id: string
    name?: string | null
    code?: string | null
    description?: string | null
    tags?: PriceListTagResponse[] | null
}

export interface PriceListItemResponse {
    /** @format uuid */
    id: string
    name?: string | null
    isHideNormTime: boolean
    currency: CurrencyCodeEnum
    tagCode?: string | null
    carIds?: string[] | null
    spares?: PriceListStationSpare[] | null
    works?: PriceListStationWork[] | null
    /** @format double */
    spareVat: number
    /** @format double */
    workVat: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
}

export interface PriceListItemResponsePaginatedCollection {
    page?: PriceListItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface PriceListStationSpare {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    /** @format uuid */
    stockId?: string | null
    vendorCode?: string | null
    name: string | null
    catalogCode?: string | null
    brandName?: string | null
    country?: string | null
    measure: string | null
    /** @format double */
    count: number
    /** @format double */
    vat: number
    /** @format double */
    inputPriceNoVat: number
    /** @format double */
    inputPriceNoVatTotal: number
    /** @format double */
    inputPriceVat: number
    /** @format double */
    inputPrice: number
    /** @format double */
    inputPriceTotal: number
    /** @format double */
    extraPercent: number
    /** @format double */
    extraAmount: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    priceVat: number
    /** @format double */
    price: number
    /** @format double */
    priceTotal: number
}

export interface PriceListStationWork {
    workDesc: string | null
    /** @format double */
    count: number
    /** @format double */
    normTime: number
    /** @format double */
    normTimeTotal: number
    /** @format int32 */
    rateNumber: number
    /** @format double */
    ratePrice: number
    /** @format double */
    vat: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    priceNoVatTotal: number
    /** @format double */
    price: number
    /** @format double */
    priceVat: number
    /** @format double */
    priceTotal: number
    notes?: string | null
    ignoreWorkOnCalc: boolean
}

export interface PriceListTagResponse {
    name?: string | null
    code?: string | null
    description?: string | null
    tags?: PriceListTagResponse[] | null
}

export interface PriceListVehicleModificationResponse {
    modificationId?: string | null
    displayName?: string | null
    manufacture?: string | null
    model?: string | null
    engineLitres?: string | null
    fuelType: FuelTypeEnum
    yearsRange?: string | null
    repDb: RepTimesDbEnum
}

/** Discount information for a specific subscription period. */
export interface PricingDiscountResponse {
    /**
     * Number of months for the subscription period.
     * @format int32
     */
    months: number
    /**
     * Discount percentage.
     * @format double
     */
    percent: number
}

export interface PrintPageItemResponse {
    templateId: PrintTemplateEnum
    genericId?: string | null
    printOptionName?: string | null
    /** @format int32 */
    position: number
    fitHeight: boolean
    setPaymentForm: boolean
    setPaymentType: boolean
    fillNames: boolean
    fillCarDetails: boolean
    printLandscape: boolean
    fillStamp: boolean
    fillCatalogNumber: boolean
    fillImages: boolean
    isDefault: boolean
    headerText?: string | null
    headerNumering?: string | null
    availableOptions?: PrintUserOptionEnum[] | null
}

export interface PrintPageResponse {
    items?: PrintPageItemResponse[] | null
}

/** Response model that represents the current system print settings. */
export interface PrintSettingsResponse {
    /** Indicates whether the order document number should be printed on documents. */
    printOrderDocumentNumber: boolean
    /** Indicates whether the payment form is included in printed documents. */
    setPaymentForm: boolean
    /** Indicates whether the payment type is included in printed documents. */
    setPaymentType: boolean
    /** Indicates whether the document content is scaled to fit on a single page when printed. */
    fitToOnePage: boolean
    /** Indicates whether customer and company names are automatically filled in documents. */
    fillNames: boolean
    /** Indicates whether car details are automatically filled in documents. */
    fillCarDetails: boolean
    /** Indicates whether catalog numbers are automatically filled in documents. */
    fillCatalogNumber: boolean
    /** Custom name for the "Order Act" document. */
    nameOfOrderActDocument?: string | null
    /** Custom name for the "Order" document. */
    nameOfOrderDocument?: string | null
    /** Custom name for the "Request" document. */
    nameOfRequestDocument?: string | null
    /** Custom name for the "Invoice" document. */
    nameOfInvoiceDocument?: string | null
    /** Custom name for the "Act" document. */
    nameOfActDocument?: string | null
    /** Custom name for the "Report" document. */
    nameOfReportDocument?: string | null
    /**
     * Identifier of the contact template used in printed documents.
     * @format int32
     */
    contactsTemplate: number
    /** Indicates whether the act document name follows legal naming conventions. */
    actNameUseLaw: boolean
    /** Indicates whether the order document name follows legal naming conventions. */
    orderNameUseLaw: boolean
}

export interface ProblemDetails {
    type?: string | null
    title?: string | null
    /** @format int32 */
    status?: number | null
    detail?: string | null
    instance?: string | null
    [key: string]: any
}

export interface ProductCategoryResponse {
    /** @format uuid */
    id: string
    code?: string | null
    name?: string | null
    description?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    tags?: ProductTagResponse[] | null
}

export interface ProductCostInfoResponse {
    /** @format double */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    discount: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
    costRevaluationDocRef?: CatalogDocumentRef
}

export interface ProductMatchedCategoriesResponse {
    catalogCode?: string | null
    categories?: MatchedCategoryItem[] | null
}

export interface ProductSnapshotDataResponse {
    name?: string | null
    catalogCode?: string | null
    vendorCode?: string | null
    measure?: string | null
    description?: string | null
    brandName?: string | null
    country?: string | null
    /** @format double */
    vat: number
    /** @format double */
    cost: number
    /** @format double */
    discount: number
    /** @format double */
    sellingPrice: number
    supplierName?: string | null
    /** @format date-time */
    created: string
    createdBy?: string | null
    /** @format date-time */
    modified: string
    modifiedBy?: string | null
}

export interface ProductSnapshotResponse {
    /** @format uuid */
    id: string
    entityId?: string | null
    /** @format int32 */
    version: number
    /** @format date-time */
    createdAt?: string | null
    userId?: string | null
    reason?: string | null
    data?: ProductSnapshotDataResponse
}

export interface ProductTagResponse {
    code?: string | null
    name?: string | null
    description?: string | null
    tags?: ProductTagResponse[] | null
}

export interface ProductUsage {
    documentRef?: WarehouseDocumentReference
    /** @format date-time */
    documentDate: string
    documentType: TransactionDocumentType
    /** @format uuid */
    productId: string
    internalCode?: string | null
}

/** Represents a promotion ID with its new sort order. */
export interface PromotionSortOrderItem {
    /**
     * Promotion ID.
     * @format int32
     */
    id: number
    /**
     * New sort order value.
     * @format int32
     */
    sortOrder: number
}

/** Ответ ошибки типа `PublishIncomeDocumentException`. Код см. в поле `Detail`. */
export interface PublishIncomeDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'PublishIncomeDocumentException'. */
    Title?: 'PublishIncomeDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentAlreadyPublished` — The document is already published; result contains documentId.
     * - `DocumentHasEmptyProducts` — The document has no products; result contains documentId.
     * - `DocumentHasProductsWithZeroCount` — The document contains products with zero count; result contains documentId.
     */
    Detail?: PublishIncomeDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `PublishInventoryDocumentException`. Код см. в поле `Detail`. */
export interface PublishInventoryDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'PublishInventoryDocumentException'. */
    Title?: 'PublishInventoryDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentAlreadyPublished` — The document is already published; result contains documentId.
     */
    Detail?: PublishInventoryDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `PublishRevaluationDocumentException`. Код см. в поле `Detail`. */
export interface PublishRevaluationDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'PublishRevaluationDocumentException'. */
    Title?: 'PublishRevaluationDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentAlreadyPublished` — The document is already published; result contains documentId.
     */
    Detail?: PublishRevaluationDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `PurgeRecycleBinItemException`. Код см. в поле `Detail`. */
export interface PurgeRecycleBinItemExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'PurgeRecycleBinItemException'. */
    Title?: 'PurgeRecycleBinItemException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ResourceTypeNotSupported` — Тип ресурса корзины не поддерживается — нет зарегистрированного обработчика.
     * - `DependentAlive` — На ресурс всё ещё ссылается активная (в базе или в корзине) зависимая запись — сначала окончательно удалите её.
     */
    Detail?: PurgeRecycleBinItemExceptionCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface QuickSearchResponse {
    clients?: ClientResponse[] | null
    cars?: CarResponse[] | null
    orders?: OrderSearchResultResponse[] | null
}

export interface RecycleBinItemMetadata {
    order?: OrderRecycleBinMetadata
    client?: ClientRecycleBinMetadata
    car?: CarRecycleBinMetadata
}

export interface RecycleBinItemResponse {
    /** @format int32 */
    id: number
    resourceType?: string | null
    resourceId?: string | null
    title?: string | null
    deletedBy?: string | null
    /** @format date-time */
    deletedAt: string
    /** @format date-time */
    expiresAt: string
    deleteBatchId?: string | null
    metadata?: RecycleBinItemMetadata
}

/** Ответ ошибки типа `RegisterTenantException`. Код см. в поле `Detail`. */
export interface RegisterTenantExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'RegisterTenantException'. */
    Title?: 'RegisterTenantException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ContactEmailIsDuplicate` — A user with the given contact email is already registered.
     */
    Detail?: RegisterTenantErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Represents a request to register a new tenant (company) in the system. */
export interface RegisterTenantRequest {
    /** Full name of the main contact person. */
    contactName: string | null
    /** Phone number of the contact person. */
    contactPhone: string | null
    /** Email address of the contact person. */
    contactEmail: string | null
    /** Name of the company being registered. */
    companyName: string | null
    /** Company registration number (UNN, VAT number, or equivalent). */
    companyUnn: string | null
    /** Country where the company is located. */
    country: string | null
    /** Preferred language for the tenant (e.g., "en", "ru"). */
    language: string | null
    tariff: TenantSubscriptionPlanResponse
    /**
     * Number of months the subscription will be active.
     * @format int32
     */
    months: number
}

/** Ответ ошибки типа `ReleaseOrderException`. Код см. в поле `Detail`. */
export interface ReleaseOrderExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ReleaseOrderException'. */
    Title?: 'ReleaseOrderException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ForceReleaseDenied` (HTTP 403) — Force-releasing a lock requires the Orders.LockReset permission.
     * - `LockedByAnotherUser` (HTTP 409) — The lock belongs to another user; retry with force=true to override.
     */
    Detail?: ReleaseOrderErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for removing an employee's schedule assignment from a specific area. */
export interface RemoveEmployeeScheduleAreaRequest {
    /**
     * The unique identifier of the employee whose schedule assignment is being removed.
     * @format int32
     */
    employeeId: number
    /**
     * The unique identifier of the area from which the schedule will be unlinked.
     * @format int32
     */
    areaId: number
}

export interface ReportBankAccountRef {
    /** @format uuid */
    bankAccountId: string
    bankAccountTitle?: string | null
}

export interface ReportBuyerRef {
    buyerId?: string | null
    buyerName?: string | null
}

export interface ReportEmployeeRef {
    id?: string | null
    name?: string | null
}

export interface ReportStockRef {
    /** @format uuid */
    stockId: string
    stockTitle?: string | null
}

export interface ReportSupplierRef {
    /** @format uuid */
    supplierId: string
    supplierName?: string | null
    supplierUnp?: string | null
}

export interface ReportingDateKeyTextOptionResponse {
    key: ReportingDateEnum
    text?: string | null
    checked: boolean
}

/** Ответ ошибки типа `ResetPasswordConfirmException`. Код см. в поле `Detail`. */
export interface ResetPasswordConfirmExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ResetPasswordConfirmException'. */
    Title?: 'ResetPasswordConfirmException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadResetCode` — Неверный или просроченный код сброса
     */
    Detail?: ResetPasswordConfirmErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `ResetPasswordException`. Код см. в поле `Detail`. */
export interface ResetPasswordExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'ResetPasswordException'. */
    Title?: 'ResetPasswordException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `UserIsLockedOut` — Аккаунт заблокирован
     */
    Detail?: ResetPasswordErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Represents a request to confirm a password reset. */
export interface ResetUserPasswordConfirmRequest {
    /** The reset code (token) sent to the user, used to verify the password reset request. */
    resetCode: string | null
    /** The new password the user wants to set. */
    newPassword: string | null
}

/** Represents a request to initiate the password reset process for a user. */
export interface ResetUserPasswordRequest {
    /** Email address of the user requesting the password reset. */
    email: string | null
}

/** Ответ ошибки типа `ResourceNotFoundException`. Кодов нет — тип ошибки см. в поле `Title`. */
export interface ResourceNotFoundExceptionProblem {
    /** Всегда 'ResourceNotFoundException'. */
    Type?: 'ResourceNotFoundException'
    /** Discriminator. Всегда 'ResourceNotFoundException'. */
    Title?: 'ResourceNotFoundException'
    /** @format int32 */
    Status?: number
    /** Техническое сообщение исключения. Кодов у 404 нет — тип ошибки см. в `Title`. */
    Detail?: string
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface ResponsibleCommonReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts?: string[] | null
    vehicleType?: VehicleTypeEnum
    documentOptions?: DocumentKindEnum[] | null
    workRates?: number[] | null
    isResponsibleFromOrder: boolean
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ResponsibleCommonReportResponse {
    /** Response model representing detailed information about an employee */
    employee?: EmployeeResponse
    data?: ResponsibleReportCommonDataResponse
}

export interface ResponsibleDetailsReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts?: string[] | null
    vehicleType?: VehicleTypeEnum
    documentOptions?: DocumentKindEnum[] | null
    workRates?: number[] | null
    /** @format int32 */
    employeeId: number
    responsibleFromOrder: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    isPersonal: boolean
    isCompany: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface ResponsibleDetailsReportResponse {
    /** @format int32 */
    orderId: number
    orderNo?: string | null
    actNo?: string | null
    /** @format date-time */
    orderDate?: string | null
    /** @format date-time */
    estimateDate?: string | null
    /** @format date-time */
    paymentDueDate?: string | null
    /** @format date-time */
    paymentDate?: string | null
    /** @format double */
    wksDiscountAmount: number
    /** @format double */
    sprDiscountAmount: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    wksProfit: number
    /** @format double */
    ctrProfit: number
    /** @format double */
    sprProfit: number
    /** @format double */
    ttlProfit: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    ctrCostNoVat: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    ctrCostVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    ctrCostTotal: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostTotal: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    cspCostTotal: number
    /** @format double */
    discountWksClient: number
    /** @format double */
    discountWksCar: number
    /** @format double */
    discountWksTtl: number
    /** @format double */
    discountSprTtl: number
    /** @format double */
    discountYear: number
    /** @format int32 */
    ownerId: number
    /** @format int32 */
    clientId: number
    /** @format int32 */
    payerId: number
    /** @format int32 */
    carId: number
    /** @format int32 */
    mileage: number
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    owner?: ClientResponse
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    client?: ClientResponse
    /**
     * Response model representing detailed client information.
     * Provides full data about a client, including contacts, banking details, discounts, and metadata.
     */
    payer?: ClientResponse
    /** Response model that represents detailed information about a car. */
    car?: CarResponse
    /** Response model representing detailed information about an employee */
    responsible?: EmployeeResponse
    stationWorks?: OrderStationWorkResponse[] | null
    contractorWorks?: OrderContractorWorkResponse[] | null
    stationSpares?: OrderStationSpareResponse[] | null
    clientSpares?: OrderClientSpareResponse[] | null
}

export interface ResponsibleReportCommonDataResponse {
    /** @format int32 */
    employeeId: number
    /** @format double */
    normTimeSum: number
    /** @format double */
    amountPartSum: number
    /** @format double */
    sprCostSum: number
    /** @format int32 */
    orderCount: number
}

/** Ответ ошибки типа `RestoreRecycleBinItemException`. Код см. в поле `Detail`. */
export interface RestoreRecycleBinItemExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'RestoreRecycleBinItemException'. */
    Title?: 'RestoreRecycleBinItemException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ResourceTypeNotSupported` — Тип ресурса корзины не поддерживается — нет зарегистрированного обработчика.
     * - `SourceObjectNotFound` — Исходный объект не найден и не может быть восстановлен.
     * - `SourceObjectAlreadyRestored` — Исходный объект уже восстановлен (soft-delete снят) и не подлежит повторному восстановлению.
     * - `ParentNotRestored` — Родительский агрегат отсутствует или помечен удалённым — сначала восстановите родителя.
     */
    Detail?: RestoreRecycleBinItemExceptionCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface RevaluationAddResponse {
    /** @format uuid */
    documentId: string
}

/** Ответ ошибки типа `RevaluationCatalogSyncException`. Код см. в поле `Detail`. */
export interface RevaluationCatalogSyncExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'RevaluationCatalogSyncException'. */
    Title?: 'RevaluationCatalogSyncException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `SomeProductsAreMissingInCatalog` — Some of the document's products no longer exist in the catalog; result contains documentId.
     * - `BadInternalCode` — The document references an internal code that no longer exists on the catalog product; result contains productId and internalCode.
     */
    Detail?: RevaluationCatalogSyncErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface RevaluationDetailsResponse {
    /** @format uuid */
    id: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    isPublished: boolean
    comment?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    responsibleRef?: RevaluationEmployeeRef
    products?: RevaluationProductItem[] | null
}

/** Ответ ошибки типа `RevaluationDocumentReadonlyException`. Код см. в поле `Detail`. */
export interface RevaluationDocumentReadonlyExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'RevaluationDocumentReadonlyException'. */
    Title?: 'RevaluationDocumentReadonlyException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `PublishedDocumentIsReadonly` — A published document is read-only and cannot be edited or deleted; result contains documentId.
     */
    Detail?: RevaluationDocumentReadonlyErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface RevaluationEmployeeRef {
    id?: string | null
    name?: string | null
}

export interface RevaluationListItemResponse {
    /** @format uuid */
    id: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    comment?: string | null
    isPublished: boolean
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
}

export interface RevaluationProductItem {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    name?: string | null
    /** @format double */
    vat: number
    catalogCode?: string | null
    /** @format double */
    inputPriceNoVat: number
    /** @format double */
    inputPriceVat: number
    /** @format double */
    inputPrice: number
    /** @format double */
    oldSellingPriceNoVat: number
    /** @format double */
    oldSellingPriceVat: number
    /** @format double */
    oldSellingPrice: number
    /** @format double */
    discount: number
    /** @format double */
    discountAmount: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
}

/** Ответ ошибки типа `SaveCashboxException`. Код см. в поле `Detail`. */
export interface SaveCashboxExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SaveCashboxException'. */
    Title?: 'SaveCashboxException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `CashboxTitleNotUnique` — Another cashbox with the same title already exists; result contains the title.
     */
    Detail?: SaveCashboxErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `SaveIncomeDocumentException`. Код см. в поле `Detail`. */
export interface SaveIncomeDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SaveIncomeDocumentException'. */
    Title?: 'SaveIncomeDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadStock` — The referenced stock was not found; result contains stockId.
     * - `BadBuyer` — A buyer reference is required for this document type but was not provided.
     * - `BadBuyerContract` — The buyer's contract was not found; result contains contractId.
     * - `BadSupplier` — The referenced supplier was not found; result contains supplierId.
     * - `BadSupplierContract` — The supplier's contract was not found; result contains contractId.
     * - `DuplicateDocumentNo` — Настройка «Уникальность номера документа» включена, а документ того же типа с таким номером уже есть; result содержит documentNo, documentType и id найденного документа.
     */
    Detail?: SaveIncomeDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `SaveInventoryDocumentException`. Код см. в поле `Detail`. */
export interface SaveInventoryDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SaveInventoryDocumentException'. */
    Title?: 'SaveInventoryDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ProductsMustNotBeEmpty` — The document must contain at least one product.
     * - `ProductsHasDuplicates` — The document has duplicate products by internalCode.
     * - `DuplicateDocument` — Another document with the same document number already exists; result contains documentNo.
     * - `BadStock` — The referenced stock was not found; result contains stockId.
     * - `DuplicateProduct` — A product with the same internalCode is already present in the document; result contains internalCode.
     * - `MissingProduct` — A product to update or delete was not found in the document; result contains internalCode.
     */
    Detail?: SaveInventoryDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `SaveOutcomeDocumentException`. Код см. в поле `Detail`. */
export interface SaveOutcomeDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SaveOutcomeDocumentException'. */
    Title?: 'SaveOutcomeDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadStock` — The referenced stock was not found; result contains stockId.
     * - `BadBuyer` — A buyer reference is required for this document type but was not provided.
     * - `BadBuyerContract` — The buyer's contract was not found; result contains contractId.
     * - `BadSupplier` — The referenced supplier was not found; result contains supplierId.
     * - `BadSupplierContract` — The supplier's contract was not found; result contains contractId.
     * - `DuplicateDocumentNo` — Настройка «Уникальность номера документа» включена, а документ того же типа с таким номером уже есть; result содержит documentNo, documentType и id найденного документа.
     */
    Detail?: SaveOutcomeDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `SaveRevaluationDocumentException`. Код см. в поле `Detail`. */
export interface SaveRevaluationDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SaveRevaluationDocumentException'. */
    Title?: 'SaveRevaluationDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ProductsMustNotBeEmpty` — The document must contain at least one product.
     * - `ProductsHasDuplicates` — The document has duplicate products by productId or internalCode.
     * - `DuplicateDocument` — Another document with the same document number already exists; result contains documentNo.
     */
    Detail?: SaveRevaluationDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `SaveStorageLocationException`. Код см. в поле `Detail`. */
export interface SaveStorageLocationExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SaveStorageLocationException'. */
    Title?: 'SaveStorageLocationException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `StorageLocationAlreadyExists` — A storage location with the same code already exists on the stock; result contains stockId and code.
     */
    Detail?: SaveStorageLocationErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface SaveUiLayoutRequest {
    pageType: UiLayoutPageTypeEnum
    layoutJson?: string | null
}

export interface SavedRecipientListPreviewResponse {
    /** @format int32 */
    id: number
    title?: string | null
    isManual: boolean
}

export interface SavedRecipientListResponse {
    /** @format int32 */
    id: number
    title?: string | null
    isManual: boolean
    filter?: SearchSmsClientsRequest
    clients?: SmsClientResponse[] | null
}

/** Represents a screen with new sort order. */
export interface ScreenSortOrderItem {
    /**
     * Screen ID.
     * @format int32
     */
    id: number
    /**
     * New sort order value.
     * @format int32
     */
    sortOrder: number
}

export interface SearchPriceListResponse {
    priceListItems?: PriceListItemResponsePaginatedCollection
    categoryTags?: string[] | null
}

export interface SearchProductsResponse {
    products?: CatalogProductResponsePagedResult
    categoryTags?: string[] | null
}

export interface SearchSmsClientsRequest {
    orderDate?: DateTimeNullableRangeValue
    paymentDate?: DateTimeNullableRangeValue
    workCost?: DecimalNullableRangeValue
    componentsCost?: DecimalNullableRangeValue
    totalCost?: DecimalNullableRangeValue
    ordersCount?: Int32NullableRangeValue
    orderStatuses?: string[] | null
    clientTypes?: string[] | null
    carYears?: string[] | null
    carBrands?: string[] | null
    carModels?: string[] | null
}

export interface SearchStockBalanceResponse {
    products?: StockBalanceSearchItemPaginatedCollection
    categoryTags?: string[] | null
}

export interface SearchSupplierPricesRequest {
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    keyword?: string | null
    sortCol?: string | null
    sortAsc: boolean
    supplierTypes: SuppliersTypeEnum[]
    /** @minLength 1 */
    articleCode: string
}

export interface SendVerificationSmsRequest {
    phoneNumber?: string | null
    locale?: string | null
}

export interface SentVerificationSmsResponse {
    verificationSid?: string | null
    /** @format int32 */
    attempts: number
    /** @format date-time */
    lockedUntil: string
    /** @format date-time */
    expirationTime: string
}

/** Request model for assigning an employee's schedule to a specific area. */
export interface SetEmployeeScheduleToAreaRequest {
    /**
     * The unique identifier of the employee whose schedule is being assigned.
     * @format int32
     */
    employeeId: number
    /**
     * The unique identifier of the area to which the schedule will be linked.
     * @format int32
     */
    areaId: number
}

/**
 * Represents the result of setting or creating an order, including
 * the assigned number and information about missing numbers.
 */
export interface SetOrderResponse {
    /** Indicates whether there are missing (unassigned) order numbers in the sequence. */
    hasEmptyNumbers: boolean
    /** The order number that was assigned/generated for the current order. */
    number?: string | null
    /**
     * A list of missing (unassigned) order numbers that were detected
     * when processing the current order.
     */
    emptyNumbers?: OrderMissedNumberModel[] | null
}

/** Ответ ошибки типа `SignOutException`. Код см. в поле `Detail`. */
export interface SignOutExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SignOutException'. */
    Title?: 'SignOutException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadTokenCredentials` — Неверный app token
     */
    Detail?: SignOutErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface SmsCampaignRecipientRequest {
    /** @format int32 */
    id?: number | null
    /** @format int32 */
    clientContactId?: number | null
    phoneNumber?: string | null
}

export interface SmsClientResponse {
    /** @format int32 */
    id: number
    fullName?: string | null
    description?: string | null
    contacts?: SmsContactResponse[] | null
}

export interface SmsContactResponse {
    /** @format int32 */
    id: number
    isSmsAllowed: boolean
    phoneNumber?: string | null
    label?: string | null
    /** @format int32 */
    position: number
    fullName?: string | null
}

export interface SmsRecipient {
    /** @format int32 */
    id: number
    fullName?: string | null
    type: ClientTypeEnum
    description?: string | null
    banSms: boolean
    contacts?: ClientContactResponse[] | null
}

export interface SmsRecipientHistoryResponse {
    title?: string | null
    message?: string | null
    scheduleDate?: string | null
    status?: string | null
    statusText?: string | null
    subscriber?: string | null
}

/** Response model that represents the current SMS mailing service settings. */
export interface SmsSettingsResponse {
    provider: SmsProviderEnum
    /** Indicates whether bulk SMS mailing is enabled. */
    smsMailingEnable: boolean
    /** Provider-specific configuration settings (structure depends on the selected provider). */
    settings?: any
}

export interface SmsTemplateResponse {
    /** @format uuid */
    id: string
    name: SmsTemplateNameEnum
    type: SmsTemplateTypeEnum
    /** @format int32 */
    value: number
    message?: string | null
}

export interface SmsTemplatesResponse {
    /** @format int32 */
    resultsCount: number
    results?: MoiZvonkiSmsTemplateResponse[] | null
}

/** Response model that represents a source entity linked to a specific resource. */
export interface SourceResponse {
    /**
     * The unique identifier of the source.
     * @format int32
     */
    id: number
    resourceType: SourceResourceTypeEnum
    /** The title or descriptive name of the source. */
    title?: string | null
    /**
     * The date and time when the source record was created.
     * @format date-time
     */
    created: string
    /**
     * The date and time when the source record was last modified.
     * @format date-time
     */
    modified: string
}

export interface SpareAudatexResponse {
    title?: string | null
    catalogNumber?: string | null
    /** @format double */
    count: number
    /** @format double */
    costTotal: number
    quantity?: string | null
    value?: string | null
}

export interface SpareIncrease {
    /** @format double */
    price: number
    /** @format double */
    percentage: number
}

export interface SparesItemResponse {
    articleCode?: string | null
    manufacturers?: SparesManufacturerResponse[] | null
}

export interface SparesItemResponsePaginatedCollection {
    page?: SparesItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface SparesManufacturerResponse {
    brandName?: string | null
    name?: string | null
    description?: string | null
    suppliers?: SparesSupplierResponse[] | null
}

export interface SparesPriceInfoResponse {
    /** @format date-time */
    deliveryDate?: string | null
    /** @format int32 */
    rating?: number | null
    price?: string | null
}

export interface SparesSupplierResponse {
    supplierType: SuppliersTypeEnum
    /** @format int32 */
    count: number
    prices?: SparesPriceInfoResponse[] | null
}

/** Response model that represents the details of a station bank account. */
export interface StationBankAccountResponse {
    /**
     * Unique identifier of the bank account.
     * @format uuid
     */
    id: string
    /**
     * The position or display order of the bank account in the list.
     * @format int32
     */
    position: number
    /** The title or descriptive name of the bank account. */
    title?: string | null
    /** The name of the bank where the account is held. */
    bankName?: string | null
    /** The bank’s code (e.g., SWIFT/BIC or local identifier). */
    bankCode?: string | null
    /** The number of the bank account. */
    bankAccount?: string | null
    /** The address of the bank branch. */
    bankAddress?: string | null
    currency: CurrencyCodeEnum
    type: BankAccountTypeEnum
    /** Indicates whether this account is the default account for the station. */
    isDefault: boolean
    /** Indicates whether the account is archived (inactive). */
    archived: boolean
    /** A list of associated cashbox identifiers linked to this account. */
    cashboxes?: string[] | null
}

export interface StationCommonReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    vehicleType?: VehicleTypeEnum
    documentOptions?: DocumentKindEnum[] | null
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol: StationReportSortColEnum
}

/** Response model representing a station contact with basic details. */
export interface StationContactResponse {
    /**
     * Unique identifier of the contact.
     * @format int32
     */
    id: number
    /** Phone number of the contact. */
    phone: string | null
    /** Full name of the contact person. */
    name: string | null
    /** Email address of the contact (optional). */
    email?: string | null
    /** Job position or role of the contact. */
    position?: string | null
    type: ContactTypeEnum
}

export interface StationInfoResponse {
    tenant?: string | null
    title?: string | null
    expire?: string | null
    current: boolean
    blocked: boolean
    isTrial: boolean
    /** @format int32 */
    parentTenantId?: number | null
    mode: AvailabilityModeEnum
}

/** Response model that represents a station rate with details. */
export interface StationRateResponse {
    /**
     * Unique identifier of the rate.
     * @format int32
     */
    id: number
    /**
     * The sequential number of the rate (used as a reference in other entities).
     * @format int32
     */
    number: number
    /**
     * Sort order used for displaying rates in UI lists.
     * @format int32
     */
    order: number
    /** The title or name of the rate. */
    title?: string | null
    /**
     * Value from norms database 1 (RepTimesDb1).
     * @format double
     */
    repTimesDb1: number
    /**
     * Value from norms database 2 (RepTimesDb2).
     * @format double
     */
    repTimesDb2: number
    /**
     * Value from norms database 3 (RepTimesDb3).
     * @format double
     */
    repTimesDb3: number
    /**
     * Value from norms database 4 (RepTimesDb4).
     * @format double
     */
    repTimesDb4: number
    /**
     * Value from norms database 5 (RepTimesDb5).
     * @format double
     */
    repTimesDb5: number
    currency: CurrencyCodeEnum
    /**
     * The base price associated with the rate.
     * @format double
     */
    price: number
    /** Indicates whether the rate is archived. */
    archived: boolean
}

export interface StationReportResponse {
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    wksNormsTotalSum: number
    /** @format double */
    wksCostNoVatSum: number
    /** @format double */
    wksCostVatSum: number
    /** @format double */
    wksCostTotalSum: number
    /** @format double */
    wksDiscountAmountSum: number
    /** @format double */
    wksProfitSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    ctrCostNoVatSum: number
    /** @format double */
    ctrCostVatSum: number
    /** @format double */
    ctrCostTotalSum: number
    /** @format double */
    ctrProfitSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    ttlProfitSum: number
    orders?: OrderStationReportResponse[] | null
}

export interface StationSpareSnapshotResponse {
    /** @format int32 */
    id: number
    /** @format int32 */
    position: number
    spareName?: string | null
    catalogNumber?: string | null
    /** @format double */
    count: number
    measure?: string | null
    /** @format double */
    inputPriceNoVat: number
    /** @format double */
    extraPercent: number
    /** @format double */
    priceNoVat: number
    /** @format double */
    discount: number
    /** @format double */
    costTotal: number
    /** Reference to a related entity captured inside a snapshot (id + display name). */
    responsible?: EntityReferenceSnapshotResponse
}

export interface StationSparesReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts?: string[] | null
    vehicleType?: VehicleTypeEnum
    documentOptions?: DocumentKindEnum[] | null
    /** @format int32 */
    clientId?: number | null
    /** @format int32 */
    employeeId?: number | null
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol?: string | null
}

export interface StationSparesReportResponse {
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    ttlProfitSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    discountSprTtlSum: number
    /** @format double */
    inputPriceNoVatTotalSum: number
    /** @format double */
    priceNoVatTotalSum: number
    /** @format double */
    discountAmountSum: number
    /** @format double */
    costNoVatTotalSum: number
    /** @format double */
    profitSum: number
    orders?: OrderStationReportResponse[] | null
}

/**
 * Товар с недостаточным остатком для публикации расходного документа.
 * Возвращается в payload ошибки `BadStockBalance`.
 */
export interface StockBalanceProductResponse {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    /**
     * На складе с учётом проданных.
     * @format double
     */
    inStock: number
    /**
     * Кол-во для списания.
     * @format double
     */
    inDocument: number
    /**
     * В резерве.
     * @format double
     */
    inReserve: number
}

export interface StockBalanceSearchItem {
    /** @format uuid */
    productId: string
    internalCode?: string | null
    externalId?: string | null
    customsDeclarationNumber?: string | null
    /** @format date-time */
    expirationDate?: string | null
    certificateNumber?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    tagCode?: string | null
    name?: string | null
    description?: string | null
    /** @format date-time */
    modifiedAt: string
    brandName?: string | null
    country?: string | null
    measure?: string | null
    storageLocationCode?: string | null
    /** @format double */
    count: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    vat: number
    /** @format double */
    discount: number
    /** @format double */
    reservesTotalCount: number
    note?: string | null
    oecodes?: string[] | null
}

export interface StockBalanceSearchItemPaginatedCollection {
    page?: StockBalanceSearchItem[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface StockListItem {
    /** @format uuid */
    id: string
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    title?: string | null
    address?: string | null
    notes?: string | null
    isHide: boolean
    archived: boolean
    showInReports: boolean
    showInTransactions: boolean
}

export interface StockProductReserveResponse {
    /** @format int32 */
    orderId: number
    orderNo?: string | null
    /** @format uuid */
    documentId: string
    documentNo?: string | null
    documentType?: string | null
    reservedBy?: string | null
    /** @format date-time */
    reservedAt: string
    /** @format double */
    count: number
}

/** Response model for a storage location. */
export interface StorageLocationResponse {
    /**
     * The unique identifier of the storage location.
     * @format uuid
     */
    id: string
    /**
     * The identifier of the stock/warehouse this location belongs to.
     * @format uuid
     */
    stockId: string
    /** The title of the stock/warehouse. */
    stockTitle?: string | null
    /** Unique code/identifier for the storage location. */
    code?: string | null
    /** Additional notes or description. */
    comment?: string | null
    /**
     * The timestamp when the storage location was created (UTC).
     * @format date-time
     */
    createdAt: string
}

/**
 * Ответ ошибки типа `SubscriptionPlanNotFoundException`. Код см. в поле `Detail`.
 *
 * Exception thrown when subscription plan is not found for the specified country and currency.
 */
export interface SubscriptionPlanNotFoundExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SubscriptionPlanNotFoundException'. */
    Title?: 'SubscriptionPlanNotFoundException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `SubscriptionPlanNotFound` — No subscription plan is configured for the tenant's country and currency; result contains country and currency.
     */
    Detail?: SubscriptionPlanNotFoundErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `SupplierException`. Код см. в поле `Detail`. */
export interface SupplierExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'SupplierException'. */
    Title?: 'SupplierException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `UsedInDocuments` — Поставщик используется в документах (приход/расход/договоры) — удаление запрещено.
     */
    Detail?: SupplierErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

export interface SupplierListItemResponse {
    /** @format uuid */
    id: string
    name?: string | null
    unp?: string | null
    address?: string | null
    /** @format double */
    discount: number
    login?: string | null
    password?: string | null
    clientId?: string | null
    clientSecret?: string | null
    apiKey?: string | null
    notes?: string | null
    status?: string | null
    type: SuppliersTypeEnum
    active: boolean
    contactsList?: ContactResponse[] | null
}

export interface SupplierReferenceResponse {
    /** @format uuid */
    supplierId: string
    supplierName?: string | null
    supplierUnp?: string | null
}

/** Ответ ошибки типа `TagException`. Код см. в поле `Detail`. */
export interface TagExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'TagException'. */
    Title?: 'TagException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ResourceNotFound`
     * - `TagNotFound`
     * - `LinkNotFound`
     */
    Detail?: TagErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Response model that represents a tag in the tag list, together with how many resources use it. */
export interface TagListItemResponse {
    /**
     * The unique identifier of the tag.
     * @format int32
     */
    id?: number | null
    resourceType: TagResourceTypeEnum
    /** The name of the tag. */
    name?: string | null
    /**
     * Number of resources the tag is attached to.
     * Links to deleted resources are not counted, so a tag returned with
     * `includeUnused=true` may have a usage count of zero.
     * @format int32
     */
    usageCount: number
}

/** Response model that represents a tag attached to a resource. */
export interface TagResponse {
    /**
     * The unique identifier of the tag.
     * @format int32
     */
    id?: number | null
    resourceType: TagResourceTypeEnum
    /** The name of the tag. */
    name?: string | null
}

/** Paged response wrapper for task lists. */
export interface TaskListResponse {
    /** The list of tasks. */
    items?: TaskResponse[] | null
    /**
     * Total number of tasks matching the filters.
     * @format int32
     */
    totalCount: number
}

/** Response model for a task. */
export interface TaskResponse {
    /**
     * Primary key.
     * @format int32
     */
    id: number
    /** Short title of the task. */
    title?: string | null
    /** Optional detailed description. */
    description?: string | null
    /** Task status values. */
    status: TaskStatusEnum
    /**
     * Optional due date (UTC).
     * @format date-time
     */
    dueDate?: string | null
    /**
     * Assigned employee ID, or null.
     * @format int32
     */
    assigneeEmployeeId?: number | null
    /** Display name of the assigned employee, or null. */
    assigneeEmployeeName?: string | null
    /** Resource type the task is associated with, or null. */
    resourceType?: string | null
    /** Resource identifier, or null. */
    resourceId?: string | null
    /** User ID of the task creator. */
    ownerId?: string | null
    /**
     * Timestamp when the task was created (UTC).
     * @format date-time
     */
    createdAt: string
    /**
     * Timestamp when the task was last modified (UTC).
     * @format date-time
     */
    modifiedAt: string
    /** Whether the current user can edit this task (owner or assignee). */
    isEditable: boolean
    /**
     * Bucket the task belongs to, or null.
     * @format int32
     */
    bucketId?: number | null
    /** Lexorank position within the bucket, or null. */
    positionInBucket?: string | null
}

/** Response model that represents the current tax (VAT) settings of the system. */
export interface TaxSettingsResponse {
    /**
     * The type of VAT applied (e.g., standard, reduced, custom).
     * @format int32
     */
    vatType: number
    /**
     * The VAT percentage rate applied to work/services.
     * Default is `0`.
     * @format double
     */
    workVat: number
    /**
     * The VAT percentage rate applied to spare parts.
     * Default is `0`.
     * @format double
     */
    spareVat: number
    /** The text description of VAT (e.g., legal notice or additional info). */
    vatText?: string | null
}

/** Represents a team member with new sort order. */
export interface TeamMemberSortOrderItem {
    /**
     * Team member ID.
     * @format int32
     */
    id: number
    /**
     * New sort order value.
     * @format int32
     */
    sortOrder: number
}

/** Response model for Telemost board settings. */
export interface TelemostBoardSettingsResponse {
    /**
     * Unique identifier for the board settings.
     * @format int32
     */
    id: number
    /** Indicates whether to display the order status. */
    showStatus: boolean
    /** Indicates whether to display the planned time for orders. */
    showPlannedTime: boolean
    /** Indicates whether to display the estimated completion time. */
    showEstimatedTime: boolean
    /** Represents the available sort orders for board orders display. */
    sortOrder: TelemostBoardSortOrderEnum
    /**
     * Maximum number of orders to display on screen (1-50).
     * @format int32
     */
    maxOrdersOnScreen: number
}

/** Response model containing the logo URL for Telemost branding. */
export interface TelemostBrandingLogoResponse {
    /** URL to the logo image. */
    logoUrl?: string | null
}

/** Response model for Telemost branding settings. */
export interface TelemostBrandingResponse {
    /**
     * Unique identifier for the branding settings.
     * @format int32
     */
    id: number
    /** Name of the service being branded. */
    serviceName?: string | null
    /** Address of the service (optional). */
    address?: string | null
    /** URL to the logo image (optional). */
    logoUrl?: string | null
    /** Background color in HEX format (optional). */
    backgroundColor?: string | null
    /** Text color in HEX format (optional). */
    textColor?: string | null
    /** Accent color in HEX format (optional). */
    accentColor?: string | null
}

/** Response model for promotion image upload. */
export interface TelemostPromotionImageResponse {
    /** Public URL of the uploaded image. */
    imageUrl?: string | null
}

/** Response model for a single Telemost promotion. */
export interface TelemostPromotionResponse {
    /**
     * Unique identifier of the promotion.
     * @format int32
     */
    id: number
    /** Title of the promotion. */
    title?: string | null
    /** Detailed description of the promotion (optional). */
    description?: string | null
    /** URL to the promotion image (optional). */
    imageUrl?: string | null
    /**
     * Date when the promotion expires (optional, null = no expiration).
     * @format date-time
     */
    expirationDate?: string | null
    /** Whether the promotion is active and should be displayed. */
    isActive: boolean
    /**
     * Display order of the promotion (lower numbers first).
     * @format int32
     */
    sortOrder: number
    /**
     * Date and time when the promotion was created.
     * @format date-time
     */
    created: string
    /**
     * Date and time when the promotion was last modified.
     * @format date-time
     */
    modified: string
}

/** Response model for a list of Telemost promotions. */
export interface TelemostPromotionsListResponse {
    /** List of promotions. */
    promotions?: TelemostPromotionResponse[] | null
    /**
     * Total number of promotions matching the filter.
     * @format int32
     */
    totalCount: number
}

/** Response model containing the public link token for Telemost access. */
export interface TelemostPublicLinkTokenResponse {
    /** Token used to generate a public link for Telemost access. */
    publicLinkToken?: string | null
}

/** Simplified promotion information for screen list. */
export interface TelemostScreenPromotionResponse {
    /**
     * Unique identifier of the promotion.
     * @format int32
     */
    id: number
    /** Title of the promotion. */
    title?: string | null
}

/** Represents a screen in the Telemost rotation. */
export interface TelemostScreenResponse {
    /**
     * Unique identifier of the screen.
     * @format int32
     */
    id: number
    /** Represents the types of screens available in Telemost. */
    screenType: TelemostScreenTypeEnum
    /**
     * Reference ID (e.g., promotion ID for Promotion screens).
     * @format int32
     */
    referenceId?: number | null
    /**
     * Display interval in seconds (1-300).
     * @format int32
     */
    displayIntervalSec: number
    /** Whether the screen is enabled in rotation. */
    isEnabled: boolean
    /**
     * Display order (lower numbers appear first).
     * @format int32
     */
    sortOrder: number
    /** Whether the screen can be disabled by user (false for Board screen). */
    canToggle: boolean
}

/** Represents a list of screens with total count. */
export interface TelemostScreensListResponse {
    /** List of screens. */
    screens?: TelemostScreenResponse[] | null
    /** List of promotions referenced by screens. */
    promotions?: TelemostScreenPromotionResponse[] | null
}

/** Response model for Telemost settings. */
export interface TelemostSettingsResponse {
    /**
     * Unique identifier for the Telemost settings.
     * @format int32
     */
    id: number
    /** Indicates if Telemost is enabled for the tenant. */
    isEnabled: boolean
    /** Token used to generate a public link for Telemost access. */
    publicLinkToken?: string | null
    /** If true, only the board feature is enabled in Telemost. */
    boardOnlyMode: boolean
}

/** Response model for team member photo upload. */
export interface TelemostTeamMemberPhotoResponse {
    /** URL to the uploaded photo. */
    photoUrl?: string | null
}

/** Represents a team member displayed on the "Team" screen. */
export interface TelemostTeamMemberResponse {
    /**
     * Unique identifier of the team member.
     * @format int32
     */
    id: number
    /** Full name of the team member. */
    displayName?: string | null
    /** Position/role of the team member. */
    position?: string | null
    /** Short biography or description (up to 1000 characters). */
    bio?: string | null
    /** URL to the team member's photo. */
    photoUrl?: string | null
    /**
     * Display order (lower numbers appear first).
     * @format int32
     */
    sortOrder: number
    /**
     * Date and time when the team member was created.
     * @format date-time
     */
    created: string
    /**
     * Date and time when the team member was last modified.
     * @format date-time
     */
    modified: string
}

/** Represents a list of team members with total count. */
export interface TelemostTeamMembersListResponse {
    /** List of team members. */
    teamMembers?: TelemostTeamMemberResponse[] | null
    /**
     * Total count of team members.
     * @format int32
     */
    totalCount: number
}

/** Response model for Telemost ticker (running line) settings. */
export interface TelemostTickerSettingsResponse {
    /**
     * Unique identifier for the ticker settings.
     * @format int32
     */
    id: number
    /** Indicates whether the ticker is enabled and visible on the board. */
    isEnabled: boolean
    /** Ordered list of text items displayed in the running line. */
    items?: string[] | null
}

/** Information about a branch tenant. */
export interface TenantBranchResponse {
    /**
     * Branch tenant identifier.
     * @format int32
     */
    id: number
    /** Branch tenant name. */
    name?: string | null
    /** Branch organization name. */
    organizationName?: string | null
}

export interface TenantFeaturesResponse {
    sms: boolean
    telecom: boolean
}

export interface TenantRegistrationFormOption {
    title?: string | null
    value?: string | null
}

export interface TenantReportFilterResponse {
    reportingDateOptions?: ReportingDateKeyTextOptionResponse[] | null
    paymentMethodOptions?: KeyTexOptionResponse[] | null
    documentOptions?: DocumentKingKeyTextOptionResponse[] | null
    orderStatusOptions?: OrderStatusKeyTexOptionResponse[] | null
    workTypeOptions?: KeyTexOptionResponse[] | null
    sources?: IntKeyTexOptionResponse[] | null
}

export interface TipSummaryItem {
    /** @format int32 */
    id: number
    note?: string | null
}

export interface TipsSummaryResponse {
    exists: boolean
    cars?: TipSummaryItem[] | null
    clients?: TipSummaryItem[] | null
    orders?: OrderTipSummaryItem[] | null
}

/** Ответ ошибки типа `TogglePinNoteException`. Код см. в поле `Detail`. */
export interface TogglePinNoteExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'TogglePinNoteException'. */
    Title?: 'TogglePinNoteException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccessDenied` — The current user can only pin/unpin their own notes.
     */
    Detail?: TogglePinNoteErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `TokenSignInException`. Код см. в поле `Detail`. */
export interface TokenSignInExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'TokenSignInException'. */
    Title?: 'TokenSignInException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadTokenCredentials` — Неверный формат токена
     * - `BadToken` — Пользователь по токену не найден
     * - `UserIsLockedOut` — Аккаунт заблокирован
     * - `TenantIsMissing` — У пользователя нет тенанта
     * - `TenantIsBlocked` — Тенант заблокирован
     */
    Detail?: TokenSignInExceptionCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Represents a request to sign in using an authentication token. */
export interface TokenSignInRequest {
    /** Authentication token issued by the system (e.g., JWT, OAuth token). */
    token: string | null
}

export interface TransactionDocumentRef {
    /** @format uuid */
    documentId: string
    documentNo?: string | null
    documentType?: string | null
}

export interface TransactionHistoryResponse {
    /** @format uuid */
    id: string
    stockRef?: TransactionStockRef
    documentRef?: TransactionDocumentRef
    /** @format date-time */
    documentDate: string
    documentType?: string | null
    measure?: string | null
    /** @format double */
    debit: number
    /** @format double */
    credit: number
    supplierRef?: TransactionSupplierRef
}

export interface TransactionStockRef {
    /** @format uuid */
    stockId: string
    stockTitle?: string | null
}

export interface TransactionSupplierRef {
    /** @format uuid */
    supplierId: string
    supplierName?: string | null
    supplierUnp?: string | null
}

export interface TransferDocumentResponse {
    /** @format uuid */
    id: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    status: TransferDocumentStatusEnum
    sourceStockRef?: TransferStockRef
    targetStockRef?: TransferStockRef
    responsibleRef?: TransferEmployeeRef
    comment?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
    products?: TransferProductItem[] | null
}

export interface TransferEmployeeRef {
    id?: string | null
    name?: string | null
}

export interface TransferListItemResponse {
    /** @format uuid */
    id: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    status: TransferDocumentStatusEnum
    sourceStockRef?: TransferStockRef
    targetStockRef?: TransferStockRef
    responsibleRef?: TransferEmployeeRef
    comment?: string | null
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
}

export interface TransferListItemResponsePaginatedCollection {
    page?: TransferListItemResponse[] | null
    /** @format int32 */
    pageIndex: number
    /** @format int32 */
    pageSize: number
    /** @format int32 */
    totalCount: number
    /** @format int32 */
    totalPages: number
    hasPreviousPage: boolean
    hasNextPage: boolean
}

export interface TransferProductItem {
    /** @format uuid */
    productId: string
    name?: string | null
    internalCode?: string | null
    vendorCode?: string | null
    catalogCode?: string | null
    measure?: string | null
    /** @format double */
    count: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    sellingPriceNoVat: number
    /** @format double */
    sellingPriceVat: number
    /** @format double */
    sellingPrice: number
    /** @format double */
    costNoVatTotal: number
    /** @format double */
    sellingPriceNoVatTotal: number
}

export interface TransferStockRef {
    /** @format uuid */
    stockId: string
    stockTitle?: string | null
}

export interface UiLayoutResponse {
    pageType: UiLayoutPageTypeEnum
    layoutJson?: string | null
}

/** Ответ ошибки типа `UnblockUserException`. Код см. в поле `Detail`. */
export interface UnblockUserExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UnblockUserException'. */
    Title?: 'UnblockUserException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `UserIsNotLockedOut` — Аккаунт не заблокирован
     */
    Detail?: UnblockUserErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Represents a request to unblock a previously blocked user. */
export interface UnblockUserRequest {
    /** The login (username or email) of the user to be unblocked. */
    login: string | null
}

/** Ответ ошибки типа `UnpublishIncomeDocumentException`. Код см. в поле `Detail`. */
export interface UnpublishIncomeDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UnpublishIncomeDocumentException'. */
    Title?: 'UnpublishIncomeDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentMustBePublished` — The document is not published, so it cannot be unpublished; result contains documentId.
     */
    Detail?: UnpublishIncomeDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Ответ ошибки типа `UnpublishIncomeDocumentPromptException`. Код см. в поле `Detail`.
 *
 * Unpublishing without force is blocked while other documents still reference the same internal codes; the caller may retry with force=true to proceed anyway. Carries the domain payload (module's own ProductUsage list) as so this type stays referenceable from the Web layer, which maps it to a response model for the OpenAPI schema.
 */
export interface UnpublishIncomeDocumentPromptExceptionProblem {
    /** Всегда 'BadOperationPromptException'. */
    Type?: 'BadOperationPromptException'
    /** Discriminator. Всегда 'UnpublishIncomeDocumentPromptException'. */
    Title?: 'UnpublishIncomeDocumentPromptException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `ProductsAreUsedElsewhere`
     */
    Detail?: UnpublishIncomeDocumentPromptExceptionCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: {
        /** Типизированная полезная нагрузка. Какие коды её заполняют — см. описания значений `Detail`. */
        result?: ProductUsage[] | null
        /** Ошибки валидации `BadRequestException`: имя поля (camelCase) → массив сообщений. */
        errors?: Record<string, string[]>
        /** Полезная нагрузка `BadOperationPromptException.Result` (диалог подтверждения). */
        prompt?: any
        /** Полный `ToString()` исключения. Заполняется только в Development для непредвиденных ошибок. */
        error?: string | null
        [key: string]: any
    }
}

/** Ответ ошибки типа `UnpublishInventoryDocumentException`. Код см. в поле `Detail`. */
export interface UnpublishInventoryDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UnpublishInventoryDocumentException'. */
    Title?: 'UnpublishInventoryDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentMustBePublished` — The document is not published, so it cannot be unpublished; result contains documentId.
     */
    Detail?: UnpublishInventoryDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Ответ ошибки типа `UnpublishRevaluationDocumentException`. Код см. в поле `Detail`. */
export interface UnpublishRevaluationDocumentExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UnpublishRevaluationDocumentException'. */
    Title?: 'UnpublishRevaluationDocumentException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `DocumentMustBePublished` — The document is not published, so it cannot be unpublished; result contains documentId.
     * - `OnlyLastPublishedDocumentCanBeUnpublished` — Only the most recently published document can be unpublished; result contains documentId.
     */
    Detail?: UnpublishRevaluationDocumentErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for adding or updating Audatex integration settings. */
export interface UpdateAudatexSettingsRequest {
    /** The username used to authenticate with the Audatex service (optional). */
    username?: string | null
    /** The password used to authenticate with the Audatex service (optional). */
    password?: string | null
    /** Indicates whether the Audatex integration is enabled. */
    isEnabled: boolean
}

/** Request model for updating billing settings. */
export interface UpdateBillingSettingsRequest {
    /** Whether to send email notifications for invoices. */
    sendEmailEnabled: boolean
    /** Email address to send invoice notifications to. */
    sendEmailTo?: string | null
    /** Whether to create invoices automatically. */
    createInvoicesAutomatically: boolean
    /**
     * Number of days before subscription end to create invoice automatically.
     * @format int32
     */
    createInvoicesBeforeInDays: number
    /**
     * Billing period in months (1-12).
     * @format int32
     */
    billingPeriodInMonths: number
}

/**
 * Request model for updating an existing blacklist entry.
 * Allows modifying the reason why a client is blacklisted.
 */
export interface UpdateBlacklistRequest {
    /**
     * The unique identifier of the client whose blacklist entry should be updated.
     * @format int32
     */
    clientId: number
    /** The updated reason for keeping the client in the blacklist. */
    reason: string | null
}

/** Request model for updating a bucket. */
export interface UpdateBucketRequest {
    /** New display name. Required, max 200 characters. */
    name?: string | null
}

/** Request model for updating an existing car in the system. */
export interface UpdateCarRequest {
    /**
     * The unique identifier of the car to update.
     * @format int32
     */
    id: number
    /**
     * The identifier of the car owner.
     * @format int32
     */
    ownerId: number
    /**
     * The current mileage of the car (optional).
     * @format int32
     */
    mileage?: number | null
    /** The manufacturing year of the car (optional). */
    year?: string | null
    /** The registration number (license plate) of the car (optional). */
    regNo?: string | null
    /** The primary body (chassis) number of the car (optional). */
    bodyNo?: string | null
    /** An alternative body (chassis) number of the car (optional). */
    bodyNo2?: string | null
    /** The manufacturer (make) of the car (optional). */
    manufacturer?: string | null
    /** The model of the car (optional). */
    model?: string | null
    /**
     * The engine capacity in liters (optional).
     * @format float
     */
    engineLitres?: number | null
    fuelType?: FuelTypeEnum
    vehicleType: VehicleTypeEnum
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    /** Additional notes or annotations for the car. */
    annotation?: string | null
    /**
     * The identifier for the first repair times database entry (optional).
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** The value/description for the first repair times database entry (optional). */
    repTimesDb1Value?: string | null
    /**
     * The identifier for the second repair times database entry (optional).
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** The value/description for the second repair times database entry (optional). */
    repTimesDb2Value?: string | null
    /** The identifier for the third repair times database entry (optional). */
    repTimesDb3Id?: string | null
    /** The value/description for the third repair times database entry (optional). */
    repTimesDb3Value?: string | null
    /** The identifier for the fourth repair times database entry (optional). */
    repTimesDb4Id?: string | null
    /** The value/description for the fourth repair times database entry (optional). */
    repTimesDb4Value?: string | null
    /** The identifier for the fifth repair times database entry (optional). */
    repTimesDb5Id?: string | null
    /** The value/description for the fifth repair times database entry (optional). */
    repTimesDb5Value?: string | null
}

export interface UpdateCashboxPaymentRequest {
    /** @format uuid */
    id: string
    /** @format uuid */
    cashBoxId: string
    /** @format date-time */
    paymentDate: string
    /** @format uuid */
    parentPaymentId?: string | null
    /** @format uuid */
    paymentCategoryId?: string | null
    client?: PaymentClientRequest
    comment?: string | null
    email?: string | null
    isFullPayment?: boolean | null
    paymentType: PaymentTypeEnum
    isCanceled: boolean
    isReturned: boolean
    payments?: AddUpdateCashboxTransactionRequest[] | null
    documentReference?: DocumentReferenceRequest
}

export interface UpdateCashboxRequest {
    /** @format uuid */
    id: string
    title: string | null
    cashboxType: CashBoxTypeEnum
    hidden: boolean
    isArchive: boolean
    username?: string | null
    password?: string | null
    defaultCurrency: CurrencyCodeEnum
    /** @format int32 */
    integrationId?: number | null
}

/**
 * Request model for updating an existing client.
 * Contains detailed client information, including contacts, tags, and sources.
 */
export interface UpdateClientRequest {
    clientTypeCode: ClientTypeEnum
    /** A display-friendly name of the client (e.g., full name or company name). */
    displayName: string | null
    /** The email address of the client (optional). */
    email?: string | null
    /** The Skype contact of the client (optional). */
    skype?: string | null
    /** The Telegram contact of the client (optional). */
    telegram?: string | null
    /** The street address of the client (optional). */
    streetAddress?: string | null
    /** Additional notes or annotations about the client (optional). */
    annotation?: string | null
    /** The name of the bank associated with the client (optional). */
    bank?: string | null
    /** The bank code (e.g., SWIFT or local code) (optional). */
    bankCode?: string | null
    /** The bank account number of the client (optional). */
    bankAccount?: string | null
    /** The address of the client’s bank (optional). */
    bankAddress?: string | null
    /** The full name of the company director (optional). */
    director?: string | null
    /** The full name of the company accountant (optional). */
    accountant?: string | null
    /**
     * The general discount percentage applied to the client’s services.
     * @format int32
     */
    discountWorks: number
    /**
     * The discount percentage applied to spare parts.
     * @format int32
     */
    discountSpares: number
    /** The discount card number associated with the client (optional). */
    discountCard?: string | null
    /** Indicates whether the client is a resident (optional). */
    resident?: boolean | null
    /** The client’s birthday (optional). */
    birthday?: string | null
    /** Indicates whether the client requires follow-up calls. */
    isNeedCall?: boolean | null
    /** Marks the client as a favorite. */
    isFavorite?: boolean | null
    /** Indicates whether the client is marked as trusted. */
    isTrusted?: boolean | null
    /** The contract identifier associated with the client (optional). */
    contract?: string | null
    /** The contract start date (optional). */
    contractDate?: string | null
    /** The contract end date (optional). */
    contractEndDate?: string | null
    /** The legal basis for the contract (optional). */
    based?: string | null
    /** Indicates whether SMS notifications are disabled for this client. */
    banSms?: boolean | null
    /** The description or reason for disabling SMS notifications (optional). */
    banSmsDescription?: string | null
    /**
     * The rate number associated with the client.
     * @format int32
     */
    rateNumber?: number | null
    countryCode: CountryEnum
    /** The unique taxpayer identification number (UNP) of the client (optional). */
    unp?: string | null
    /** Custom property 2 (for extended data). */
    prop2?: string | null
    /** Custom property 3 (for extended data). */
    prop3?: string | null
    /** A list of sources from which the client was acquired. */
    sources?: AddUpdateClientSourceRequest[] | null
    /** A list of contact persons associated with the client. */
    contacts?: ClientContactRequest[] | null
    /**
     * The unique identifier of the client to update.
     * @format int32
     */
    id: number
}

export interface UpdateContactRequest {
    /** @format uuid */
    id?: string | null
    name?: string | null
    phone?: string | null
    email?: string | null
}

/** Represents a request to update an existing contract. */
export interface UpdateContractRequest {
    /** Contract number (optional, can be updated if changed). */
    contractNo?: string | null
    /**
     * Identifier of the station's bank account associated with this contract.
     * @format uuid
     */
    stationBankAccountId?: string | null
    /**
     * Identifier of the supplier (if the contract is with a supplier).
     * @format uuid
     */
    supplierId?: string | null
    /**
     * Identifier of the client (if the contract is with a client).
     * @format int32
     */
    clientId?: number | null
    /**
     * Date when the contract was signed.
     * @format date-time
     */
    signedAt: string
    /**
     * Date when the contract becomes effective.
     * @format date-time
     */
    startDate: string
    /**
     * Date when the contract ends.
     * @format date-time
     */
    endDate: string
    /**
     * Payment deferment period in days.
     * @format int32
     */
    paymentDeferment: number
    /**
     * Discount applied to work/services under the contract (percentage).
     * @format double
     */
    workDiscount: number
    /**
     * Discount applied to spare parts under the contract (percentage).
     * @format double
     */
    spareDiscount: number
    /**
     * Discount applied to contractor services under the contract (percentage).
     * @format double
     */
    contractorDiscount: number
    /** Additional notes or comments about the contract. */
    notes?: string | null
    signedBy?: string | null
    signedByPosition?: string | null
    signedOnBasis?: string | null
    warrantyObligations?: string | null
}

/**
 * Represents a request to update a contractor's contact information.
 * Contains details about the contact's identity, name, and phone number.
 */
export interface UpdateContractorContactRequest {
    /**
     * The unique identifier of the contact to update (optional).
     * If null, a new contact may be created.
     * @format int32
     */
    id?: number | null
    /**
     * The identifier of the contractor this contact belongs to.
     * @format int32
     */
    contractorId: number
    /** The full name of the contractor’s contact person. */
    fullName: string | null
    /** The phone number of the contractor’s contact person. */
    phoneNumber: string | null
}

/** Represents a request to update an existing contractor. */
export interface UpdateContractorRequest {
    /** Full legal name of the contractor (organization or individual). */
    fullName: string | null
    /** Taxpayer Identification Number (TIN) or equivalent company identifier. */
    tin: string | null
    /** Official address of the contractor. */
    address?: string | null
    /** Website of the contractor, if available. */
    site?: string | null
    /** Additional notes or annotations about the contractor. */
    annotation?: string | null
    /** Updated list of the contractor's contact persons with their details. */
    contacts?: UpdateContractorContactRequest[] | null
}

/** Represents a request to update or reorder a customer-provided work item within an order. */
export interface UpdateCustomerWorkRequest {
    /**
     * The identifier of the existing customer work item.
     * If `null`, the request may be treated as adding a new item.
     * @format int32
     */
    id?: number | null
    /**
     * The position (order index) of the work item in the list.
     * Used for sorting and execution sequence.
     * @format int32
     */
    position: number
    /**
     * The updated title or description of the customer work.
     * Example: "Install new battery", "Replace oil filter".
     */
    title: string | null
}

export interface UpdateCustomerWorksListItemRequest {
    /** @format int32 */
    id: number
    name?: string | null
}

export interface UpdateEmployeePermissionsRequest {
    permissions?: string[] | null
}

/** Request model for updating an existing employee's rate configuration. */
export interface UpdateEmployeeRateRequest {
    /**
     * The unique identifier of the employee rate record to be updated.
     * @format int32
     */
    id: number
    /**
     * The identifier of the station rate associated with this employee rate.
     * @format int32
     */
    stationRateId: number
    /**
     * The interest rate (percentage) applied for the specified station rate.
     * @format double
     */
    interestRate: number
    employeeRateType: EmployeeRateTypeEnum
}

/** Модель редактирования сотрудника */
export interface UpdateEmployeeRequest {
    /**
     * ID сотрудника
     * @format int32
     */
    id: number
    /** Полное имя сотрудника */
    fullName: string | null
    /** Сокращенное имя */
    shortName: string | null
    /** Должность сотрудника */
    position: string | null
    /** Адрес сотрудника */
    address?: string | null
    /** Основной телефон сотрудника */
    primaryPhone?: string | null
    /** Дополнительный телефон сотрудника */
    secondaryPhone?: string | null
    /** Email сотрудника */
    email?: string | null
    /** Дата рождения сотрудника */
    birthDay?: string | null
    /** Показывать как ответственного */
    showAsResponsible: boolean
    /**
     * Процентная ставка для ответственного
     * @format double
     */
    interestRateResponsible: number
    /** Показывать ли сотрудника как исполнителя */
    showAsExecutor: boolean
    /** Использовать единый процент на все виды работ */
    useCommonWorkInterestRate: boolean
    /**
     * Единый процент на все виды работ
     * @format double
     */
    workInterestRate?: number | null
    /**
     * Процентная ставка на запчасти
     * @format double
     */
    spareInterestRate: number
    /** Примечания для сотрудника */
    annotation?: string | null
    /** Доступ к мобильному приложению CarDone/Favicar - Master */
    isMobileAccessEnabledForMaster: boolean
    /** Процентные ставки в зависимости от вида работ */
    employeeRates?: UpdateEmployeeRateRequest[] | null
    /** Request model for adding or updating an employee's work schedule. */
    employeeSchedule?: AddUpdateEmployeeScheduleRequest
}

/** Represents a request to update a client-supplied spare part attached to an event. */
export interface UpdateEventClientSpareRequest {
    /**
     * Unique identifier of the client spare record to update.
     * @format int32
     */
    id: number
    /** Human-readable name of the spare part. */
    spareName: string | null
    /** Catalog/part number (SKU, OEM/aftermarket code). */
    catalogNumber?: string | null
    /**
     * Quantity of the spare part (can be fractional for fluids/consumables).
     * @format double
     */
    count: number
    /** Unit of measure (e.g., "pcs", "l", "kg", "m"). */
    measure: string | null
    condition: OrderClientSpareConditionEnum
    /**
     * Per-unit input price for this spare part (tenant currency). Use `decimal` for money.
     * @format double
     */
    inputPrice: number
}

export interface UpdateEventRequest {
    /**
     * Unique identifier of the event.
     * @format int32
     */
    id: number
    type: EventTypeEnum
    /**
     * Identifier of the area/location where the event takes place.
     * @format int32
     */
    areaId: number
    /**
     * Identifier of the responsible employee.
     * @format int32
     */
    responsibleId: number
    /**
     * Source
     * @format int32
     */
    sourceId?: number | null
    status: EventStatusEnum
    /**
     * Scheduled start time in UTC.
     * @format date-time
     */
    startUtc: string
    /**
     * Scheduled end time in UTC.
     * @format date-time
     */
    endUtc: string
    /** Short title/subject of the event. */
    title?: string | null
    /** Detailed description/notes for the event. */
    description?: string | null
    /**
     * Related vehicle identifier, if any.
     * @format int32
     */
    vehicleId?: number | null
    /**
     * Related client identifier, if any.
     * @format int32
     */
    clientId?: number | null
    /** Represents notification preferences for an event. */
    eventNotification?: EventNotificationDto
    /**
     * Lightweight vehicle DTO for embedding into event payloads/responses.
     * Includes display fields and cross-references to multiple RepTimes catalogs.
     */
    vehicleData?: EventVehicleDto
    clientData: EventClientDto
    /** Customer-requested work items (free-form list). */
    customerWork?: string[] | null
    /** Station-performed works associated with the event (optional). */
    stationWorks?: UpdateEventStationWorkRequest[] | null
    /** Station-supplied spare parts associated with the event (optional). */
    stationSpares?: UpdateEventStationSpareRequest[] | null
    /** Client-supplied spare parts associated with the event (optional). */
    clientSpares?: UpdateEventClientSpareRequest[] | null
    /**
     * Total cost of works/services.
     * @format double
     */
    wksCostTotal: number
    /**
     * Total cost of spare parts.
     * @format double
     */
    sprCostTotal: number
    /**
     * Total event cost
     * @format double
     */
    ttlCostTotal: number
    /** Linked Google Calendar identifier (optional). */
    googleCalendarId?: string | null
    /** Linked Google Calendar event identifier (optional). */
    googleEventId?: string | null
}

export interface UpdateEventStationSpareRequest {
    /**
     * Id
     * @format int32
     */
    id: number
    /** The name/description of the spare part. */
    spareName?: string | null
    /** Country of origin for the spare part (optional). */
    country?: string | null
    /** The brand name of the spare part (optional). */
    brandName?: string | null
    /** Vendor code (article number provided by manufacturer or supplier, optional). */
    vendorCode?: string | null
    /** Catalog number (article) of the spare part (optional). */
    catalogNumber?: string | null
    /**
     * The quantity of the spare part used in the order.
     * @format double
     */
    count: number
    /** Unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * VAT Rate
     * @format double
     */
    vatRate: number
    /**
     * Base input price (per unit) without VAT.
     * @format double
     */
    inputPriceNoVat: number
    /**
     * Total input price without VAT for all items (InputPriceNoVat * Count).
     * @format double
     */
    inputPriceNoVatTotal: number
    /**
     * VAT amount applied to the input price.
     * @format double
     */
    inputPriceVat: number
    /**
     * Input price (per unit) including VAT.
     * @format double
     */
    inputPrice: number
    /**
     * Total input price including VAT for all items.
     * @format double
     */
    inputPriceTotal: number
    /**
     * Absolute markup (extra charge) applied to the spare part.
     * @format double
     */
    extraAmount: number
    /**
     * Percentage markup applied to the spare part.
     * @format double
     */
    extraPercent: number
    /**
     * Selling price per unit without VAT.
     * @format double
     */
    priceNoVat: number
    /**
     * Total selling price without VAT for all items.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount applied to the selling price.
     * @format double
     */
    priceVat: number
    /**
     * Selling price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * Total selling price including VAT for all items.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to this spare part.
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount applied.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount included in the cost.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments for this spare part. */
    notes?: string | null
    /**
     * Identifier of the stock (warehouse) from which the spare part was taken.
     * @format uuid
     */
    stockId?: string | null
    /**
     * Identifier of the product in stock system.
     * @format uuid
     */
    productId?: string | null
    /** Internal code of the spare part in stock system (optional). */
    internalCode?: string | null
    status: OrderStationSparesStatusEnum
}

/**
 * Represents a request to update a station-performed work line within an event,
 * including pricing, VAT, discount, costs and display options.
 */
export interface UpdateEventStationWorkRequest {
    /**
     * Unique identifier of the work line to update.
     * @format int32
     */
    id: number
    /** Display name of the work (shown in UI/documents). */
    displayName: string | null
    /**
     * Quantity of work (e.g., hours or units). Use `decimal` for exact arithmetic.
     * @format double
     */
    count: number
    /**
     * Optional rate code/number from the price list (tariff identifier).
     * @format int32
     */
    rateNumber: number
    /**
     * Optional price per rate unit (e.g., per hour) excluding VAT.
     * @format double
     */
    ratePrice: number
    /**
     * Standard (normative) time per unit (e.g., hours for this operation).
     * @format double
     */
    normTime: number
    /**
     * Total normative time (usually `NormTime × Count`).
     * @format double
     */
    normTimeTotal: number
    /**
     * VAT Rate
     * @format double
     */
    vatRate: number
    /**
     * Unit price excluding VAT (net).
     * @format double
     */
    priceNoVat: number
    /**
     * Total price excluding VAT (net) for the line.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount for the line (commonly total, not a rate).
     * @format double
     */
    priceVat: number
    /**
     * Unit price including VAT (gross).
     * @format double
     */
    price: number
    /**
     * Total price including VAT (gross) for the line.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to the line (0–100).
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount in currency (total subtracted).
     * @format double
     */
    discountAmount: number
    /**
     * Unit internal cost excluding VAT (net).
     * @format double
     */
    costNoVat: number
    /**
     * Total internal cost excluding VAT (net) for the line.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount calculated from internal cost (commonly total).
     * @format double
     */
    costVat: number
    /**
     * Total internal cost including VAT (gross) for the line.
     * @format double
     */
    costTotal: number
    workSource: WorkSourceEnum
    /** If true, hides the normative time in printed documents/UI. */
    isHideNormTime: boolean
    status: OrderWorkStatusEnum
}

export interface UpdateIncomeDocumentRequest {
    /** @format uuid */
    stockId: string
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    /** @format date-time */
    estimatedShippingDate?: string | null
    bankAccountRef?: WarehouseBankAccountReferenceDto
    responsibleRef?: WarehouseEmployeeReferenceDto
    supplierRef?: WarehouseSupplierReferenceDto
    supplierContractRef?: WarehouseContractReferenceDto
    buyerRef?: WarehouseBuyerReferenceDto
    buyerContractRef?: WarehouseContractReferenceDto
    comment?: string | null
    /** @format double */
    vat: number
    products?: IncomeProductDto[] | null
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    documentType: IncomeDocumentTypeEnum
}

export interface UpdateInventoryDocumentRequest {
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    stockRef?: InventoryStockRef
    responsibleRef?: InventoryEmployeeRef
    comment?: string | null
    productsToAdd?: InventoryProductCreateItem[] | null
    productsToUpdate?: InventoryProductUpdateItem[] | null
    productsToDelete?: InventoryProductDeleteItem[] | null
}

/** Ответ ошибки типа `UpdateNoteException`. Код см. в поле `Detail`. */
export interface UpdateNoteExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UpdateNoteException'. */
    Title?: 'UpdateNoteException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccessDenied` — The current user can only update their own notes.
     */
    Detail?: UpdateNoteErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for updating an existing note. */
export interface UpdateNoteRequest {
    /** The updated content/description of the note. */
    description?: string | null
    /** Indicates whether the note is visible to all users who can access the resource. If false, the note is personal (visible only to the owner). */
    isPublic: boolean
    /** Indicates whether the note should be pinned to the top of the list. */
    isPinned: boolean
}

/**
 * Represents a request model for adding a client-provided spare part to an order.
 * Contains details such as catalog number, name, unit of measure, quantity, usage flag,
 * and initial input price.
 */
export interface UpdateOrderClientSpareRequest {
    /**
     * Unique identifier of the client spare part record.
     * @format int32
     */
    id?: number | null
    /**
     * The position (sorting index) of the spare part in the order’s spare list.
     * @format int32
     */
    position: number
    /** The catalog number of the spare part (optional, may come from a catalog or be manually entered). */
    catalogNumber?: string | null
    /** The name/description of the spare part provided by the client. */
    spareName?: string | null
    /** The unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * The quantity of the spare part provided by the client.
     * @format float
     */
    count: number
    condition: OrderClientSpareConditionEnum
    /**
     * The input price of the spare part (value assigned, before markup).
     * @format double
     */
    inputPrice: number
}

/**
 * Represents a request model for adding a contractor's work to an order.
 * Contains details such as contractor identifier, work description,
 * pricing information (with and without VAT), and calculated profit.
 */
export interface UpdateOrderContractorWorkRequest {
    /**
     * Unique identifier of the contractor work record.
     * @format int32
     */
    id?: number | null
    /**
     * The position (sorting index) of the work in the order’s contractor work list.
     * @format int32
     */
    position: number
    /**
     * The identifier of the contractor who performed the work.
     * @format int32
     */
    contractorId: number
    /** The description of the contractor's work (e.g., "Wheel alignment", "Painting"). */
    workDesc: string | null
    /**
     * The applied VAT (Value Added Tax) percentage for this work.
     * @format double
     */
    vat: number
    /**
     * The initial input price without vat
     * @format double
     */
    inputPriceNoVat: number
    /**
     * The initial input price (cost provided by contractor, before taxes).
     * @format double
     */
    inputPriceVat: number
    /**
     * The initial input price (cost provided by contractor, before taxes).
     * @format double
     */
    inputPrice: number
    /** @format double */
    extraAmount: number
    /** @format double */
    extraPercent: number
    /**
     * The cost of the work excluding VAT.
     * @format double
     */
    costNoVat: number
    /**
     * The VAT amount applied to the cost of the work.
     * @format double
     */
    costVat: number
    /**
     * The total cost including VAT.
     * @format double
     */
    costTotal: number
    /**
     * The calculated profit margin for this contractor work.
     * @format double
     */
    profit: number
}

/** Ответ ошибки типа `UpdateOrderException`. Код см. в поле `Detail`. */
export interface UpdateOrderExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UpdateOrderException'. */
    Title?: 'UpdateOrderException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadOrderVersion` (HTTP 400) — The request does not contain a valid row version.
     * - `OrderVersionConflict` (HTTP 409) — The order was modified concurrently; reload it and retry.
     */
    Detail?: UpdateOrderErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Request model for updating an existing order.
 * Contains order details, financial calculations, dates,
 * and related child objects (works, spares, tags).
 */
export interface UpdateOrderRequest {
    /**
     * The unique identifier of the order being updated.
     * @format int32
     */
    id: number
    /** Concurrency version token */
    version?: string | null
    /**
     * The identifier of the associated bank account.
     * @format uuid
     */
    bankAccount: string
    /**
     * The identifier of the employee responsible for the order.
     * @format int32
     */
    employeeId: number
    /**
     * The identifier of the order owner.
     * @format int32
     */
    ownerId: number
    /**
     * The identifier of the client.
     * @format int32
     */
    clientId: number
    /**
     * The identifier of the payer (who pays for the order).
     * @format int32
     */
    payerId: number
    /**
     * The identifier of the associated car.
     * @format int32
     */
    carId: number
    /**
     * The identifier of the related contract, if applicable.
     * @format uuid
     */
    contractId?: string | null
    numberingType: OrderNumberingTypeEnum
    /** The order number (optional). */
    orderNo?: string | null
    /** The act number (optional). */
    actNo?: string | null
    /**
     * The current mileage of the vehicle (optional).
     * @format int32
     */
    mileage?: number | null
    /** Indicates whether this is a training order. */
    isTraining: boolean
    /** Proxy number related to the order (optional). */
    proxyNumber?: string | null
    /** Reported malfunctions or issues (optional). */
    malfunctions?: string | null
    /** Additional notes about the order (optional). */
    notes?: string | null
    /** Warranty details (optional). */
    warranty?: string | null
    /** Recommendations for the client (optional). */
    recommendation?: string | null
    status: OrderStatusEnum
    /**
     * VAT value for works.
     * @format double
     */
    ndsWorks: number
    /**
     * VAT value for spare parts.
     * @format double
     */
    ndsSpares: number
    /**
     * The order creation date.
     * @format date-time
     */
    orderDate: string
    /**
     * The estimated completion date.
     * @format date-time
     */
    estimateDate: string
    /**
     * The due date for payment (optional).
     * @format date-time
     */
    paymentDueDate?: string | null
    /**
     * The actual payment date (optional).
     * @format date-time
     */
    paymentDate?: string | null
    /**
     * Discount applied to works.
     * @format double
     */
    wksDiscountAmount: number
    /**
     * Discount applied to spare parts.
     * @format double
     */
    sprDiscountAmount: number
    /**
     * Total discount amount.
     * @format double
     */
    ttlDiscountAmount: number
    /**
     * Profit from works.
     * @format double
     */
    wksProfit: number
    /**
     * Profit from contractor works.
     * @format double
     */
    ctrProfit: number
    /**
     * Profit from spare parts.
     * @format double
     */
    sprProfit: number
    /**
     * Total profit from the order.
     * @format double
     */
    ttlProfit: number
    /**
     * Cost of works without VAT.
     * @format double
     */
    wksCostNoVat: number
    /**
     * Cost of contractor works without VAT.
     * @format double
     */
    ctrCostNoVat: number
    /**
     * Cost of spare parts without VAT.
     * @format double
     */
    sprCostNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    ttlCostNoVat: number
    /**
     * VAT amount for works.
     * @format double
     */
    wksCostVat: number
    /**
     * VAT amount for contractor works.
     * @format double
     */
    ctrCostVat: number
    /**
     * VAT amount for spare parts.
     * @format double
     */
    sprCostVat: number
    /**
     * Total VAT amount.
     * @format double
     */
    ttlCostVat: number
    /**
     * Total cost of works (including VAT).
     * @format double
     */
    wksCostTotal: number
    /**
     * Total cost of contractor works (including VAT).
     * @format double
     */
    ctrCostTotal: number
    /**
     * Total cost of spare parts (including VAT).
     * @format double
     */
    sprCostTotal: number
    /**
     * Total cost of the order (including VAT).
     * @format double
     */
    ttlCostTotal: number
    /**
     * Total work norms.
     * @format double
     */
    wksNormsTotal: number
    /**
     * Total contractor spare costs.
     * @format double
     */
    cspCostTotal: number
    /**
     * Discount for works applied at the client level.
     * @format double
     */
    discountWksClient: number
    /**
     * Discount for works applied at the car level.
     * @format double
     */
    discountWksCar: number
    /**
     * Total discount for works.
     * @format double
     */
    discountWksTtl: number
    /**
     * Total discount for spare parts.
     * @format double
     */
    discountSprTtl: number
    /**
     * Discount based on car age or year.
     * @format double
     */
    discountYear: number
    /** List of customer works linked to the order (optional). */
    customerWorks?: UpdateCustomerWorkRequest[] | null
    /** List of station works linked to the order (optional). */
    orderWorks?: UpdateOrderStationWorkRequest[] | null
    /** List of contractor works linked to the order (optional). */
    contractorWorks?: UpdateOrderContractorWorkRequest[] | null
    /** List of client-supplied spare parts (optional). */
    clientSpares?: UpdateOrderClientSpareRequest[] | null
    /** List of station-supplied spare parts (optional). */
    stationSpares?: UpdateOrderStationSpareRequest[] | null
}

/**
 * Represents a request model for adding a station-provided spare part to an order.
 * Contains details about identification, pricing, markup, discounts, costs, and stock properties.
 */
export interface UpdateOrderStationSpareRequest {
    /**
     * Unique identifier of the station spare record.
     * @format int32
     */
    id?: number | null
    /**
     * The position (sorting index) of the spare part in the order’s spare list.
     * @format int32
     */
    position: number
    /** The name/description of the spare part. */
    spareName?: string | null
    /** Country of origin for the spare part (optional). */
    country?: string | null
    /** The brand name of the spare part (optional). */
    brandName?: string | null
    /** Vendor code (article number provided by manufacturer or supplier, optional). */
    vendorCode?: string | null
    /** Catalog number (article) of the spare part (optional). */
    catalogNumber?: string | null
    /**
     * The quantity of the spare part used in the order.
     * @format double
     */
    count: number
    /** Unit of measure for the spare part (e.g., pcs, liters). */
    measure?: string | null
    /**
     * Identifier of the employee responsible for this spare part.
     * @format int32
     */
    responsibleId: number
    /**
     * Base input price (per unit) without VAT.
     * @format double
     */
    inputPriceNoVat: number
    /**
     * Total input price without VAT for all items (InputPriceNoVat * Count).
     * @format double
     */
    inputPriceNoVatTotal: number
    /**
     * VAT amount applied to the input price.
     * @format double
     */
    inputPriceVat: number
    /**
     * Input price (per unit) including VAT.
     * @format double
     */
    inputPrice: number
    /**
     * Total input price including VAT for all items.
     * @format double
     */
    inputPriceTotal: number
    /**
     * Absolute markup (extra charge) applied to the spare part.
     * @format double
     */
    extraAmount: number
    /**
     * Percentage markup applied to the spare part.
     * @format double
     */
    extraPercent: number
    /**
     * Selling price per unit without VAT.
     * @format double
     */
    priceNoVat: number
    /**
     * Total selling price without VAT for all items.
     * @format double
     */
    priceNoVatTotal: number
    /**
     * VAT amount applied to the selling price.
     * @format double
     */
    priceVat: number
    /**
     * Selling price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * Total selling price including VAT for all items.
     * @format double
     */
    priceTotal: number
    /**
     * Discount percentage applied to this spare part.
     * @format double
     */
    discount: number
    /**
     * Absolute discount amount applied.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT.
     * @format double
     */
    costNoVatTotal: number
    /**
     * VAT amount included in the cost.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments for this spare part. */
    notes?: string | null
    /**
     * Calculated profit for this spare part (selling price - cost).
     * @format double
     */
    profit: number
    /**
     * Identifier of the stock (warehouse) from which the spare part was taken.
     * @format uuid
     */
    stockId?: string | null
    /**
     * Identifier of the product in stock system.
     * @format uuid
     */
    productId?: string | null
    /** Internal code of the spare part in stock system (optional). */
    internalCode?: string | null
    status: OrderStationSparesStatusEnum
}

/**
 * Represents a request model for adding a station work entry to an order.
 * Contains details about work identification, pricing, costs, discounts, profit,
 * and assigned employees.
 */
export interface UpdateOrderStationWorkRequest {
    /**
     * Unique identifier of the station work entry.
     * @format int32
     */
    id?: number | null
    /**
     * Position (ordering) of this work within the order.
     * @format int32
     */
    position: number
    /** Identifier of the work item (from catalog or external source). */
    workId?: string | null
    /** Description of the work performed. */
    workDesc?: string | null
    workSource: WorkSourceEnum
    /**
     * Quantity of work items.
     * @format double
     */
    count: number
    /**
     * Standard norm time for a single unit of this work.
     * @format double
     */
    normTime: number
    /**
     * Total calculated norm time (NormTime × Count).
     * @format double
     */
    normTimeTotal: number
    /**
     * Identifier of the responsible employee.
     * @format int32
     */
    responsibleId: number
    /**
     * Optional rate number (used for calculating pricing based on station rate tables).
     * @format int32
     */
    rateNumber?: number | null
    /**
     * Price per unit (rate price).
     * @format double
     */
    ratePrice: number
    /**
     * Price without VAT for a single unit of work.
     * @format double
     */
    priceNoVat: number
    /**
     * Total price without VAT (PriceNoVat × Count).
     * @format double
     */
    priceNoVatTotal: number
    /**
     * Price per unit including VAT.
     * @format double
     */
    price: number
    /**
     * VAT amount for the work.
     * @format double
     */
    priceVat: number
    /**
     * Total price including VAT.
     * @format double
     */
    priceTotal: number
    /**
     * Applied discount percentage.
     * @format double
     */
    discount: number
    /**
     * Discount amount in absolute value.
     * @format double
     */
    discountAmount: number
    /**
     * Cost per unit without VAT.
     * @format double
     */
    costNoVat: number
    /**
     * Total cost without VAT (CostNoVat × Count).
     * @format double
     */
    costNoVatTotal: number
    /**
     * Cost of VAT applied to this work.
     * @format double
     */
    costVat: number
    /**
     * Total cost including VAT.
     * @format double
     */
    costTotal: number
    /** Additional notes or comments about the work. */
    notes?: string | null
    /**
     * Calculated profit (difference between price and cost).
     * @format double
     */
    profit: number
    /** Indicates whether the norm time should be hidden in reports/UI. */
    isHideNormTime: boolean
    /** Indicates whether this work should be excluded from order calculations. */
    ignoreWorkOnCalc: boolean
    calc: EmployeeCalcTypeEnum
    status: OrderWorkStatusEnum
    /** List of employees assigned to this work. */
    workers?: UpdateOrderWorkEmployeeRequest[] | null
}

/** Ответ ошибки типа `UpdateOrderStatusException`. Код см. в поле `Detail`. */
export interface UpdateOrderStatusExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UpdateOrderStatusException'. */
    Title?: 'UpdateOrderStatusException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `UnsupportedStatus` — The order status has no mapping to an event/preorder status.
     */
    Detail?: UpdateOrderStatusErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/**
 * Response model representing the details of an employee's involvement in a specific order work item.
 * Contains information about time worked, share of work, and calculated payment/interest.
 */
export interface UpdateOrderWorkEmployeeRequest {
    /**
     * Unique identifier of the employee.
     * @format int32
     */
    employeeId: number
    /**
     * Norm time (in hours) assigned to the employee for this work item.
     * @format float
     */
    normTime: number
    /**
     * Percentage of the total work assigned to the employee.
     * @format double
     */
    percentage: number
    /**
     * Absolute part of the work amount assigned to the employee.
     * @format double
     */
    amountPart: number
    /**
     * Employee’s interest rate (percentage of profit or cost applied).
     * @format double
     */
    interestRate: number
    /**
     * Calculated interest amount for the employee based on the interest rate.
     * @format double
     */
    interestAmount: number
    /**
     * Rate price per unit of work assigned to the employee.
     * @format double
     */
    ratePrice: number
}

export interface UpdateOutcomeDocumentRequest {
    /** @format uuid */
    stockId: string
    suppressStockBalanceCheck: boolean
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    /** @format date-time */
    estimatedSaleDate?: string | null
    /** @format date-time */
    estimatedPaymentDate?: string | null
    bankAccountRef?: WarehouseBankAccountReferenceDto
    responsibleRef?: WarehouseEmployeeReferenceDto
    supplierRef?: WarehouseSupplierReferenceDto
    supplierContractRef?: WarehouseContractReferenceDto
    buyerRef?: WarehouseBuyerReferenceDto
    buyerContractRef?: WarehouseContractReferenceDto
    comment?: string | null
    /** @format double */
    vat: number
    products?: OutcomeProductDto[] | null
    /** @format double */
    ttlPriceNoVat: number
    /** @format double */
    ttlPriceVat: number
    /** @format double */
    ttlPriceTotal: number
    /** @format double */
    ttlDiscountAmount: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
    documentType: OutcomeDocumentTypeEnum
}

export interface UpdatePreOrderRequest {
    preOrder: PreOrderPayload
    events?: PreOrderEventsUpdatePayload
}

export interface UpdatePriceListItemRequest {
    /** @format uuid */
    itemId: string
    name: string | null
    tagCode: string | null
    isHideNormTime: boolean
    currency: CurrencyCodeEnum
    spares?: PriceListStationSpare[] | null
    works?: PriceListStationWork[] | null
    /** @format double */
    spareVat: number
    /** @format double */
    workVat: number
    /** @format double */
    wksNormsTotal: number
    /** @format double */
    wksCostNoVat: number
    /** @format double */
    wksCostVat: number
    /** @format double */
    wksCostTotal: number
    /** @format double */
    sprCostNoVat: number
    /** @format double */
    sprCostVat: number
    /** @format double */
    sprCostTotal: number
    /** @format double */
    ttlCostNoVat: number
    /** @format double */
    ttlCostVat: number
    /** @format double */
    ttlCostTotal: number
}

export interface UpdatePriceListItemTagRequest {
    name: string | null
    description?: string | null
}

export interface UpdateProductRequest {
    /** @minLength 1 */
    name: string
    printName?: string | null
    /** @minLength 1 */
    measure: string
    /** @minLength 1 */
    tagCode: string
    catalogCode?: string | null
    vendorCode?: string | null
    description?: string | null
    brandName?: string | null
    country?: string | null
    comment?: string | null
    /** @format double */
    minBalance: number
    /** @format double */
    weight: number
    /** @format double */
    vat: number
    /** @format double */
    costNoVat: number
    /** @format double */
    costVat: number
    /** @format double */
    cost: number
    /** @format double */
    recommendedPriceNoVat: number
    /** @format double */
    recommendedPriceVat: number
    /** @format double */
    recommendedPrice: number
    barcodeList?: CatalogBarcodeItem[] | null
    oecodeList?: CatalogOecodeItem[] | null
    renameEverywhere: boolean
}

export interface UpdateProductTagRequest {
    name?: string | null
    description?: string | null
}

/** Request model for updating the sort order of multiple promotions. */
export interface UpdatePromotionsSortOrderRequest {
    /** List of promotion IDs with their new sort order values. */
    items?: PromotionSortOrderItem[] | null
}

export interface UpdateRevaluationDocumentRequest {
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    responsibleRef?: RevaluationEmployeeRef
    comment?: string | null
    products?: RevaluationProductItem[] | null
}

export interface UpdateScreensSortOrderRequest {
    items?: ScreenSortOrderItem[] | null
}

export interface UpdateSourceRequest {
    title: string | null
}

/** Request model for updating an existing station bank account. */
export interface UpdateStationBankAccountRequest {
    /**
     * Unique identifier of the bank account to update.
     * @format uuid
     */
    id: string
    /**
     * The position or display order of the bank account in the list.
     * @format int32
     */
    position: number
    /** The title or descriptive name of the bank account. */
    title: string | null
    /** The name of the bank where the account is held. */
    bankName?: string | null
    /** The bank’s code (e.g., SWIFT/BIC or local identifier). */
    bankCode?: string | null
    /** The number of the bank account. */
    bankAccount?: string | null
    /** The address of the bank branch. */
    bankAddress?: string | null
    currency: CurrencyCodeEnum
    type: BankAccountTypeEnum
    /** A list of associated cashbox identifiers linked to this account. */
    cashboxes?: string[] | null
    /** Indicates whether this account is the default account for the station. */
    isDefault: boolean
    /** Indicates whether the account is archived (inactive). */
    archived: boolean
}

/** Request model for updating stock product note. */
export interface UpdateStockProductNoteRequest {
    /**
     * Note text. Send null or empty string to clear.
     * @maxLength 250
     */
    note?: string | null
}

export interface UpdateStockRequest {
    /** @minLength 1 */
    title: string
    address?: string | null
    notes?: string | null
    isHide: boolean
}

/** Request model for updating an existing storage location. */
export interface UpdateStorageLocationRequest {
    /** Unique code/identifier for the storage location. */
    code?: string | null
    /** Additional notes or description. */
    comment?: string | null
}

export interface UpdateSupplierRequest {
    name?: string | null
    nip?: string | null
    address?: string | null
    /** @format double */
    discount: number
    login?: string | null
    password?: string | null
    clientId?: string | null
    clientSecret?: string | null
    apiKey?: string | null
    notes?: string | null
    status?: string | null
    type: SuppliersTypeEnum
    active: boolean
    contactsList?: UpdateContactRequest[] | null
}

/** Ответ ошибки типа `UpdateTaskException`. Код см. в поле `Detail`. */
export interface UpdateTaskExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UpdateTaskException'. */
    Title?: 'UpdateTaskException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `AccessDenied` — Only the creator or assignee can update the task.
     */
    Detail?: UpdateTaskErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Request model for updating an existing task. */
export interface UpdateTaskRequest {
    /** Short title of the task. Required, max 500 characters. */
    title?: string | null
    /** Optional detailed description. Max 2000 characters. */
    description?: string | null
    /**
     * Optional employee to assign the task to.
     * @format int32
     */
    assigneeEmployeeId?: number | null
    /**
     * Optional due date (UTC).
     * @format date-time
     */
    dueDate?: string | null
    /** Task status values. */
    status: TaskStatusEnum
}

export interface UpdateTeamMembersSortOrderRequest {
    items?: TeamMemberSortOrderItem[] | null
}

/** Request model for updating Telemost board settings. */
export interface UpdateTelemostBoardSettingsRequest {
    /** Indicates whether to display the planned time for orders. */
    showPlannedTime: boolean
    /** Indicates whether to display the order status. */
    showStatus: boolean
    /** Indicates whether to display the estimated completion time. */
    showEstimatedTime: boolean
    /** Represents the available sort orders for board orders display. */
    sortOrder: TelemostBoardSortOrderEnum
    /**
     * Maximum number of orders to display on screen (1-50).
     * @format int32
     */
    maxOrdersOnScreen: number
}

/** Request model for updating Telemost branding settings */
export interface UpdateTelemostBrandingRequest {
    /** Display name of the service. */
    serviceName?: string | null
    /** Address of the service (optional, max 500 characters). */
    address?: string | null
    /** Background color in HEX format (#RRGGBB). */
    backgroundColor?: string | null
    /** Text color in HEX format (#RRGGBB). */
    textColor?: string | null
    /** Accent color in HEX format (#RRGGBB). */
    accentColor?: string | null
}

/** Request model for updating an existing Telemost promotion. */
export interface UpdateTelemostPromotionRequest {
    /** Title of the promotion. */
    title?: string | null
    /** Detailed description of the promotion (optional). */
    description?: string | null
    /**
     * Date when the promotion expires (optional, null = no expiration).
     * @format date-time
     */
    expirationDate?: string | null
    /** Whether the promotion is active and should be displayed. */
    isActive: boolean
}

/** Request model for updating screen settings. */
export interface UpdateTelemostScreenRequest {
    /**
     * Display interval in seconds (1-300).
     * @format int32
     */
    displayIntervalSec: number
    /** Whether the screen is enabled in rotation (Note: Board screen cannot be disabled). */
    isEnabled: boolean
}

/** Request model for updating Telemost settings */
export interface UpdateTelemostSettingsRequest {
    /** Indicates whether Telemost is activated for the station. */
    isEnabled: boolean
    /** When enabled, displays only the orders board without rotating through other screens. */
    boardOnlyMode: boolean
}

/** Request model for updating an existing team member. */
export interface UpdateTelemostTeamMemberRequest {
    /** Full name of the team member (required). */
    displayName?: string | null
    /** Position/role of the team member (required). */
    position?: string | null
    /** Short biography or description (optional, up to 1000 characters). */
    bio?: string | null
}

/** Request model for updating Telemost ticker (running line) settings. */
export interface UpdateTelemostTickerSettingsRequest {
    /** Indicates whether the ticker is enabled and visible on the board. */
    isEnabled: boolean
    /** Ordered list of text items to display in the running line (max 20 items, max 500 chars each). */
    items?: string[] | null
}

export interface UpdateTransferDocumentRequest {
    documentNo?: string | null
    /** @format date-time */
    documentDate: string
    /** @format uuid */
    targetStockId: string
    responsibleRef?: TransferEmployeeRef
    comment?: string | null
    products?: TransferProductItem[] | null
}

export interface UpdateWhSettingsRequest {
    warehouseAccountingMethod: WarehouseAccountingMethodTypeEnum
    disallowShippingMissingItems: boolean
    isValidateSalePrice: boolean
    isReserveControlEnabled: boolean
    isCatalogNumberRequired: boolean
    uniqueDocNumberRequired: boolean
}

export interface UpsertSavedRecipientListFromReportRequest {
    title?: string | null
    /** @format date-time */
    startDate: string
    /** @format int32 */
    ordersCount: number
    fiz: boolean
    org: boolean
}

export interface UpsertSavedRecipientListRequest {
    /** @format int32 */
    id?: number | null
    title?: string | null
    isManual: boolean
    filter?: SearchSmsClientsRequest
    clientIds?: number[] | null
}

export interface UpsertSmsCampaignRequest {
    /** @format int32 */
    id?: number | null
    status: SmsCampaignStatusResponse
    title?: string | null
    message?: string | null
    isInstant: boolean
    /** @format date-time */
    scheduleDate?: string | null
    /** @format int32 */
    selectedSavedRecipientListId?: number | null
    recipients?: SmsCampaignRecipientRequest[] | null
}

export interface UpsertSmsTemplateRequest {
    name: SmsTemplateNameEnum
    type: SmsTemplateTypeEnum
    /** @format int32 */
    value: number
    message?: string | null
}

/** Ответ ошибки типа `UserSignInException`. Код см. в поле `Detail`. */
export interface UserSignInExceptionProblem {
    /** Всегда 'BadOperationException'. */
    Type?: 'BadOperationException'
    /** Discriminator. Всегда 'UserSignInException'. */
    Title?: 'UserSignInException'
    /** @format int32 */
    Status?: number
    /**
     * Возможные значения:
     * - `BadUser` — Пользователь не найден
     * - `UserIsLockedOut` — Аккаунт заблокирован
     * - `BadCredentials` — Неверный пароль
     * - `TenantIsMissing` — У пользователя нет тенанта
     * - `TenantIsBlocked` — Тенант заблокирован
     */
    Detail?: UserSignInErrorCode
    Instance?: string | null
    /**
     * Содержимое поля `Extensions`. Все поля опциональны; null не сериализуются
     * (`WhenWritingNull`), чтобы клиент видел только реально заполненные ключи —
     * как в прежней dictionary-реализации.
     */
    Extensions?: ApiProblemExtensions
}

/** Represents a request to sign in a user with login credentials. */
export interface UserSignInRequest {
    /** The login identifier of the user (username or email). */
    login: string | null
    /** The user's password associated with the login. */
    password: string | null
}

/** Represents a request to sign out a user from the application. */
export interface UserSignOutRequest {
    /** Application token used to identify the active user session. */
    appToken: string | null
}

export interface VehicalsAnalyticalReportResponse {
    summary?: VehicalsSummaryResponse
    raitings?: VehicalsRatingSetResponse
}

export interface VehicalsAverageBillRatingResponse {
    vehicalName?: string | null
    /** @format double */
    averageBill: number
    /** @format double */
    averageBillPersent: number
}

export interface VehicalsOrdersRatingResponse {
    vehicalName?: string | null
    /** @format int32 */
    orderCount: number
    /** @format double */
    orderPersent: number
}

export interface VehicalsRatingSetResponse {
    ordersRaiting?: VehicalsOrdersRatingResponse[] | null
    repairTimeRaiting?: VehicalsRepairTimeRatingResponse[] | null
    workCostRaiting?: VehicalsWorkCostRatingResponse[] | null
    spareCostRaiting?: VehicalsSpareCostRatingResponse[] | null
    averageBillRaiting?: VehicalsAverageBillRatingResponse[] | null
}

export interface VehicalsRepairTimeRatingResponse {
    vehicalName?: string | null
    /** @format double */
    normTimeTotalSum: number
    /** @format double */
    normTimePersent: number
}

export interface VehicalsSpareCostRatingResponse {
    vehicalName?: string | null
    /** @format double */
    spareTotalCostSum: number
    /** @format double */
    spareTotalCostPersent: number
}

export interface VehicalsSummaryResponse {
    /** @format int32 */
    clientTotalCount: number
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    orderWorkCostGrandTotalSum: number
    /** @format double */
    orderWorkCostGrandTotalSumByCash: number
    /** @format double */
    orderWorkCostGrandTotalSumByCashless: number
    /** @format double */
    orderSpareGrandTotalSum: number
    /** @format double */
    orderSpareGrandTotalSumByCash: number
    /** @format double */
    orderSpareGrandTotalSumByCashless: number
    /** @format double */
    averageBill: number
}

export interface VehicalsWorkCostRatingResponse {
    vehicalName?: string | null
    /** @format double */
    workTotalCostSum: number
    /** @format double */
    workTotalCostPersent: number
}

export interface VehicleStationReportResult {
    /**
     * The unique identifier of the car.
     * @format int32
     */
    id: number
    /** A user-friendly name or alias for the car. */
    friendlyName?: string | null
    /**
     * The identifier of the car owner.
     * @format int32
     */
    ownerId: number
    /**
     * The current mileage of the car.
     * @format int32
     */
    mileage?: number | null
    /** The manufacturing year of the car. */
    year?: string | null
    /** The registration number (license plate) of the car. */
    regNo?: string | null
    /** The primary body (chassis) number of the car. */
    bodyNo?: string | null
    /** An alternative body (chassis) number of the car. */
    bodyNo2?: string | null
    /** The manufacturer (make) of the car. */
    manufacturer?: string | null
    /** The model of the car. */
    model?: string | null
    /**
     * The engine capacity in liters.
     * @format float
     */
    engineLitres?: number | null
    fuelType?: FuelTypeEnum
    vehicleType: VehicleTypeEnum
    /** The type of transmission (e.g., manual, automatic). */
    transmission?: string | null
    /** Additional notes or annotations for the car. */
    annotation?: string | null
    /**
     * The identifier for the first repair times database entry.
     * @format int32
     */
    repTimesDb1Id?: number | null
    /** The value/description for the first repair times database entry. */
    repTimesDb1Value?: string | null
    /**
     * The identifier for the second repair times database entry.
     * @format int32
     */
    repTimesDb2Id?: number | null
    /** The value/description for the second repair times database entry. */
    repTimesDb2Value?: string | null
    /** The identifier for the third repair times database entry. */
    repTimesDb3Id?: string | null
    /** The value/description for the third repair times database entry. */
    repTimesDb3Value?: string | null
    /** The identifier for the fourth repair times database entry. */
    repTimesDb4Id?: string | null
    /** The value/description for the fourth repair times database entry. */
    repTimesDb4Value?: string | null
    /** The identifier for the fifth repair times database entry. */
    repTimesDb5Id?: string | null
    /** The value/description for the fifth repair times database entry. */
    repTimesDb5Value?: string | null
    /**
     * The date and time when the car record was created.
     * @format date-time
     */
    createdAt: string
    createdBy?: string | null
    /**
     * The date and time when the car record was last modified.
     * @format date-time
     */
    modifiedAt?: string | null
    modifiedBy?: string | null
}

export interface VehiclesFilterResponse {
    carYears?: string[] | null
    carBrands?: string[] | null
    carModels?: string[] | null
}

export interface WarehouseBankAccountReferenceDto {
    /** @format uuid */
    bankAccountId: string
    bankAccountTitle?: string | null
}

export interface WarehouseBuyerReferenceDto {
    buyerId?: string | null
    buyerName?: string | null
}

export interface WarehouseContractReferenceDto {
    /** @format uuid */
    contractId: string
    contractNo?: string | null
}

export interface WarehouseDocumentReference {
    /** @format uuid */
    documentId: string
    documentNo?: string | null
    documentType?: string | null
}

export interface WarehouseEmployeeReferenceDto {
    id?: string | null
    name?: string | null
}

export interface WarehouseIncomeDocumentReferenceWithInfoDto {
    /** @format uuid */
    documentId: string
    documentType: IncomeDocumentTypeEnum
    /** @format date-time */
    createdAt: string
    documentNo?: string | null
}

export interface WarehouseOrderReferenceDto {
    /** @format int32 */
    orderId: number
    /** @format date-time */
    createdAt: string
    orderActNo?: string | null
    orderOrderNo?: string | null
}

export interface WarehouseOutcomeDocumentReferenceWithInfoDto {
    /** @format uuid */
    documentId: string
    documentType: OutcomeDocumentTypeEnum
    /** @format date-time */
    createdAt: string
    documentNo?: string | null
}

export interface WarehouseStockReferenceDto {
    /** @format uuid */
    stockId: string
    stockTitle?: string | null
}

export interface WarehouseSupplierReferenceDto {
    /** @format uuid */
    supplierId: string
    supplierName?: string | null
    supplierUnp?: string | null
}

/** Response model that represents the configured webhook settings. */
export interface WebHookSettingsResponse {
    /** @format uuid */
    id: string
    /** The source endpoint or system identifier from which the webhook is sent. */
    from: string | null
    /** The destination endpoint or system identifier to which the webhook is delivered. */
    to: string | null
}

export interface WhSettingsResponse {
    /** @format uuid */
    id: string
    warehouseAccountingMethod: WarehouseAccountingMethodTypeEnum
    disallowShippingMissingItems: boolean
    isValidateSalePrice: boolean
    isReserveControlEnabled: boolean
    isCatalogNumberRequired: boolean
    uniqueDocNumberRequired: boolean
    createdBy?: string | null
    /** @format date-time */
    createdAt: string
    modifiedBy?: string | null
    /** @format date-time */
    modifiedAt: string
}

export interface WorkAudatexResponse {
    title?: string | null
    code?: string | null
    /** @format double */
    normTimeTotal: number
    normTimeTotalElement?: string | null
    compositeDescription?: string | null
    additionalDescription?: AdditionalDescriptionElement[] | null
}

export interface WorkIncrease {
    /** @format int32 */
    year: number
    /** @format double */
    percentage: number
}

export interface WorkReportRequest {
    /** @format date-time */
    startDate: string
    /** @format date-time */
    endDate: string
    reportingDate: ReportingDateEnum
    statusIds?: OrderStatusEnum[] | null
    bankAccounts: string[] | null
    vehicleType?: VehicleTypeEnum
    documentOptions?: DocumentKindEnum[] | null
    workRates?: number[] | null
    isPersonal: boolean
    isCompany: boolean
    tagIds?: number[] | null
    sourceIds?: number[] | null
    tagsExclude: boolean
    sourceExclude: boolean
    sortAsc: boolean
    sortCol: WorkReportSortColEnum
}

export interface WorkReportResponse {
    /** @format int32 */
    orderTotalCount: number
    /** @format double */
    wksNormsTotalSum: number
    /** @format double */
    wksCostNoVatSum: number
    /** @format double */
    wksCostVatSum: number
    /** @format double */
    wksCostTotalSum: number
    /** @format double */
    wksDiscountAmountSum: number
    /** @format double */
    wksProfitSum: number
    /** @format double */
    sprCostNoVatSum: number
    /** @format double */
    sprCostVatSum: number
    /** @format double */
    sprCostTotalSum: number
    /** @format double */
    sprDiscountAmountSum: number
    /** @format double */
    sprProfitSum: number
    /** @format double */
    ctrCostNoVatSum: number
    /** @format double */
    ctrCostVatSum: number
    /** @format double */
    ctrCostTotalSum: number
    /** @format double */
    ctrProfitSum: number
    /** @format double */
    ttlCostNoVatSum: number
    /** @format double */
    ttlCostVatSum: number
    /** @format double */
    ttlCostTotalSum: number
    /** @format double */
    ttlDiscountAmountSum: number
    /** @format double */
    ttlProfitSum: number
    orders?: OrderStationReportResponse[] | null
}
